webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	/* Redux */
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reduxThunk = __webpack_require__(207);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _middleware = __webpack_require__(208);
	
	/* Polyfill is necessary to work with IE11 */
	
	__webpack_require__(213);
	
	/* Analytics Handler */
	
	var _servicesEventHandler = __webpack_require__(544);
	
	var EventHandler = _interopRequireWildcard(_servicesEventHandler);
	
	var _servicesFeatureToggleService = __webpack_require__(546);
	
	var _servicesFeatureToggleService2 = _interopRequireDefault(_servicesFeatureToggleService);
	
	/* FeatureToggle Service */
	
	var _dataFeatures = __webpack_require__(548);
	
	/* Reducers */
	
	var _reducersDefault = __webpack_require__(549);
	
	var _reducersDefault2 = _interopRequireDefault(_reducersDefault);
	
	var _reducersNavigation = __webpack_require__(689);
	
	var _reducersNavigation2 = _interopRequireDefault(_reducersNavigation);
	
	var _reducersStats = __webpack_require__(692);
	
	var _reducersStats2 = _interopRequireDefault(_reducersStats);
	
	/* Router */
	
	var _reactRouter = __webpack_require__(693);
	
	var _reactRouterRedux = __webpack_require__(774);
	
	/* Sections */
	
	var _componentsApp = __webpack_require__(779);
	
	var _componentsApp2 = _interopRequireDefault(_componentsApp);
	
	var _componentsStepsLandingPage = __webpack_require__(805);
	
	var _componentsStepsLandingPage2 = _interopRequireDefault(_componentsStepsLandingPage);
	
	var _componentsStepsSendMessage = __webpack_require__(854);
	
	var _componentsStepsSendMessage2 = _interopRequireDefault(_componentsStepsSendMessage);
	
	var _componentsStepsThankYouPage = __webpack_require__(856);
	
	var _componentsStepsThankYouPage2 = _interopRequireDefault(_componentsStepsThankYouPage);
	
	var _componentsStepsContactDetailsPage = __webpack_require__(859);
	
	var _componentsStepsContactDetailsPage2 = _interopRequireDefault(_componentsStepsContactDetailsPage);
	
	var _componentsStepsMatchingMatchPage = __webpack_require__(861);
	
	var _componentsStepsMatchingMatchPage2 = _interopRequireDefault(_componentsStepsMatchingMatchPage);
	
	var _componentsStaticStaticFooter = __webpack_require__(866);
	
	var _componentsStaticStaticFooter2 = _interopRequireDefault(_componentsStaticStaticFooter);
	
	var _componentsPage404 = __webpack_require__(867);
	
	var _componentsPage4042 = _interopRequireDefault(_componentsPage404);
	
	/* Component Wrapper */
	
	var _componentsStepsHOCLoadingWrapper = __webpack_require__(868);
	
	// Load images to be used inside css files
	__webpack_require__(869);
	
	// CSS main import
	__webpack_require__(870);
	// Cross-browser favicon declaration
	__webpack_require__(872);
	// EventHandler start
	EventHandler.activate();
	
	// FeatureToggle Service start
	var featureToggleService = _servicesFeatureToggleService2['default'].instance;
	featureToggleService.initialiseServiceWithFeatures(_dataFeatures.Features);
	
	var reducersCombined = (0, _redux.combineReducers)({
	    reducer: _reducersDefault2['default'],
	    navigation: _reducersNavigation2['default'],
	    stats: _reducersStats2['default'],
	    routing: _reactRouterRedux.routerReducer
	});
	
	var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2['default'], _middleware.logger)(_redux.createStore);
	var store = createStoreWithMiddleware(reducersCombined);
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	history.listen(function (location) {
	    EventHandler.pageView(location.pathname, window.location.href);
	});
	
	_reactDom2['default'].render(_react2['default'].createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2['default'].createElement(
	        _reactRouter.Router,
	        { history: history },
	        _react2['default'].createElement(
	            _reactRouter.Route,
	            { path: '/', component: _componentsApp2['default'] },
	            _react2['default'].createElement(_reactRouter.IndexRoute, { components: _componentsStepsLandingPage2['default'] }),
	            _react2['default'].createElement(_reactRouter.Route, { path: 'contact',
	                component: _componentsStepsContactDetailsPage2['default'] }),
	            _react2['default'].createElement(_reactRouter.Route, { path: 'message',
	                component: (0, _componentsStepsHOCLoadingWrapper.loadComponent)(_componentsStepsSendMessage2['default']) }),
	            _react2['default'].createElement(_reactRouter.Route, { path: 'finish',
	                component: _componentsStepsThankYouPage2['default'] }),
	            _react2['default'].createElement(_reactRouter.Route, { path: 'match', component: _componentsStepsMatchingMatchPage2['default'] }),
	            _react2['default'].createElement(_reactRouter.Route, { path: '*', component: _componentsPage4042['default'] }),
	            _react2['default'].createElement(_reactRouter.Route, { path: '404', component: _componentsPage4042['default'] })
	        )
	    )
	), document.getElementById('app'));
	
	// Render static footer
	_reactDom2['default'].render(_react2['default'].createElement(
	    'div',
	    { className: 'app__static__footer' },
	    _react2['default'].createElement(_componentsStaticStaticFooter2['default'], null)
	), document.getElementById('static'));

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(160);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(174);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(176);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(177);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(178);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(175);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(161);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(171);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(162),
	    getPrototype = __webpack_require__(168),
	    isObjectLike = __webpack_require__(170);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(163),
	    getRawTag = __webpack_require__(166),
	    objectToString = __webpack_require__(167);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(164);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(165);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 165:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(163);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(169);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),

/***/ 169:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 170:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(173);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(172)(module)))

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(160);
	
	var _isPlainObject = __webpack_require__(161);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(175);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (process.env.NODE_ENV !== 'production') {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(178);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(180);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(192);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(147);
	
	var _propTypes = __webpack_require__(181);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(190);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (process.env.NODE_ENV !== 'production') {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(181);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(147);
	
	var _storeShape = __webpack_require__(190);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(193);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(194);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(195);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(205);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(206);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (process.env.NODE_ENV !== 'production') {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (process.env.NODE_ENV !== 'production') {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (process.env.NODE_ENV !== 'production') {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(159);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(196),
	    getPrototype = __webpack_require__(202),
	    isObjectLike = __webpack_require__(204);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(197),
	    getRawTag = __webpack_require__(200),
	    objectToString = __webpack_require__(201);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(198);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(199);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(197);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(203);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(182);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	var FORM_VALIDATION_ACTION_TYPES = [ActionTypes.INVALID_SUBMIT, ActionTypes.VALID_SUBMIT, ActionTypes.INVALIDATE_FORM, ActionTypes.VALIDATE_FORM];
	
	var logger = function logger() {
	    return function (next) {
	        return function (action) {
	            /* eslint no-console: 0 */
	            if (action && !new RegExp(FORM_VALIDATION_ACTION_TYPES.join('|')).test(action.type)) {
	                console.log('dispatching: ', action);
	            }
	
	            return next(action);
	        };
	    };
	};
	exports.logger = logger;

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	var _actionsStatsActionTypes = __webpack_require__(210);
	
	_defaults(exports, _interopExportWildcard(_actionsStatsActionTypes, _defaults));
	
	var _actionsNavigationActionTypes = __webpack_require__(211);
	
	_defaults(exports, _interopExportWildcard(_actionsNavigationActionTypes, _defaults));
	
	var _actionsDefaultActionTypes = __webpack_require__(212);
	
	_defaults(exports, _interopExportWildcard(_actionsDefaultActionTypes, _defaults));

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var UPDATE_STATS = 'UPDATE_STATS';
	
	exports.UPDATE_STATS = UPDATE_STATS;
	var UPDATE_STATS_ERROR = 'UPDATE_STATS_ERROR';
	exports.UPDATE_STATS_ERROR = UPDATE_STATS_ERROR;

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var NAVIGATION_RESET = 'NAVIGATION_RESET';
	
	exports.NAVIGATION_RESET = NAVIGATION_RESET;
	var NAVIGATE = 'NAVIGATE';
	
	exports.NAVIGATE = NAVIGATE;
	var INVALID_SUBMIT = 'INVALID_SUBMIT';
	exports.INVALID_SUBMIT = INVALID_SUBMIT;
	var VALID_SUBMIT = 'VALID_SUBMIT';
	
	exports.VALID_SUBMIT = VALID_SUBMIT;
	var INVALIDATE_FORM = 'INVALIDATE_FORM';
	exports.INVALIDATE_FORM = INVALIDATE_FORM;
	var VALIDATE_FORM = 'VALIDATE_FORM';
	exports.VALIDATE_FORM = VALIDATE_FORM;

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var RESET = 'RESET';
	
	exports.RESET = RESET;
	var START = 'START';
	
	exports.START = START;
	var INITIALISE_URL_QUERY_DATA = 'INITIALISE_URL_QUERY_DATA';
	
	exports.INITIALISE_URL_QUERY_DATA = INITIALISE_URL_QUERY_DATA;
	var UPDATE_PERSON_ATTRIBUTE = 'UPDATE_PERSON_ATTRIBUTE';
	
	exports.UPDATE_PERSON_ATTRIBUTE = UPDATE_PERSON_ATTRIBUTE;
	var CREATE_MESSAGE = 'CREATE_MESSAGE';
	
	exports.CREATE_MESSAGE = CREATE_MESSAGE;
	var SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
	exports.SUBMIT_SUCCESS = SUBMIT_SUCCESS;
	var SUBMIT_ERROR = 'SUBMIT_ERROR';
	
	exports.SUBMIT_ERROR = SUBMIT_ERROR;
	var SUBMIT_NEWSLETTER_SUCCESS = 'SUBMIT_NEWSLETTER_SUCCESS';
	exports.SUBMIT_NEWSLETTER_SUCCESS = SUBMIT_NEWSLETTER_SUCCESS;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-undef: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.activate = activate;
	exports.track = track;
	exports.pageView = pageView;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _immutable = __webpack_require__(545);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var API_KEYS = window.vfEnvironmentConfig;
	
	var GoogleAnalytics = (function () {
	    function GoogleAnalytics(key) {
	        _classCallCheck(this, GoogleAnalytics);
	
	        this.key = key;
	    }
	
	    _createClass(GoogleAnalytics, [{
	        key: 'activate',
	        value: function activate() {
	            /*eslint-disable */
	
	            (function (i, s, o, g, r, a, m) {
	                i['GoogleAnalyticsObject'] = r;
	
	                if (!i[r]) {
	                    i[r] = function () {
	                        (i[r].q = i[r].q || []).push(arguments);
	                    };
	
	                    i[r].l = 1 * new Date();
	                }
	
	                a = s.createElement(o);
	                a.setAttribute('type', 'text/plain');
	                a.setAttribute('data-cookiescript', 'accepted');
	                m = s.getElementsByTagName(o)[0];
	                a.async = 1;
	                a.src = g;
	                m.parentNode.insertBefore(a, m);
	            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	
	            window.ga('create', this.key, 'auto');
	            window.ga('send', 'pageview');
	            /*eslint-enable */
	        }
	    }, {
	        key: 'track',
	        value: function track(action, opts) {
	            window.ga('send', 'event', opts.category, action, opts.label, opts.value);
	        }
	    }, {
	        key: 'pageView',
	        value: function pageView(location) {
	            window.ga('send', 'pageview', location);
	        }
	    }]);
	
	    return GoogleAnalytics;
	})();
	
	var GTM = (function () {
	    function GTM(key) {
	        _classCallCheck(this, GTM);
	
	        this.key = key;
	    }
	
	    _createClass(GTM, [{
	        key: 'track',
	        value: function track(action, opts) {
	            window.dataLayer.push({
	                category: opts.category,
	                event: action,
	                label: opts.label,
	                value: opts.value
	            });
	        }
	    }, {
	        key: 'pageView',
	        value: function pageView(location) {
	            window.dataLayer.push({
	                event: 'Loaded a Page',
	                path: location,
	                url: window.location.href,
	                title: document.title,
	                referrer: document.referrer
	            });
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            window.dataLayer = window.dataLayer || [];
	
	            window.dataLayer.push({
	                'gtm.start': new Date().getTime(),
	                event: 'gtm.js'
	            });
	
	            var script = document.createElement('script');
	            script.type = 'text/javascript';
	            script.async = true;
	            script.src = '//www.googletagmanager.com/gtm.js?id=' + this.key + '&l=dataLayer';
	            var first = document.getElementsByTagName('script')[0];
	            first.parentNode.insertBefore(script, first);
	        }
	    }]);
	
	    return GTM;
	})();
	
	var integrations = _immutable2['default'].List([new GoogleAnalytics(API_KEYS.GOOGLE_ANALYTICS_KEY), new GTM(API_KEYS.GOOGLE_TAG_MANAGER)]);
	
	function activate() {
	    integrations.forEach(function (integration) {
	        return integration.activate();
	    });
	}
	
	function track(action, opts) {
	    integrations.forEach(function (integration) {
	        return integration.track(action, opts);
	    });
	}
	
	function pageView(pathname, url) {
	    integrations.forEach(function (integration) {
	        return integration.pageView(pathname, url);
	    });
	}
	
	/** google's code **/

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _SessionStorageHandler = __webpack_require__(547);
	
	var _SessionStorageHandler2 = _interopRequireDefault(_SessionStorageHandler);
	
	var _dataFeatures = __webpack_require__(548);
	
	var singleton = Symbol();
	var singletonEnforcer = Symbol();
	
	/* eslint eqeqeq: 0 */
	
	var FeatureToggleService = (function () {
	    function FeatureToggleService(enforcer) {
	        _classCallCheck(this, FeatureToggleService);
	
	        if (enforcer !== singletonEnforcer) {
	            throw new Error('Cannot construct FeatureToggleService');
	        }
	    }
	
	    _createClass(FeatureToggleService, [{
	        key: 'initialiseServiceWithFeatures',
	        value: function initialiseServiceWithFeatures(features) {
	            this.isBrowserCapable = _SessionStorageHandler2['default'].isCapable();
	
	            if (features) {
	                this.features = features;
	            } else {
	                this.features = _dataFeatures.Features;
	            }
	        }
	    }, {
	        key: 'chooseValueForFeature',
	        value: function chooseValueForFeature(name) {
	            var feature = this.features.get(name);
	            if (!feature) {
	                return null;
	            }
	
	            var values = feature.get('values');
	            if (!values || !Array.isArray(values) || !values.length) {
	                return null;
	            }
	
	            var randomIndex = Math.floor(Math.random() * values.length);
	            return values[randomIndex];
	        }
	    }, {
	        key: 'getFeatureValue',
	        value: function getFeatureValue(name) {
	            if (!this.features || !this.features.get(name)) {
	                return null;
	            }
	
	            if (!this.isBrowserCapable) {
	                return this.features.get(name).get('defaultValue') != null ? this.features.get(name).get('defaultValue') : null;
	            }
	
	            var value = _SessionStorageHandler2['default'].getItem(name);
	            if (value == null) {
	                var newValue = this.chooseValueForFeature(name);
	                _SessionStorageHandler2['default'].setItem(name, JSON.stringify(newValue));
	                return JSON.stringify(newValue);
	            }
	
	            return value;
	        }
	    }], [{
	        key: 'instance',
	        get: function get() {
	            if (!this[singleton]) {
	                this[singleton] = new FeatureToggleService(singletonEnforcer);
	            }
	            return this[singleton];
	        }
	    }]);
	
	    return FeatureToggleService;
	})();
	
	exports['default'] = FeatureToggleService;
	module.exports = exports['default'];

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	/* eslint no-console: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var SessionStorageHandler = (function () {
	    function SessionStorageHandler() {
	        _classCallCheck(this, SessionStorageHandler);
	    }
	
	    _createClass(SessionStorageHandler, null, [{
	        key: 'isCapable',
	        value: function isCapable() {
	            try {
	                window.sessionStorage.setItem('capability', true);
	                window.sessionStorage.getItem('capability');
	                window.sessionStorage.removeItem('capability');
	            } catch (e) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'setItem',
	        value: function setItem(key, value) {
	            try {
	                window.sessionStorage.setItem(key, value);
	            } catch (e) {
	                console.warn('Browser not capable of sessionStorage');
	            }
	        }
	    }, {
	        key: 'getItem',
	        value: function getItem(key) {
	            try {
	                return window.sessionStorage.getItem(key);
	            } catch (e) {
	                console.warn('Browser not capable of sessionStorage');
	            }
	
	            return null;
	        }
	    }]);
	
	    return SessionStorageHandler;
	})();
	
	exports['default'] = SessionStorageHandler;
	module.exports = exports['default'];

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _immutable = __webpack_require__(545);
	
	var Features = (0, _immutable.Map)({
	    'default': (0, _immutable.Map)({
	        values: [true, false],
	        defaultValue: true
	    }),
	    addMoreServices: (0, _immutable.Map)({
	        values: [{
	            name: 'Control one service',
	            value: false
	        }, {
	            name: 'Experiment multiple services',
	            value: true
	        }],
	        defaultValue: {
	            name: 'Control one service',
	            value: false
	        }
	    })
	});
	exports.Features = Features;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _immutable = __webpack_require__(545);
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	var _modelPerson = __webpack_require__(550);
	
	var _modelPerson2 = _interopRequireDefault(_modelPerson);
	
	var _constantsAdviceArea = __webpack_require__(686);
	
	var _constantsDefaultServices = __webpack_require__(687);
	
	var _contentHeadlineContent = __webpack_require__(688);
	
	var initialState = (0, _immutable.Map)({
	    loading: false,
	    error: false,
	    errorMessage: '',
	
	    submitted: false,
	
	    person: new _modelPerson2['default']()
	});
	
	var reducer = function reducer(state, action) {
	    if (state === undefined) state = initialState;
	
	    if (action.type === ActionTypes.RESET) {
	        return initialState.merge((0, _immutable.Map)({
	            loading: false,
	            error: false,
	            errorMessage: '',
	
	            submitted: false,
	
	            person: new _modelPerson2['default']()
	        }));
	    }
	
	    if (action.type === ActionTypes.UPDATE_PERSON_ATTRIBUTE) {
	        var newData = state.get('person').set(action.attributeName, action.value);
	        var newState = (0, _immutable.Map)({
	            person: new _modelPerson2['default'](newData)
	        });
	
	        return state.merge(newState);
	    }
	
	    if (action.type === ActionTypes.START) {
	        var newState = (0, _immutable.Map)({
	            started: true
	        });
	
	        return state.merge(newState);
	    }
	
	    if (action.type === ActionTypes.INITIALISE_URL_QUERY_DATA) {
	        if (!action.query) {
	            return state;
	        }
	
	        var adviceArea = _contentHeadlineContent.HeadlineAdviserTypes[action.query.vf_adviser_type] ? _contentHeadlineContent.HeadlineAdviserTypes[action.query.vf_adviser_type].value : null;
	
	        var person = state.get('person');
	        if (adviceArea) {
	            var newData = person.set('adviceArea', adviceArea);
	            person = new _modelPerson2['default'](newData);
	        }
	
	        var newState = (0, _immutable.Map)({
	            adviserType: action.query.vf_adviser_type,
	            consumerLocation: action.query.vf_consumer_location,
	            person: person
	        });
	
	        return state.merge(newState);
	    }
	
	    if (action.type === ActionTypes.CREATE_MESSAGE) {
	        var person = state.get('person');
	
	        var otherAdviceAreas = '';
	        if (person.get('otherAdviceAreas')) {
	            var delimiter = ',';
	            for (var i = 0; i < person.get('otherAdviceAreas').length; i++) {
	                var otherAdviceArea = person.get('otherAdviceAreas')[i];
	                if (!_constantsAdviceArea.AdviceArea[otherAdviceArea]) {
	                    continue;
	                }
	
	                if (i === person.get('otherAdviceAreas').length - 1) {
	                    delimiter = ' and';
	                }
	
	                otherAdviceAreas += delimiter + ' ' + _constantsAdviceArea.AdviceArea[otherAdviceArea];
	            }
	        }
	
	        var message = 'Hello, \n\n' + ('I am looking for help with ' + _constantsDefaultServices.DefaultServices.get(person.get('needKey')).get('name') + '. \n\n');
	
	        if (person.get('adviceArea') === 392) {
	            message += 'The value of the property I\'m looking to ';
	            message += '' + (person.get('needKey') === 'remortgaging' ? 'remortgage ' : 'buy ');
	            message += 'is ' + person.get('mortgageValue') + '. \n\n';
	            message += 'I am looking to do this in ' + person.get('adviceTime') + '. \n\n';
	            message += 'I have an annual income of ' + person.get('annualIncome') + ' ';
	            message += 'and a deposit of ' + person.get('deposit') + '. \n\n';
	        } else {
	            message += 'I have ' + person.get('wealthLevel') + ' in savings, investments & pensions. \n\n';
	        }
	
	        message += 'I am also keen to understand the costs associated with this advice.';
	
	        var newData = person.set('message', message);
	
	        return state.merge({ person: new _modelPerson2['default'](newData) });
	    }
	
	    if (action.type === ActionTypes.SUBMIT_SUCCESS) {
	        var newState = (0, _immutable.Map)({
	            submitted: true,
	            error: false,
	            errorMessage: ''
	        });
	
	        return state.merge(newState);
	    }
	
	    if (action.type === ActionTypes.SUBMIT_ERROR) {
	        var newState = (0, _immutable.Map)({
	            submitted: false,
	            error: true,
	            errorMessage: 'An error occurred while sending your data. Please try again in a few seconds.'
	        });
	
	        return state.merge(newState);
	    }
	
	    if (action.type === ActionTypes.SUBMIT_NEWSLETTER_SUCCESS) {
	        var newState = (0, _immutable.Map)({
	            newsletterEmailSent: true
	        });
	
	        return state.merge(newState);
	    }
	
	    return state;
	};
	
	exports['default'] = reducer;
	module.exports = exports['default'];

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _immutable = __webpack_require__(545);
	
	var _moment = __webpack_require__(551);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpersStringFormatHelper = __webpack_require__(685);
	
	var _helpersStringFormatHelper2 = _interopRequireDefault(_helpersStringFormatHelper);
	
	var DEFAULT_DATE_FORMAT = 'YYYY-MM-DD\THH:mm:ss\Z';
	var DEFAULT_DATE_MASK = 'DD/MM/YYYY';
	
	var Person = (function () {
	    function Person(data) {
	        _classCallCheck(this, Person);
	
	        if (!data) {
	            this.data = (0, _immutable.Map)({
	                numberOfQuotes: '3',
	                telephonyAdvice: true,
	                dbPension: false
	            });
	        } else {
	            this.data = data;
	        }
	    }
	
	    _createClass(Person, [{
	        key: 'get',
	        value: function get(attributeName) {
	            return this.data.get(attributeName);
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(attributeName) {
	            this.data = this.data['delete'](attributeName);
	        }
	    }, {
	        key: 'setMutable',
	        value: function setMutable(attributeName, value) {
	            this.data = this.data.set(attributeName, value);
	        }
	    }, {
	        key: 'set',
	        value: function set(attributeName, value) {
	            return this.data.set(attributeName, value);
	        }
	    }, {
	        key: 'getFullName',
	        value: function getFullName() {
	            return this.data.get('firstName') + ' ' + this.data.get('lastName');
	        }
	    }, {
	        key: 'getDateOfBirth',
	        value: function getDateOfBirth() {
	            if (!this.data.get('dateOfBirth')) {
	                return '';
	            }
	
	            return (0, _moment2['default'])(this.data.get('dateOfBirth')).format(DEFAULT_DATE_MASK);
	        }
	    }, {
	        key: 'setDateOfBirth',
	        value: function setDateOfBirth(dateOfBirth) {
	            if (!dateOfBirth || !dateOfBirth.trim()) {
	                this.data = this.data.set('dateOfBirth', '');
	                return;
	            }
	
	            if (/\d\d\/\d\d\/\d\d$/.test(dateOfBirth.trim())) {
	                var _dateOfBirth$split = dateOfBirth.split('/');
	
	                var _dateOfBirth$split2 = _slicedToArray(_dateOfBirth$split, 3);
	
	                var day = _dateOfBirth$split2[0];
	                var month = _dateOfBirth$split2[1];
	                var year = _dateOfBirth$split2[2];
	
	                var twoDigitCurrentYear = (0, _moment2['default'])().year() - 2000;
	                var fourDigitYear = (0, _moment2['default'])().year();
	
	                if (year < twoDigitCurrentYear) {
	                    fourDigitYear = 2000 + parseInt(year);
	                } else {
	                    fourDigitYear = 1900 + parseInt(year);
	                }
	
	                this.data = this.data.set('dateOfBirth', (0, _moment2['default'])(day + '/' + month + '/' + fourDigitYear, DEFAULT_DATE_MASK).format(DEFAULT_DATE_FORMAT));
	            } else if ((0, _moment2['default'])(dateOfBirth, DEFAULT_DATE_MASK).isValid()) {
	                this.data = this.data.set('dateOfBirth', (0, _moment2['default'])(dateOfBirth, DEFAULT_DATE_MASK).format(DEFAULT_DATE_FORMAT));
	            } else {
	                this.data = this.data.set('dateOfBirth', (0, _moment2['default'])().format(DEFAULT_DATE_FORMAT));
	            }
	        }
	    }, {
	        key: 'getDataAsJSON',
	        value: function getDataAsJSON() {
	            var requestData = {
	                advice_area: !isNaN(parseInt(this.data.get('adviceArea'))) ? parseInt(this.data.get('adviceArea')) : 393,
	                number_of_quotes: !isNaN(parseInt(this.data.get('numberOfQuotes'))) ? parseInt(this.data.get('numberOfQuotes')) : 3,
	                message: this.data.get('message'),
	                vertical: 5,
	                source: 'discover-mortgage',
	                customer: {
	                    name: this.data.get('fullName'),
	                    email: this.data.get('email'),
	                    phone: this.data.get('phone'),
	                    postcode: this.data.get('postcode')
	                },
	                isLocationImportant: this.data.get('isLocationImportant')
	            };
	
	            if (this.data.get('adviceArea') !== 392) {
	                requestData.wealth_level = _helpersStringFormatHelper2['default'].formatToNumber(this.data.get('wealthLevel'));
	                requestData.telephony_advice = this.data.get('telephonyAdvice');
	            } else {
	                var depositValue = _helpersStringFormatHelper2['default'].formatToNumber(this.data.get('deposit'));
	                var mortgageValue = _helpersStringFormatHelper2['default'].formatToNumber(this.data.get('mortgageValue'));
	                requestData.mortgage_value = mortgageValue - depositValue;
	                requestData.annual_income = _helpersStringFormatHelper2['default'].formatToNumber(this.data.get('annualIncome'));
	                requestData.deposit = depositValue;
	                requestData.advice_time = this.data.get('adviceTime');
	            }
	
	            return requestData;
	        }
	    }, {
	        key: 'getDataAsSearchParams',
	        value: function getDataAsSearchParams() {
	            var params = {};
	            if (this.data.get('adviceArea')) {
	                params.attribute_ids = this.data.get('adviceArea');
	            }
	
	            if (this.data.get('postcode')) {
	                params.location = this.data.get('postcode');
	            }
	
	            if (this.data.get('wealthLevel')) {
	                params.wealth_level_ids = Person.getWealthLevelIds(this.data.get('wealthLevel'));
	            }
	
	            if (this.data.get('mortgageValue')) {
	                params.mortgage_level_ids = Person.getMortgageValueIds(this.data.get('mortgageValue'));
	            }
	
	            return params;
	        }
	    }], [{
	        key: 'build',
	        value: function build(data) {
	            return new Person(data);
	        }
	    }, {
	        key: 'getWealthLevelIds',
	        value: function getWealthLevelIds(value) {
	            var integerValue = _helpersStringFormatHelper2['default'].formatToNumber(value);
	
	            if (!integerValue || isNaN(integerValue)) {
	                return '';
	            }
	
	            if (integerValue < 50000) {
	                return '402';
	            }
	
	            if (integerValue < 100000) {
	                return '402,403';
	            }
	
	            if (integerValue < 250000) {
	                return '402,403,404';
	            }
	
	            if (integerValue < 500000) {
	                return '402,403,404,405';
	            }
	
	            return '402,403,404,405,406';
	        }
	    }, {
	        key: 'getMortgageValueIds',
	        value: function getMortgageValueIds(value) {
	            var integerValue = _helpersStringFormatHelper2['default'].formatToNumber(value);
	
	            if (!integerValue || isNaN(integerValue)) {
	                return '';
	            }
	
	            if (integerValue < 50000) {
	                return '408';
	            }
	
	            if (integerValue < 100000) {
	                return '408,587';
	            }
	
	            if (integerValue < 250000) {
	                return '408,587,409';
	            }
	
	            if (integerValue < 500000) {
	                return '408,587,409,410';
	            }
	
	            if (integerValue < 1000000) {
	                return '408,587,409,410,411';
	            }
	
	            return '408,587,409,410,411,412';
	        }
	    }]);
	
	    return Person;
	})();
	
	exports['default'] = Person;
	module.exports = exports['default'];

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var currencyFormat = ['en-GB', { style: 'currency', currency: 'GBP' }];
	
	/* eslint eqeqeq: 0 */
	
	var StringFormatHelper = (function () {
	    function StringFormatHelper() {
	        _classCallCheck(this, StringFormatHelper);
	    }
	
	    _createClass(StringFormatHelper, null, [{
	        key: 'formatToCurrency',
	        value: function formatToCurrency(number) {
	            var _Number;
	
	            if (number == null || number === '' || isNaN(parseInt(number))) {
	                return '';
	            }
	
	            var replacement = /\.\d{2}$/;
	            var formattedNumber = (_Number = Number(Math.round(number))).toLocaleString.apply(_Number, currencyFormat);
	
	            if (formattedNumber && formattedNumber.indexOf('£') < 0) {
	                formattedNumber = '£' + Number(Math.round(number)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	            }
	
	            return formattedNumber.replace(replacement, '');
	        }
	    }, {
	        key: 'formatToNumber',
	        value: function formatToNumber(currency) {
	            var currencyToNumber = currency.toString().replace(/£/g, '').replace(/\,/g, '');
	            currencyToNumber = isNaN(parseInt(currencyToNumber)) ? '' : parseInt(currencyToNumber);
	            return currencyToNumber;
	        }
	    }]);
	
	    return StringFormatHelper;
	})();
	
	exports['default'] = StringFormatHelper;
	module.exports = exports['default'];

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var AdviceArea = {
	    391: 'Insurance & Protection',
	    396: 'Auto Enrolment',
	    397: 'Investments & Savings',
	    392: 'Mortgages',
	    393: 'Pension & Retirement',
	    557: 'Pension & Retirement',
	    394: 'Equity Release',
	    558: 'Inheritance Planning',
	    395: 'Annuities'
	};
	
	exports.AdviceArea = AdviceArea;
	var AdviceAreaStats = {
	    391: 968,
	    396: 448,
	    397: 1012,
	    393: 929,
	    557: 480,
	    394: 312,
	    558: 780,
	    395: 810
	};
	exports.AdviceAreaStats = AdviceAreaStats;

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _immutable = __webpack_require__(545);
	
	var DefaultServices = (0, _immutable.Map)({
	    'first-property': (0, _immutable.Map)({
	        id: 392,
	        name: 'Buying my first property',
	        label: 'Finding the best mortgage advice',
	        title: 'Find the best adviser to help <span class="line">with your mortgage</span>',
	        description: 'to help with mortgage advice'
	    }),
	    remortgaging: (0, _immutable.Map)({
	        id: 392,
	        name: 'Remortgaging',
	        label: 'Finding the best mortgage advice',
	        title: 'Find the best adviser to help <span class="line">with your mortgage</span>',
	        description: 'to help with mortgage advice'
	    }),
	    'additional-property': (0, _immutable.Map)({
	        id: 392,
	        name: 'Buying a new property',
	        label: 'Finding the best mortgage advice',
	        title: 'Find the best adviser to help <span class="line">with your mortgage</span>',
	        description: 'to help with mortgage advice'
	    })
	});
	exports.DefaultServices = DefaultServices;

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var DEFAULT_HEADLINE_CONTENT = {
	    headline: {
	        firstLine: 'The best way to find a',
	        secondLine: 'Mortgage Adviser',
	        mobile: {
	            firstLine: 'The best way to find a',
	            secondLine: 'Mortgage Adviser'
	        }
	    }
	};
	
	exports.DEFAULT_HEADLINE_CONTENT = DEFAULT_HEADLINE_CONTENT;
	/* eslint quote-props: 0 */
	var HeadlineAdviserTypes = {
	    'independent financial adviser': { text: 'Independent Financial Adviser' },
	    'independent financial advisers': { text: 'Independent Financial Advisers' },
	    'independent financial advisor': { text: 'Independent Financial Advisor' },
	    'independent financial advisors': { text: 'Independent Financial Advisors' },
	
	    'financial adviser': { text: 'Financial Adviser' },
	    'financial advisers': { text: 'Financial Advisers' },
	    'financial advisor': { text: 'Financial Advisor' },
	    'financial advisors': { text: 'Financial Advisors' },
	    'financial planner': { text: 'Financial Planner' },
	    'financial planners': { text: 'Financial Planners' },
	
	    'mortgage adviser': { text: 'Mortgage Adviser' },
	    'mortgage advisers': { text: 'Mortgage Advisers' },
	    'mortgage advisor': { text: 'Mortgage Advisor' },
	    'mortgage advisors': { text: 'Mortgage Advisor' },
	    'mortgage broker': { text: 'Mortgage Broker' },
	    'mortgage brokers': { text: 'Mortgage Brokers' },
	    'mortgage advice': { text: 'Mortgage Advice' },
	    'independent mortgage advice': { text: 'Independent Mortgage Advice' },
	    'independent mortgage adviser': { text: 'Independent Mortgage Adviser' },
	    'independent mortgage advisers': { text: 'Independent Mortgage Advisers' },
	    'independent mortgage advisor': { text: 'Independent Mortgage Advisor' },
	    'independent mortgage advisors': { text: 'Independent Mortgage Advisor' },
	    'independent mortgage broker': { text: 'Independent Mortgage Broker' },
	    'independent mortgage brokers': { text: 'Independent Mortgage Brokers' },
	
	    'investment adviser': { text: 'Investment Adviser' },
	    'investment advisers': { text: 'Investment Advisers' },
	    'investment advisor': { text: 'Investment Advisor' },
	    'investment advisors': { text: 'Investment Advisors' },
	    'investment planner': { text: 'Investment Planner' },
	    'investment planners': { text: 'Investment Planners' },
	    'independent investment planner': { text: 'Independent Investment Planner' },
	    'independent investment planners': { text: 'Independent Investment Planners' },
	    'financial advice': { text: 'Financial Advisers' },
	    'investment advice': { text: 'Investment Advisers' },
	    'retirement advice': { text: 'Retirement Advisers' },
	    'ifa': { text: 'IFAs' },
	    'ifas': { text: 'IFAs' },
	    'annuity advisers': { text: 'Annuity Advisers' },
	    'annuity advisors': { text: 'Annuity Advisors' },
	    'annuity planners': { text: 'Annuity Planners' },
	    'finance advisers': { text: 'Finance Advisers' },
	    'finance planners': { text: 'Finance Planners' },
	
	    'pension adviser': {
	        text: 'Pension Adviser',
	        value: 393
	    },
	    'pension advisers': {
	        text: 'Pension Advisers',
	        value: 393
	    },
	    'pension advisor': {
	        text: 'Pension Advisor',
	        value: 393
	    },
	    'pension advisors': {
	        text: 'Pension Advisors',
	        value: 393
	    },
	    'pension planner': {
	        text: 'Pension Planner',
	        value: 393
	    },
	    'pension planners': {
	        text: 'Pension Planners',
	        value: 393
	    },
	    'inheritance tax adviser': {
	        text: 'Inheritance Tax Adviser',
	        value: 558
	    },
	    'inheritance tax advisers': {
	        text: 'Inheritance Tax Advisers',
	        value: 558
	    },
	    'inheritance tax advisor': {
	        text: 'Inheritance Tax Advisor',
	        value: 558
	    },
	    'inheritance tax advisors': {
	        text: 'Inheritance Tax Advisors',
	        value: 558
	    },
	    'retirement advisers': {
	        text: 'Retirement Advisers',
	        value: 393
	    },
	    'retirement advisors': {
	        text: 'Retirement Advisors',
	        value: 393
	    },
	    'retirement planners': {
	        text: 'Retirement Planners',
	        value: 393
	    }
	};
	
	exports.HeadlineAdviserTypes = HeadlineAdviserTypes;
	var capitaliseString = function capitaliseString(value, all) {
	    if (all) {
	        return value.split(' ').map(function (e) {
	            return capitaliseString(e);
	        }).join(' ');
	    }
	    return value.charAt(0).toUpperCase() + value.slice(1);
	};
	
	var getHeadlineContentFromQuery = function getHeadlineContentFromQuery(adviserType, consumerLocation) {
	    var content = DEFAULT_HEADLINE_CONTENT;
	
	    if (!adviserType && !consumerLocation) {
	        return content;
	    }
	
	    if (adviserType && HeadlineAdviserTypes[adviserType.toLowerCase()]) {
	        content.headline.firstLine = 'Find the best ' + HeadlineAdviserTypes[adviserType.toLowerCase()].text;
	        content.headline.mobile.firstLine = 'Find the best ' + HeadlineAdviserTypes[adviserType.toLowerCase()].text;
	
	        if (consumerLocation) {
	            content.headline.firstLine += ' in ' + capitaliseString(consumerLocation, true);
	            content.headline.mobile.firstLine += ' in ' + capitaliseString(consumerLocation, true);
	        }
	    } else if (consumerLocation) {
	        content.headline.firstLine = 'Find the best ' + HeadlineAdviserTypes['independent financial advisers'].text + ' in ' + ('' + capitaliseString(consumerLocation));
	        content.headline.mobile.firstLine = 'Find the best ' + HeadlineAdviserTypes['independent financial advisers'].text + ' in ' + ('' + capitaliseString(consumerLocation));
	    }
	
	    content.headline.secondLine = '';
	    content.headline.mobile.secondLine = '';
	
	    return content;
	};
	exports.getHeadlineContentFromQuery = getHeadlineContentFromQuery;

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _immutable = __webpack_require__(545);
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	var _contentStepContent = __webpack_require__(690);
	
	var _constantsSteps = __webpack_require__(691);
	
	var initialState = (0, _immutable.Map)({
	    title: _contentStepContent.DEFAULT_TITLE,
	    stepIndex: null,
	
	    canSubmit: false,
	    invalidSubmit: false,
	
	    experiment: false
	});
	
	var reducerNavigation = function reducerNavigation(state, action) {
	    if (state === undefined) state = initialState;
	
	    if (action.type === ActionTypes.NAVIGATION_RESET) {
	        if (action.query && action.query.vf_experiment) {
	            return state.merge((0, _immutable.Map)({ experiment: true }));
	        }
	        return initialState;
	    }
	
	    if (action.type === ActionTypes.NAVIGATE) {
	        var experiment = false;
	        if (action.search && action.search.vf_experiment) {
	            experiment = true;
	        }
	
	        if (action.url && action.url.length) {
	            var stepIndex = _constantsSteps.NavigationMap[action.url];
	
	            return state.merge((0, _immutable.Map)({
	                title: _contentStepContent.PageTitles[stepIndex],
	                stepIndex: stepIndex,
	                invalidSubmit: false,
	                experiment: experiment
	            }));
	        }
	
	        return state.merge(initialState);
	    }
	
	    if (action.type === ActionTypes.INVALIDATE_FORM) {
	        return state.merge((0, _immutable.Map)({
	            canSubmit: false
	        }));
	    }
	
	    if (action.type === ActionTypes.VALIDATE_FORM) {
	        return state.merge((0, _immutable.Map)({
	            canSubmit: true,
	            invalidSubmit: false
	        }));
	    }
	
	    if (action.type === ActionTypes.INVALID_SUBMIT) {
	        return state.merge((0, _immutable.Map)({
	            invalidSubmit: true
	        }));
	    }
	
	    if (action.type === ActionTypes.VALID_SUBMIT) {
	        return state.merge((0, _immutable.Map)({
	            invalidSubmit: false
	        }));
	    }
	
	    return state;
	};
	
	exports['default'] = reducerNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var PageInstructions = [{
	    title: 'Great news! We have advisers who can help with that',
	    subtitle: 'Simply fill in the form below to have a free, no obligation conversation with a top rated ' + 'adviser near you; we will find the best highly rated local advisers for your situation.'
	}, {
	    title: 'Thanks! Your request is almost complete',
	    subtitle: 'It\'s important you <span class="bold">edit</span> and <span class="bold">add' + ' info</span> to your message below (the more detail the better e.g. specific needs and the best time ' + 'to contact you). ' + 'Then click \'Send\' and we will send it to the best mortgage adviser for your situation.'
	}, {}];
	
	exports.PageInstructions = PageInstructions;
	var PageTitles = ['', '', ''];
	
	exports.PageTitles = PageTitles;
	var DEFAULT_TITLE = '';
	exports.DEFAULT_TITLE = DEFAULT_TITLE;

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var StepOrder = {
	    CONTACT: 0,
	    SEND_MESSAGE: 1,
	    FINISH: 2
	};
	
	var NavigationMap = {
	    contact: StepOrder.CONTACT,
	    message: StepOrder.SEND_MESSAGE,
	    finish: StepOrder.FINISH
	};
	
	var BarLabelMap = [];
	BarLabelMap[StepOrder.CONTACT] = 'Details';
	BarLabelMap[StepOrder.SEND_MESSAGE] = 'Submit';
	
	exports.StepOrder = StepOrder;
	exports.NavigationMap = NavigationMap;
	exports.BarLabelMap = BarLabelMap;

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _immutable = __webpack_require__(545);
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	var initialState = (0, _immutable.Map)({
	    total: 1,
	    averageScore: 4.4,
	    reviewsCount: 21,
	
	    error: false,
	    errorMessage: ''
	});
	
	var reducerNavigation = function reducerNavigation(state, action) {
	    if (state === undefined) state = initialState;
	
	    if (action.type === ActionTypes.UPDATE_STATS) {
	        var newState = (0, _immutable.Map)({
	            total: action.stats.total,
	            reviewsCount: action.stats.reviewsCount,
	            averageScore: action.stats.averageScore.toFixed(1),
	            error: false
	        });
	
	        return state.merge(newState);
	    }
	
	    if (action.type === ActionTypes.UPDATE_STATS_ERROR) {
	        var errorState = initialState.merge((0, _immutable.Map)({
	            error: true,
	            errorMessage: action.error
	        }));
	
	        return state.merge(errorState);
	    }
	
	    return state;
	};
	
	exports['default'] = reducerNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _formsyReact = __webpack_require__(780);
	
	var _formsyReact2 = _interopRequireDefault(_formsyReact);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _servicesWindowEventsHandler = __webpack_require__(795);
	
	var _servicesWindowEventsHandler2 = _interopRequireDefault(_servicesWindowEventsHandler);
	
	/* eslint no-unused-vars: 0 */
	
	var _Header = __webpack_require__(796);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _NavigationControl = __webpack_require__(801);
	
	var _NavigationControl2 = _interopRequireDefault(_NavigationControl);
	
	var _PageInstruction = __webpack_require__(802);
	
	var _PageInstruction2 = _interopRequireDefault(_PageInstruction);
	
	var _PageError = __webpack_require__(804);
	
	var _PageError2 = _interopRequireDefault(_PageError);
	
	var App = (function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        _get(Object.getPrototypeOf(App.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(App, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.location.pathname !== nextProps.location.pathname && this.props.location.pathname.indexOf('match/1') === -1 && this.props.location.pathname.indexOf('match/2') === -1) {
	                /* Always scroll to top when route changes */
	                _servicesWindowEventsHandler2['default'].scrollToTop();
	                /* Adjust step navigation details when route changes */
	                this.props.actions.navigate(nextProps.location.pathname);
	            }
	        }
	    }, {
	        key: 'validateForm',
	        value: function validateForm() {
	            this.props.actions.validateForm();
	        }
	    }, {
	        key: 'invalidateForm',
	        value: function invalidateForm() {
	            this.props.actions.invalidateForm();
	        }
	    }, {
	        key: 'invalidSubmit',
	        value: function invalidSubmit() {
	            this.props.actions.invalidSubmit();
	        }
	    }, {
	        key: 'validSubmit',
	        value: function validSubmit() {
	            this.props.actions.validSubmit();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isHomePage = !this.props.location.pathname.split('/')[0];
	            var isMatchPage = this.props.location.pathname === 'match';
	            var classSuffix = isHomePage || isMatchPage ? '--full' : '';
	
	            var adviceArea = null;
	            if (this.props.person && this.props.person.get('adviceArea')) {
	                adviceArea = this.props.person.get('adviceArea');
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_Header2['default'], { url: this.props.location.pathname }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__main-section__container' },
	                    _react2['default'].createElement(
	                        'section',
	                        { className: 'app__main-section' + classSuffix },
	                        !isHomePage ? _react2['default'].createElement(_PageInstruction2['default'], { stepIndex: this.props.stepIndex, adviceArea: adviceArea }) : null,
	                        !isHomePage ? _react2['default'].createElement(_PageError2['default'], null) : null,
	                        _react2['default'].createElement(
	                            _formsyReact2['default'].Form,
	                            { ref: 'form',
	                                onValid: this.validateForm.bind(this),
	                                onInvalid: this.invalidateForm.bind(this),
	                                onInvalidSubmit: this.invalidSubmit.bind(this),
	                                onValidSubmit: this.validSubmit.bind(this),
	                                className: 'app__main-section__form' + classSuffix },
	                            _react2['default'].cloneElement(this.props.children),
	                            _react2['default'].createElement(_NavigationControl2['default'], null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return App;
	})(_react.Component);
	
	exports.App = App;
	
	App.propTypes = {
	    invalidSubmit: _react2['default'].PropTypes.bool,
	    canSubmit: _react2['default'].PropTypes.bool,
	
	    stepIndex: _react2['default'].PropTypes.number,
	    title: _react2['default'].PropTypes.string,
	
	    actions: _react2['default'].PropTypes.object,
	    person: _react2['default'].PropTypes.object
	};
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	
	        stepIndex: state.navigation.get('stepIndex'),
	        title: state.navigation.get('title'),
	
	        invalidSubmit: state.navigation.get('invalidSubmit'),
	        canSubmit: state.navigation.get('canSubmit')
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.reset = reset;
	
	function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	/* This resets all reducers to initial state */
	
	function reset(query) {
	    return function (dispatch) {
	        dispatch({ type: ActionTypes.NAVIGATION_RESET, query: query });
	        dispatch({ type: ActionTypes.RESET });
	    };
	}
	
	var _defaultActions = __webpack_require__(788);
	
	_defaults(exports, _interopExportWildcard(_defaultActions, _defaults));
	
	var _navigationActions = __webpack_require__(792);
	
	_defaults(exports, _interopExportWildcard(_navigationActions, _defaults));
	
	var _statsActions = __webpack_require__(793);
	
	_defaults(exports, _interopExportWildcard(_statsActions, _defaults));

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.start = start;
	exports.updatePersonAttribute = updatePersonAttribute;
	exports.createMessage = createMessage;
	exports.submit = submit;
	exports.signUpToNewsletter = signUpToNewsletter;
	exports.initialiseUrlQueryData = initialiseUrlQueryData;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	var _reactRouter = __webpack_require__(693);
	
	var _servicesStoreService = __webpack_require__(789);
	
	var _servicesStoreService2 = _interopRequireDefault(_servicesStoreService);
	
	var storeService = new _servicesStoreService2['default']();
	
	function start(nextURL) {
	    return function (dispatch) {
	        dispatch({ type: ActionTypes.START });
	        if (nextURL) {
	            _reactRouter.browserHistory.push(nextURL);
	        }
	    };
	}
	
	function updatePersonAttribute(attributeName, value) {
	    return { type: ActionTypes.UPDATE_PERSON_ATTRIBUTE, attributeName: attributeName, value: value };
	}
	
	function createMessage() {
	    return { type: ActionTypes.CREATE_MESSAGE };
	}
	
	function submit(params, nextURL) {
	    return function (dispatch) {
	        storeService.postQuoteRequest(params).then(function () {
	            dispatch({ type: ActionTypes.SUBMIT_SUCCESS });
	
	            if (nextURL) {
	                _reactRouter.browserHistory.push(nextURL);
	            }
	        })['catch'](function (error) {
	            dispatch({ type: ActionTypes.SUBMIT_ERROR, error: error });
	        });
	    };
	}
	
	function signUpToNewsletter(params) {
	    return function (dispatch) {
	        storeService.postNewsletter(params).then(function () {
	            dispatch({ type: ActionTypes.SUBMIT_NEWSLETTER_SUCCESS });
	        })['catch'](function (error) {
	            dispatch({ type: ActionTypes.SUBMIT_ERROR, error: error });
	        });
	    };
	}
	
	function initialiseUrlQueryData(query) {
	    return { type: ActionTypes.INITIALISE_URL_QUERY_DATA, query: query };
	}

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _AjaxHandler = __webpack_require__(790);
	
	var _CookieHandler = __webpack_require__(791);
	
	var _CookieHandler2 = _interopRequireDefault(_CookieHandler);
	
	/* eslint no-undef: 0 */
	var Config = window.vfEnvironmentConfig;
	
	var StoreService = (function () {
	    function StoreService() {
	        _classCallCheck(this, StoreService);
	    }
	
	    _createClass(StoreService, [{
	        key: 'postQuoteRequest',
	        value: function postQuoteRequest(params) {
	            return this.api(Config.API_URL + '/v0/public/quote-request').postNoToken(params);
	        }
	    }, {
	        key: 'postNewsletter',
	        value: function postNewsletter(params) {
	            return this.api(Config.API_URL + '/v0/public/newsletter').postNoToken(params);
	        }
	    }, {
	        key: 'api',
	        value: function api(url) {
	            return {
	                get: function get(params) {
	                    return (0, _AjaxHandler.ajaxHandler)('GET', url, params, _CookieHandler2['default'].getTokenCookie());
	                },
	                post: function post(params) {
	                    return (0, _AjaxHandler.ajaxHandler)('POST', url, params, _CookieHandler2['default'].getTokenCookie());
	                },
	                postNoToken: function postNoToken(params) {
	                    return (0, _AjaxHandler.ajaxHandler)('POST', url, params);
	                },
	                put: function put(params) {
	                    return (0, _AjaxHandler.ajaxHandler)('PUT', url, params, _CookieHandler2['default'].getTokenCookie());
	                },
	                'delete': function _delete(params) {
	                    return (0, _AjaxHandler.ajaxHandler)('DELETE', url, params, _CookieHandler2['default'].getTokenCookie());
	                }
	            };
	        }
	    }]);
	
	    return StoreService;
	})();
	
	exports['default'] = StoreService;
	module.exports = exports['default'];

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.ajaxHandler = ajaxHandler;
	
	function ajaxHandler(method, url, jsonParams, token) {
	    var promise = new Promise(function (resolve, reject) {
	        var client = new XMLHttpRequest();
	        var uri = url;
	
	        var jsonAsString = '';
	        client.open(method, uri);
	        if (method === 'POST' || method === 'PUT') {
	            if (jsonParams) {
	                jsonAsString = JSON.stringify(jsonParams) || '';
	            }
	        }
	
	        client.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        if (token) {
	            client.setRequestHeader('Authorization', 'Bearer ' + token);
	        }
	
	        client.send(jsonAsString);
	
	        client.onload = function onload() {
	            if (this.status >= 200 && this.status < 300) {
	                var responseToken = '';
	
	                if (this.getResponseHeader('X-VF-Access-Token')) {
	                    responseToken = this.getResponseHeader('X-VF-Access-Token');
	                }
	
	                resolve({ data: this.response, token: responseToken, status: this.status });
	            } else {
	                reject(this.statusText);
	            }
	        };
	
	        client.onerror = function onerror() {
	            reject(this.statusText);
	        };
	    });
	
	    return promise;
	}

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var COOKIE_TOKEN_NAME = 'token';
	
	var CookieHandler = (function () {
	    function CookieHandler() {
	        _classCallCheck(this, CookieHandler);
	    }
	
	    _createClass(CookieHandler, null, [{
	        key: 'updateTokenCookie',
	        value: function updateTokenCookie(token) {
	            CookieHandler.setCookie(COOKIE_TOKEN_NAME, token, 1);
	        }
	    }, {
	        key: 'setCookie',
	        value: function setCookie(cookieName, cookieValue) {
	            var expirationDays = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	
	            var currentDate = new Date();
	
	            currentDate.setTime(currentDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
	
	            var expires = 'expires=' + currentDate.toUTCString();
	            window.document.cookie = cookieName + '=' + cookieValue + '; ' + expires + '; path=/';
	        }
	    }, {
	        key: 'clearTokenCookies',
	        value: function clearTokenCookies() {
	            var cookies = window.document.cookie.split(';');
	
	            for (var i = 0; i < cookies.length; i++) {
	                var cookie = cookies[i];
	                var eqPos = cookie.indexOf('=');
	                var _name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
	                if (_name && _name.trim() === COOKIE_TOKEN_NAME) {
	                    window.document.cookie = _name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
	                }
	            }
	        }
	    }, {
	        key: 'getTokenCookie',
	        value: function getTokenCookie() {
	            return CookieHandler.getCookie(COOKIE_TOKEN_NAME);
	        }
	    }, {
	        key: 'getCookie',
	        value: function getCookie(cookieName) {
	            var name = cookieName + '=';
	            var cookies = window.document.cookie.split(';');
	
	            for (var i = 0; i < cookies.length; i++) {
	                var cookieItem = cookies[i];
	                while (cookieItem.charAt(0) === ' ') {
	                    cookieItem = cookieItem.substring(1);
	                }
	                if (cookieItem.indexOf(name) === 0) {
	                    return cookieItem.substring(name.length, cookieItem.length);
	                }
	            }
	
	            return '';
	        }
	    }]);
	
	    return CookieHandler;
	})();
	
	exports['default'] = CookieHandler;
	module.exports = exports['default'];

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.navigate = navigate;
	exports.invalidateForm = invalidateForm;
	exports.validateForm = validateForm;
	exports.invalidSubmit = invalidSubmit;
	exports.validSubmit = validSubmit;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	function navigate(url, search) {
	    return { type: ActionTypes.NAVIGATE, url: url, search: search };
	}
	
	function invalidateForm() {
	    return { type: ActionTypes.INVALIDATE_FORM };
	}
	
	function validateForm() {
	    return { type: ActionTypes.VALIDATE_FORM };
	}
	
	function invalidSubmit() {
	    return { type: ActionTypes.INVALID_SUBMIT };
	}
	
	function validSubmit() {
	    return { type: ActionTypes.VALID_SUBMIT };
	}

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.updateStats = updateStats;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _constantsActionTypes = __webpack_require__(209);
	
	var ActionTypes = _interopRequireWildcard(_constantsActionTypes);
	
	var _servicesSpartaService = __webpack_require__(794);
	
	var _servicesSpartaService2 = _interopRequireDefault(_servicesSpartaService);
	
	var spartaService = new _servicesSpartaService2['default']();
	
	function updateStats(params) {
	    return function (dispatch) {
	        spartaService.getStats(params).then(function (stats) {
	            dispatch({ type: ActionTypes.UPDATE_STATS, stats: stats });
	        })['catch'](function (error) {
	            dispatch({ type: ActionTypes.UPDATE_STATS_ERROR, error: error });
	        });
	    };
	}

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _immutable = __webpack_require__(545);
	
	var _AjaxHandler = __webpack_require__(790);
	
	/* eslint no-undef: 0 */
	var Config = window.vfEnvironmentConfig;
	
	var DEFAULT_PARAMS = (0, _immutable.Map)({
	    include_travel_professionals: 'true',
	    vertical_id: '5',
	    is_contactable: '1'
	});
	
	var SpartaService = (function () {
	    function SpartaService() {
	        _classCallCheck(this, SpartaService);
	    }
	
	    _createClass(SpartaService, [{
	        key: 'buildQuery',
	        value: function buildQuery(params) {
	            var parameters = params instanceof _immutable.Map ? DEFAULT_PARAMS.merge(params) : DEFAULT_PARAMS.merge((0, _immutable.fromJS)(params));
	
	            var separator = '?';
	            return encodeURI(parameters.reduce(function (query, value, key) {
	                var reduced = '' + query + separator + key + '=' + value;
	                separator = '&';
	                return reduced;
	            }, ''));
	        }
	    }, {
	        key: 'search',
	        value: function search(params) {
	            var query = this.buildQuery(params);
	            return this.api(Config.API_URL + '/v2/public/stats-mortgages' + query).get(params);
	        }
	    }, {
	        key: 'isValidResponse',
	        value: function isValidResponse(response) {
	            return response && response.data && JSON.parse(response.data) && JSON.parse(response.data).data.total_count > 0;
	        }
	    }, {
	        key: 'isNoContent',
	        value: function isNoContent(status) {
	            return status === 204;
	        }
	    }, {
	        key: 'getStats',
	        value: function getStats(params) {
	            var _this = this;
	
	            return new Promise(function (resolve, reject) {
	                _this.search(params).then(function (response) {
	                    if (!_this.isValidResponse(response) || _this.isNoContent(response.status)) {
	                        resolve({
	                            reviewsCount: 21,
	                            averageScore: 4.4,
	                            total: 1
	                        });
	
	                        return;
	                    }
	
	                    var responseData = JSON.parse(response.data).data;
	
	                    var stats = {
	                        reviewsCount: responseData.service_review_count,
	                        averageScore: responseData.review_average_score,
	                        total: responseData.total_count
	                    };
	
	                    resolve(stats);
	                })['catch'](function (error) {
	                    reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'api',
	        value: function api(url) {
	            return {
	                get: function get(params) {
	                    return (0, _AjaxHandler.ajaxHandler)('GET', url, params);
	                }
	            };
	        }
	    }]);
	
	    return SpartaService;
	})();
	
	exports['default'] = SpartaService;
	module.exports = exports['default'];

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var WindowEventsHandler = (function () {
	    function WindowEventsHandler() {
	        _classCallCheck(this, WindowEventsHandler);
	    }
	
	    _createClass(WindowEventsHandler, null, [{
	        key: 'enableUnloadMessage',
	
	        /* eslint no-param-reassign: 0 */
	        value: function enableUnloadMessage() {
	            window.onbeforeunload = function (e) {
	                var confirmationMessage = 'There are unsaved changes on this page, are you sure you want to leave?';
	
	                e.returnValue = confirmationMessage;
	                return confirmationMessage;
	            };
	        }
	    }, {
	        key: 'disableUnloadMessage',
	        value: function disableUnloadMessage() {
	            window.onbeforeunload = function () {};
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            window.scrollTo(0, 0);
	        }
	    }]);
	
	    return WindowEventsHandler;
	})();
	
	exports['default'] = WindowEventsHandler;
	module.exports = exports['default'];

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(693);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	/* eslint no-unused-vars: 0 */
	
	var _headerActionsBarHeader = __webpack_require__(797);
	
	var _headerActionsBarHeader2 = _interopRequireDefault(_headerActionsBarHeader);
	
	var _headerProgressBarHeader = __webpack_require__(799);
	
	var _headerProgressBarHeader2 = _interopRequireDefault(_headerProgressBarHeader);
	
	var _dataImages = __webpack_require__(800);
	
	var _constantsSteps = __webpack_require__(691);
	
	/* eslint eqeqeq: 0 */
	
	var Header = (function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        _get(Object.getPrototypeOf(Header.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Header, [{
	        key: 'goToIndex',
	        value: function goToIndex() {
	            _reactRouter.browserHistory.push('/');
	        }
	    }, {
	        key: 'renderActionsBar',
	        value: function renderActionsBar() {
	            return _react2['default'].createElement(_headerActionsBarHeader2['default'], { stepIndex: this.props.stepIndex });
	        }
	    }, {
	        key: 'renderTitle',
	        value: function renderTitle() {
	            if (this.props.url && !this.props.url.split('/')[0]) {
	                return '';
	            }
	
	            return this.props.title || '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var logoHiddenMobileClass = '';
	            if (this.props.stepIndex != null) {
	                logoHiddenMobileClass = 'hidden-mobile';
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__header__wrapper' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__header__container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__header' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__header__logo ' + logoHiddenMobileClass },
	                            _react2['default'].createElement('img', { src: _dataImages.LogoWhite, onClick: this.goToIndex })
	                        ),
	                        _react2['default'].createElement(
	                            'h1',
	                            { className: 'vouchedfor-brand' },
	                            this.renderTitle()
	                        ),
	                        this.renderActionsBar()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Header;
	})(_react.Component);
	
	exports.Header = Header;
	
	Header.propTypes = {
	    url: _react2['default'].PropTypes.string,
	    stepIndex: _react2['default'].PropTypes.number,
	    title: _react2['default'].PropTypes.string,
	    actions: _react2['default'].PropTypes.object
	};
	
	function mapStateToProps(state) {
	    return {
	        stepIndex: state.navigation.get('stepIndex'),
	        title: state.navigation.get('title')
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(693);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var ActionsBarHeader = (function (_Component) {
	    _inherits(ActionsBarHeader, _Component);
	
	    function ActionsBarHeader() {
	        _classCallCheck(this, ActionsBarHeader);
	
	        _get(Object.getPrototypeOf(ActionsBarHeader.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ActionsBarHeader, [{
	        key: 'renderPhoneNumber',
	        value: function renderPhoneNumber() {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__header__actions__phone-number app__header__actions__phone-number--mobile' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'tel:03300388543' },
	                        _react2['default'].createElement(_iconsIcon2['default'], { icon: 'phone', size: '25px', style: { fill: '#FFFFFF' } })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__header__actions__phone-number' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'tel:033003885433' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'app__header__actions__phone-number__icon' },
	                            _react2['default'].createElement(_iconsIcon2['default'], { icon: 'phone', size: '22px', style: { fill: '#FFFFFF' } })
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'app__header__actions__phone-number__number' },
	                            '0330 038 8543'
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__header__actions' },
	                this.renderPhoneNumber()
	            );
	        }
	    }]);
	
	    return ActionsBarHeader;
	})(_react.Component);
	
	exports['default'] = ActionsBarHeader;
	
	ActionsBarHeader.propTypes = {
	    stepIndex: _react2['default'].PropTypes.number
	};
	module.exports = exports['default'];

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DEFAULT_COLOR = '#0099BC';
	
	var Icon = (function (_Component) {
	    _inherits(Icon, _Component);
	
	    function Icon() {
	        _classCallCheck(this, Icon);
	
	        _get(Object.getPrototypeOf(Icon.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Icon, [{
	        key: '_mergeStyles',
	        value: function _mergeStyles() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return Object.assign.apply(Object, [{}].concat(args));
	        }
	
	        /* eslint indent: 0, max-len: 0 */
	    }, {
	        key: 'renderGraphic',
	        value: function renderGraphic() {
	            switch (this.props.icon) {
	                case 'bin':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M 8 0 C 3.582031 0 0 3.582031 0 8 C 0 12.417969 3.582031 16 8 16 C 12.417969 16 16 12.417969 16 8 C 16 3.582031 12.417969 0 8 0 Z M 13 9 L 3 9 L 3 7 L 13 7 Z M 13 9 ' })
	                    );
	                case 'checkmark':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M15.36 1c-5.227 3.956-10.239 9.247-10.239 9.247l-3.612-3.247-1.509 1.537c1.485 1.395 4.924 5.081 6.088 6.463 3.275-5.472 6.679-9.552 9.912-13.284l-0.64-0.716z' })
	                    );
	                case 'settings':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M16 7l-3.767-0.753 2.131-3.196-1.414-1.414-3.196 2.131-0.753-3.767h-2l-0.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196-3.767 0.753v2l3.767 0.753-2.131 3.196 1.414 1.414 3.196-2.131 0.753 3.767h2l0.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196 3.767-0.753v-2zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z' })
	                    );
	                case 'right-arrow':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z' }),
	                        _react2['default'].createElement('path', { d: 'M8.5 12l4-4-4-4-1.5 1.5 1.5 1.5h-4.5v2h4.5l-1.5 1.5z' })
	                    );
	                case 'exit':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M11 13l4.5-4.5-4.5-4.5v3h-7v3h7v3z' }),
	                        _react2['default'].createElement('path', { d: 'M1 1h11v2h-10v11h10v2h-11c-0.552 0-1-0.448-1-1v-13c0-0.552 0.448-1 1-1z' })
	                    );
	                case 'lock':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M12.533 6.4h-0.267v-3.2c0-1.764-1.436-3.2-3.2-3.2h-2.133c-1.764 0-3.2 1.436-3.2 3.2v3.2h-0.267c-0.439 0-0.8 0.361-0.8 0.8v8c0 0.439 0.361 0.8 0.8 0.8h9.067c0.439 0 0.8-0.361 0.8-0.8v-8c0-0.439-0.361-0.8-0.8-0.8zM5.867 3.2c0-0.588 0.479-1.067 1.067-1.067h2.133c0.588 0 1.067 0.479 1.067 1.067v3.2h-4.267v-3.2z' })
	                    );
	                case 'pencil':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M3.691 5.226c0.013-0.024 0.026-0.053 0.038-0.083 0.109-0.374 0.439-0.64 0.834-0.648 1.562-0 3.12-0 4.681-0h0.061c-0.035 0.040-0.058 0.068-0.081 0.094-0.342 0.357-0.683 0.711-1.012 1.068-0.040 0.047-0.099 0.076-0.165 0.076-0.002 0-0.005-0-0.007-0h-3.157v6.135h5.895v-0.132q0-1.566 0-3.13c-0-0.003-0-0.007-0-0.011 0-0.071 0.029-0.135 0.076-0.181 0.367-0.377 0.731-0.759 1.108-1.154 0 0.043 0 0.071 0 0.099q0 2.416 0 4.835c0 0.001 0 0.001 0 0.002 0 0.393-0.248 0.729-0.596 0.858-0.040 0.016-0.068 0.030-0.094 0.045l-6.918-0.002s0-0.015 0-0.018c-0.317-0.101-0.557-0.357-0.634-0.677s-0.001-0.006-0.019-0.006z' }),
	                        _react2['default'].createElement('path', { d: 'M13.144 4.824c-0.030 0.028-0.063 0.053-0.091 0.081l-5.427 5.657c-0.047 0.054-0.116 0.089-0.192 0.089-0.003 0-0.007-0-0.010-0-0.412 0-0.824 0-1.239 0h-0.129c0-0.228 0-0.44 0-0.655 0-0.253 0-0.506 0-0.759-0-0.005-0-0.011-0-0.016 0-0.072 0.030-0.137 0.079-0.183l5.445-5.675c0.028-0.030 0.053-0.061 0.081-0.094h0.288c0.048 0.015 0.094 0.033 0.142 0.046 0.429 0.101 0.771 0.4 0.93 0.793 0.054 0.128 0.084 0.262 0.125 0.381zM7.529 9.378l4.395-4.569-0.407-0.415-4.385 4.569z' }),
	                        _react2['default'].createElement('path', { d: 'M8 15.665c-4.41 0-8-3.438-8-7.666s3.59-7.663 8-7.663 8 3.438 8 7.666-3.59 7.663-8 7.663zM8 1.6c-3.714 0-6.735 2.872-6.735 6.401s3.021 6.401 6.735 6.401 6.735-2.874 6.735-6.401-3.021-6.401-6.735-6.401z' })
	                    );
	                case 'pencil-only':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M1.543 10.706c0.012-0.021 0.018-0.039 0.030-0.051 0.148-0.148 0.299-0.295 0.447-0.443 0.117-0.117 0.228-0.237 0.345-0.354 0.223-0.221 0.448-0.44 0.671-0.662 0.121-0.119 0.236-0.242 0.355-0.362 0.217-0.217 0.438-0.432 0.655-0.648 0.136-0.136 0.27-0.276 0.406-0.413 0.216-0.215 0.434-0.428 0.65-0.643 0.121-0.122 0.238-0.246 0.36-0.367 0.216-0.215 0.434-0.428 0.65-0.643 0.121-0.122 0.24-0.245 0.36-0.367 0.233-0.232 0.468-0.461 0.7-0.693 0.208-0.207 0.415-0.414 0.624-0.621 0.115-0.117 0.231-0.232 0.346-0.348 0.121-0.122 0.238-0.246 0.36-0.367 0.231-0.231 0.464-0.458 0.694-0.688 0.107-0.107 0.212-0.219 0.32-0.326 0.103-0.103 0.21-0.203 0.312-0.308 0.029-0.030 0.059-0.028 0.083-0.009 0.047 0.037 0.105 0.047 0.155 0.076 0.042 0.025 0.085 0.047 0.128 0.071 0.035 0.018 0.068 0.042 0.105 0.055 0.077 0.028 0.135 0.086 0.207 0.119 0.093 0.043 0.162 0.121 0.258 0.157 0.024 0.009 0.041 0.033 0.063 0.043 0.077 0.039 0.135 0.109 0.219 0.14 0.017 0.007 0.029 0.024 0.043 0.035 0.084 0.066 0.166 0.132 0.252 0.196 0.047 0.037 0.098 0.069 0.145 0.107 0.033 0.026 0.058 0.062 0.092 0.085 0.195 0.138 0.355 0.314 0.525 0.481 0.109 0.106 0.214 0.216 0.32 0.325 0.008 0.008 0.014 0.020 0.020 0.030 0.045 0.084 0.119 0.143 0.177 0.216 0.043 0.055 0.084 0.11 0.127 0.165 0.068 0.088 0.141 0.173 0.206 0.263 0.069 0.1 0.131 0.207 0.197 0.309 0.054 0.083 0.117 0.161 0.159 0.249 0.029 0.060 0.067 0.114 0.097 0.172 0.041 0.076 0.085 0.149 0.123 0.227 0.022 0.043 0.037 0.089 0.056 0.134 0.007 0.014 0.017 0.026 0.026 0.039 0.022 0.030 0.018 0.059-0.009 0.086-0.195 0.197-0.389 0.394-0.586 0.589-0.231 0.231-0.464 0.458-0.694 0.688-0.11 0.109-0.215 0.223-0.324 0.331-0.244 0.242-0.49 0.483-0.735 0.727-0.194 0.191-0.386 0.384-0.579 0.576-0.145 0.145-0.29 0.291-0.435 0.436-0.177 0.177-0.354 0.352-0.529 0.529-0.179 0.181-0.356 0.363-0.536 0.544-0.141 0.143-0.287 0.282-0.428 0.423-0.123 0.123-0.245 0.249-0.369 0.372-0.173 0.173-0.348 0.343-0.521 0.516-0.152 0.152-0.3 0.308-0.451 0.46-0.173 0.173-0.346 0.345-0.52 0.517-0.245 0.242-0.49 0.485-0.735 0.728-0.093 0.092-0.182 0.187-0.275 0.28-0.178 0.178-0.358 0.356-0.536 0.534-0.029 0.029-0.069 0.024-0.086-0.014-0.064-0.138-0.162-0.254-0.237-0.385-0.042-0.075-0.106-0.136-0.151-0.211-0.039-0.067-0.098-0.121-0.135-0.185-0.035-0.063-0.096-0.105-0.123-0.165-0.050-0.11-0.155-0.172-0.211-0.276-0.029-0.056-0.083-0.101-0.126-0.151-0.174-0.203-0.355-0.398-0.548-0.584-0.138-0.132-0.269-0.269-0.406-0.4-0.097-0.093-0.193-0.189-0.304-0.265-0.055-0.038-0.096-0.094-0.149-0.132-0.083-0.059-0.157-0.123-0.225-0.197-0.079-0.017-0.114-0.094-0.177-0.13-0.111-0.062-0.203-0.151-0.31-0.216-0.092-0.056-0.182-0.111-0.267-0.178-0.051-0.041-0.115-0.066-0.172-0.098-0.047-0.028-0.093-0.056-0.136-0.086-0.016-0.012-0.024-0.031-0.038-0.050z' }),
	                        _react2['default'].createElement('path', { d: 'M14.691 5.079c-0.035-0.052-0.075-0.097-0.098-0.148-0.039-0.084-0.1-0.155-0.148-0.233-0.054-0.088-0.11-0.177-0.174-0.257-0.056-0.069-0.088-0.156-0.161-0.212-0.034-0.111-0.144-0.169-0.193-0.272-0.018-0.041-0.062-0.068-0.089-0.105-0.105-0.132-0.223-0.253-0.329-0.384-0.121-0.148-0.258-0.279-0.389-0.415-0.136-0.14-0.276-0.276-0.419-0.41-0.077-0.075-0.161-0.141-0.242-0.211-0.020-0.017-0.039-0.033-0.059-0.050-0.094-0.081-0.182-0.173-0.284-0.24-0.064-0.042-0.117-0.102-0.181-0.136s-0.106-0.092-0.165-0.123c-0.056-0.030-0.102-0.071-0.155-0.105-0.077-0.050-0.155-0.1-0.233-0.149-0.066-0.042-0.132-0.084-0.197-0.126-0.054-0.034-0.106-0.071-0.16-0.105-0.014-0.009-0.029-0.017-0.043-0.024-0.052-0.024-0.059-0.055-0.018-0.094 0.103-0.103 0.207-0.206 0.309-0.309 0.092-0.093 0.182-0.189 0.274-0.282 0.208-0.21 0.418-0.419 0.627-0.629 0.035-0.035 0.075-0.060 0.131-0.055 0.067 0.007 0.135 0.003 0.202 0.004 0.046 0.001 0.090-0.001 0.131 0.028 0.017 0.012 0.046 0.010 0.069 0.012 0.067 0.003 0.135 0.001 0.203 0.004 0.037 0.001 0.077-0.005 0.106 0.031 0.008 0.009 0.031 0.008 0.048 0.008 0.043 0.003 0.086 0.003 0.13 0.004 0.017 0.001 0.041-0.003 0.048 0.007 0.041 0.043 0.092 0.031 0.141 0.035 0.029 0.001 0.054 0.004 0.079 0.028 0.016 0.014 0.050 0.010 0.075 0.014 0.034 0.005 0.075-0.008 0.097 0.033 0.003 0.004 0.008 0.008 0.012 0.007 0.080-0.012 0.145 0.042 0.221 0.050 0.024 0.003 0.046 0.018 0.068 0.029 0.007 0.003 0.012 0.008 0.018 0.009 0.056 0.017 0.114 0.030 0.169 0.051 0.045 0.017 0.086 0.045 0.13 0.066 0.045 0.021 0.090 0.038 0.135 0.062 0.043 0.022 0.085 0.050 0.128 0.073 0.028 0.016 0.058 0.029 0.085 0.045 0.060 0.037 0.121 0.073 0.179 0.113 0.035 0.024 0.068 0.050 0.1 0.077 0.069 0.060 0.147 0.114 0.204 0.185 0.077 0.092 0.169 0.17 0.224 0.282 0.029 0.058 0.088 0.102 0.11 0.161 0.029 0.077 0.098 0.134 0.109 0.22 0.004 0.028 0.022 0.056 0.041 0.079 0.035 0.045 0.034 0.105 0.071 0.149 0.021 0.026 0.029 0.064 0.039 0.097 0.021 0.064 0.041 0.128 0.060 0.193 0.004 0.012-0.001 0.029 0.005 0.035 0.047 0.038 0.035 0.090 0.039 0.139 0.001 0.009-0.001 0.024 0.004 0.028 0.050 0.045 0.037 0.105 0.042 0.161 0 0.007 0 0.017 0.005 0.021 0.050 0.037 0.033 0.092 0.037 0.14 0.003 0.038-0.004 0.076 0.031 0.106 0.010 0.009 0.008 0.037 0.010 0.055 0.008 0.072-0.013 0.149 0.038 0.216 0.009 0.012 0.005 0.033 0.005 0.050 0.001 0.058 0.003 0.115 0.004 0.173 0 0.043 0.001 0.085 0.028 0.124 0.010 0.016 0.009 0.042 0.010 0.063 0.003 0.077-0.003 0.155 0.005 0.231 0.007 0.063-0.021 0.102-0.060 0.143-0.127 0.127-0.253 0.254-0.379 0.381-0.19 0.191-0.38 0.381-0.57 0.571-0.093 0.093-0.19 0.185-0.293 0.284z' }),
	                        _react2['default'].createElement('path', { d: 'M4.242 15.534c-0.141 0.141-0.286 0.284-0.427 0.43-0.021 0.022-0.042 0.030-0.069 0.030-0.020 0-0.038 0-0.058 0-1.191 0-2.38 0-3.571 0-0.117 0-0.109 0.007-0.109-0.11 0-1.188 0-2.376-0.001-3.563 0-0.076 0.021-0.128 0.077-0.179 0.115-0.105 0.221-0.22 0.331-0.331 0.018-0.018 0.041-0.033 0.059-0.047 0.056 0.028 0.113 0.052 0.166 0.080 0.043 0.022 0.085 0.047 0.127 0.071 0.034 0.018 0.068 0.039 0.103 0.055 0.155 0.073 0.296 0.168 0.44 0.259 0.076 0.048 0.148 0.1 0.225 0.148 0.085 0.052 0.166 0.113 0.249 0.172 0.038 0.026 0.072 0.058 0.109 0.086 0.085 0.066 0.173 0.127 0.255 0.195 0.076 0.063 0.149 0.13 0.221 0.198 0.085 0.080 0.17 0.16 0.261 0.236 0.059 0.050 0.103 0.115 0.157 0.172 0.107 0.115 0.22 0.225 0.324 0.345 0.090 0.103 0.17 0.217 0.255 0.326 0.014 0.018 0.029 0.037 0.043 0.055 0.052 0.067 0.118 0.128 0.151 0.204 0.030 0.067 0.1 0.105 0.113 0.179 0.001 0.007 0.003 0.016 0.008 0.020 0.090 0.077 0.13 0.189 0.195 0.283 0.060 0.086 0.103 0.186 0.155 0.28 0.039 0.071 0.080 0.139 0.119 0.21 0.020 0.037 0.035 0.075 0.052 0.113 0.010 0.025 0.021 0.048 0.038 0.085z' })
	                    );
	                case 'file-presentation':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 15.665c-4.41 0-8-3.438-8-7.666s3.59-7.663 8-7.663 8 3.438 8 7.666-3.59 7.663-8 7.663zM8 1.6c-3.714 0-6.735 2.872-6.735 6.401s3.021 6.401 6.735 6.401 6.735-2.874 6.735-6.401-3.021-6.401-6.735-6.401z' }),
	                        _react2['default'].createElement('path', { d: 'M3.871 12.219v-8.552c0.006-0.010 0.011-0.021 0.015-0.033 0.041-0.203 0.16-0.37 0.324-0.474 0.090-0.048 0.193-0.092 0.301-0.129l4.903-0.005c-0.001 0.009-0.001 0.020-0.001 0.030s0 0.021 0.001 0.032q0 1.341 0 2.686c-0.001 0.007-0.001 0.014-0.001 0.022 0 0.167 0.136 0.303 0.303 0.303 0.008 0 0.015 0 0.023-0.001h2.739v6.149c-0.008 0.017-0.017 0.039-0.025 0.061-0.051 0.161-0.143 0.292-0.263 0.388-0.099 0.076-0.214 0.133-0.34 0.163l-7.35 0.001-0.045-0.016c-0.209-0.051-0.38-0.185-0.48-0.365-0.037-0.074-0.071-0.159-0.1-0.247zM8.185 10.408h-2.135c-0.013-0.001-0.028-0.002-0.043-0.002s-0.030 0.001-0.045 0.002c-0.144 0.025-0.253 0.15-0.253 0.301 0 0.169 0.137 0.305 0.305 0.305 0.009 0 0.018 0 0.027-0.001h4.263c0 0 0 0 0 0 0.169 0 0.305-0.137 0.305-0.305s-0.137-0.305-0.305-0.305c0 0 0 0 0 0zM8.185 8.565h2.177c0.121-0.005 0.223-0.082 0.263-0.19 0.015-0.035 0.024-0.074 0.024-0.115 0-0.079-0.032-0.151-0.084-0.203-0.062-0.064-0.148-0.103-0.244-0.103-0.007 0-0.014 0-0.020 0.001h-4.253c-0.006 0-0.012-0.001-0.019-0.001-0.11 0-0.207 0.057-0.262 0.144-0.029 0.045-0.046 0.099-0.046 0.157s0.017 0.111 0.046 0.156c0.051 0.094 0.15 0.157 0.264 0.157 0.006 0 0.012 0 0.018-0.001zM8.185 9.795h2.198c0.138-0.018 0.246-0.125 0.263-0.262 0.001-0.012 0.002-0.023 0.002-0.035 0-0.131-0.085-0.242-0.202-0.282-0.050-0.014-0.104-0.022-0.16-0.022-0.005 0-0.011 0-0.016 0h-4.279c-0.121 0.004-0.223 0.082-0.263 0.19-0.014 0.035-0.022 0.073-0.022 0.113 0 0.169 0.137 0.305 0.305 0.305 0.007 0 0.015 0 0.022-0.001z' }),
	                        _react2['default'].createElement('path', { d: 'M9.888 5.581v-2.458c0.965 0.679 1.78 1.494 2.439 2.426z' })
	                    );
	                case 'phone-outgoing':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 15.665c-4.41 0-8-3.438-8-7.666s3.59-7.663 8-7.663 8 3.438 8 7.666-3.59 7.663-8 7.663zM8 1.6c-3.714 0-6.735 2.872-6.735 6.401s3.021 6.401 6.735 6.401 6.735-2.874 6.735-6.401-3.021-6.401-6.735-6.401z' }),
	                        _react2['default'].createElement('path', { d: 'M3.433 5.654c0.266-0.359 0.516-0.726 0.797-1.063 0.166-0.192 0.339-0.366 0.525-0.526 0.103-0.103 0.236-0.163 0.384-0.163 0.119 0 0.229 0.039 0.318 0.105 0.357 0.234 0.663 0.512 0.92 0.831 0.206 0.234 0.371 0.498 0.486 0.787 0.032 0.088 0.052 0.169 0.064 0.253 0.006 0.032 0.010 0.062 0.010 0.093 0 0.122-0.051 0.232-0.134 0.309-0.178 0.154-0.364 0.298-0.55 0.444-0.082 0.064-0.173 0.114-0.266 0.175-0.188 0.124-0.31 0.335-0.31 0.574 0 0.087 0.016 0.17 0.046 0.247 0.078 0.277 0.21 0.522 0.386 0.729 0.476 0.597 0.987 1.129 1.543 1.611 0.205 0.189 0.443 0.316 0.707 0.375 0.053 0.014 0.103 0.020 0.155 0.020 0.201 0 0.379-0.104 0.481-0.261 0.086-0.127 0.158-0.268 0.243-0.388s0.218-0.314 0.33-0.468c0.084-0.126 0.225-0.207 0.386-0.207 0.058 0 0.114 0.011 0.165 0.030 0.218 0.067 0.41 0.17 0.577 0.304 0.414 0.308 0.763 0.686 1.031 1.118 0.244 0.403 0.236 0.581-0.035 0.937-0.305 0.368-0.643 0.69-1.016 0.97l-0.433 0.343h-0.316c-0.012-0.008-0.026-0.015-0.041-0.021-0.124-0.030-0.249-0.051-0.368-0.083-0.774-0.232-1.448-0.541-2.068-0.929-0.65-0.373-1.24-0.831-1.758-1.36-0.466-0.513-0.873-1.091-1.202-1.715-0.404-0.704-0.724-1.466-0.942-2.269-0.055-0.224-0.079-0.384-0.111-0.543q-0.003-0.13-0.003-0.26z' }),
	                        _react2['default'].createElement('path', { d: 'M11.963 8.057c-0.075 0.155-0.174 0.216-0.298 0.186-0.11-0.031-0.189-0.13-0.189-0.247 0-0.006 0-0.013 0.001-0.019 0-0.007 0-0.017 0-0.027 0-0.411-0.073-0.805-0.207-1.17q-0.697-1.856-2.603-2.204c-0.126-0.019-0.273-0.031-0.423-0.033-0.005 0-0.009 0-0.012 0-0.121 0-0.223-0.086-0.246-0.201-0.005-0.021-0.008-0.044-0.008-0.067 0-0.108 0.063-0.201 0.154-0.244l0.025-0.017h0.404l0.345 0.063c1.552 0.343 2.738 1.585 2.995 3.14 0.024 0.145 0.043 0.257 0.064 0.389z' }),
	                        _react2['default'].createElement('path', { d: 'M11.029 7.907c0.003 0.016 0.004 0.035 0.004 0.054 0 0.087-0.034 0.167-0.089 0.226-0.043 0.045-0.105 0.073-0.173 0.073-0.035 0-0.069-0.008-0.099-0.022-0.094-0.040-0.159-0.133-0.159-0.241 0-0.005 0-0.009 0-0.013 0-0.005 0-0.013 0-0.020 0-0.301-0.055-0.589-0.157-0.854-0.274-0.806-0.985-1.409-1.852-1.528-0.087-0.012-0.174-0.018-0.263-0.018-0.002 0-0.004 0-0.005 0-0.148 0-0.268-0.12-0.268-0.268 0-0.001 0-0.002 0-0.003-0-0.004-0-0.008-0-0.012 0-0.146 0.118-0.264 0.264-0.264 0.004 0 0.009 0 0.013 0 0.737 0.005 1.404 0.307 1.885 0.793 0.481 0.471 0.802 1.103 0.878 1.808 0.011 0.102 0.013 0.195 0.020 0.286z' }),
	                        _react2['default'].createElement('path', { d: 'M8.305 6.037c0.874 0.055 1.583 0.697 1.74 1.534 0.020 0.113 0.035 0.237 0.044 0.362 0.003 0.025 0.005 0.043 0.005 0.061 0 0.152-0.118 0.277-0.267 0.288-0.157-0.001-0.283-0.128-0.283-0.284 0-0.015 0.001-0.030 0.003-0.044-0-0.716-0.552-1.305-1.254-1.364-0.022 0.001-0.042 0.002-0.062 0.002s-0.040-0.001-0.060-0.002c-0.12-0.030-0.21-0.14-0.21-0.271 0-0.010 0.001-0.019 0.002-0.029 0.009-0.133 0.115-0.239 0.248-0.248z' })
	                    );
	                case 'phone':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M11.733 9.6c-1.067 1.067-1.067 2.133-2.133 2.133s-2.133-1.067-3.2-2.133-2.133-2.133-2.133-3.2 1.067-1.067 2.133-2.133-2.133-4.267-3.2-4.267-3.2 3.2-3.2 3.2c0 2.133 2.192 6.459 4.267 8.533s6.4 4.267 8.533 4.267c0 0 3.2-2.133 3.2-3.2s-3.2-4.267-4.267-3.2z' })
	                    );
	                case 'user-tie':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 15.665c-4.41 0-8-3.438-8-7.666s3.59-7.663 8-7.663 8 3.438 8 7.666-3.59 7.663-8 7.663zM8 1.6c-3.714 0-6.735 2.872-6.735 6.401s3.021 6.401 6.735 6.401 6.735-2.874 6.735-6.401-3.021-6.401-6.735-6.401z' }),
	                        _react2['default'].createElement('path', { d: 'M6.003 4.297c0-1.16 0.94-2.1 2.1-2.1s2.1 0.94 2.1 2.1c0 1.16-0.94 2.1-2.1 2.1s-2.1-0.94-2.1-2.1zM10.903 7.097h-0.387l-2.178 4.421 0.814-4.071-1.050-1.050-1.050 1.050 0.814 4.071-2.178-4.421h-0.388c-1.399 0-1.399 0.941-1.399 2.1v3.5h8.4v-3.5c0-1.159 0-2.1-1.399-2.1z' })
	                    );
	                case 'star':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 0.394l2.472 5.012 5.528 0.801-3.993 3.898 0.937 5.501-4.944-2.594-4.944 2.594 0.937-5.501-3.993-3.898 5.528-0.801z' })
	                    );
	                case 'star-unfilled':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M12.942 15.502l-4.942-2.596-4.942 2.596 0.948-5.499-4.006-3.899 5.523-0.806 2.477-5.013 2.477 5.013 5.523 0.806-3.994 3.899 0.936 5.499zM8 11.84l3.686 1.932-0.699-4.101 2.975-2.904-4.124-0.593-1.837-3.745-1.837 3.733-4.124 0.593 2.975 2.904-0.699 4.101 3.686-1.92z' })
	                    );
	                case 'badge':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8.246 0.146c0 0.018 0.009 0.020 0.023 0.022 0.12 0.007 0.228 0.056 0.338 0.101 0.092 0.038 0.178 0.086 0.262 0.142 0.095 0.068 0.169 0.153 0.243 0.241 0.066 0.077 0.142 0.131 0.242 0.158 0.084 0.022 0.16 0.004 0.232-0.016 0.197-0.052 0.395-0.072 0.598-0.066 0.097 0.004 0.19 0.025 0.282 0.045 0.162 0.036 0.312 0.104 0.451 0.188 0.113 0.068 0.212 0.154 0.303 0.248 0.145 0.151 0.253 0.327 0.334 0.519 0.030 0.070 0.050 0.145 0.081 0.216 0.056 0.133 0.146 0.232 0.289 0.28 0.136 0.045 0.273 0.088 0.402 0.154 0.214 0.108 0.406 0.246 0.555 0.436 0.084 0.106 0.153 0.224 0.198 0.352 0.027 0.075 0.047 0.151 0.068 0.23 0.034 0.138 0.043 0.277 0.039 0.417-0.002 0.092-0.009 0.183-0.025 0.273-0.014 0.083-0.043 0.165-0.056 0.248-0.016 0.088-0.002 0.169 0.075 0.228 0.149 0.111 0.259 0.253 0.354 0.413 0.076 0.128 0.137 0.264 0.197 0.402 0.021 0.048 0.043 0.095 0.056 0.144 0.021 0.063 0.039 0.127 0.039 0.194 0 0.050-0.002 0.101 0 0.151 0.002 0.063-0.016 0.122-0.031 0.178-0.068 0.219-0.167 0.426-0.287 0.623-0.036 0.059-0.084 0.109-0.122 0.162-0.047 0.066-0.108 0.117-0.169 0.171-0.016 0.013-0.030 0.032-0.043 0.048-0.023 0.029-0.030 0.063-0.031 0.099-0.007 0.085 0.023 0.167 0.034 0.248 0.016 0.099 0.034 0.199 0.039 0.3 0.005 0.124 0.005 0.248-0.009 0.372-0.011 0.111-0.040 0.221-0.079 0.327-0.045 0.124-0.106 0.242-0.185 0.345s-0.169 0.198-0.275 0.277c-0.108 0.081-0.221 0.151-0.341 0.21-0.061 0.030-0.129 0.052-0.192 0.079-0.088 0.039-0.183 0.056-0.267 0.111s-0.133 0.131-0.167 0.221c-0.040 0.106-0.075 0.214-0.129 0.316-0.045 0.086-0.088 0.171-0.142 0.251-0.052 0.076-0.106 0.149-0.174 0.212-0.031 0.030-0.056 0.063-0.088 0.092-0.113 0.101-0.237 0.188-0.382 0.243-0.079 0.031-0.155 0.063-0.237 0.086-0.056 0.016-0.117 0.018-0.174 0.030-0.097 0.021-0.194 0.023-0.291 0.018-0.045-0.002-0.091-0.009-0.133-0.014-0.014-0.002-0.025-0.005-0.039-0.005-0.085-0.002-0.165-0.025-0.248-0.040-0.151-0.031-0.289-0.005-0.411 0.1-0.151 0.131-0.304 0.258-0.485 0.35-0.1 0.052-0.201 0.092-0.307 0.127-0.043 0.014-0.092 0.011-0.136 0.027-0.088 0.034-0.178 0.007-0.267 0.030-0.088-0.023-0.181 0.005-0.266-0.027-0.038-0.014-0.079-0.014-0.12-0.025-0.099-0.027-0.194-0.063-0.285-0.106-0.115-0.054-0.221-0.124-0.325-0.194-0.054-0.039-0.104-0.084-0.151-0.129-0.056-0.052-0.115-0.101-0.189-0.127-0.036-0.011-0.072-0.021-0.111-0.021-0.063 0-0.128 0.005-0.189 0.025-0.043 0.014-0.088 0.023-0.131 0.025-0.099 0.007-0.199 0.034-0.3 0.027-0.074-0.005-0.149 0.002-0.221-0.005-0.070-0.007-0.14-0.025-0.212-0.036-0.081-0.014-0.155-0.040-0.23-0.070-0.113-0.047-0.216-0.106-0.316-0.178-0.095-0.068-0.176-0.149-0.25-0.235-0.066-0.075-0.115-0.162-0.169-0.243-0.074-0.115-0.124-0.243-0.174-0.373-0.021-0.054-0.036-0.108-0.067-0.16-0.045-0.076-0.109-0.129-0.185-0.162-0.066-0.030-0.136-0.050-0.201-0.075-0.215-0.081-0.42-0.183-0.598-0.332-0.095-0.076-0.179-0.162-0.251-0.258-0.058-0.076-0.111-0.162-0.144-0.253-0.031-0.084-0.063-0.169-0.086-0.255-0.018-0.066-0.022-0.133-0.031-0.201-0.007-0.059-0.016-0.12-0.009-0.178 0.011-0.113 0-0.226 0.030-0.338 0.014-0.056 0.016-0.113 0.027-0.169 0.007-0.036 0.018-0.072 0.025-0.111 0.011-0.067-0.009-0.122-0.058-0.169-0.075-0.070-0.149-0.14-0.219-0.215-0.070-0.072-0.119-0.16-0.167-0.246-0.072-0.138-0.138-0.277-0.203-0.418-0.016-0.032-0.021-0.067-0.030-0.101-0.014-0.048-0.027-0.095-0.036-0.144-0.007-0.038-0.002-0.079-0.007-0.12-0.009-0.081 0.009-0.162 0.027-0.239 0.014-0.063 0.041-0.124 0.067-0.185 0.038-0.093 0.081-0.183 0.124-0.273 0.092-0.197 0.216-0.368 0.381-0.513 0.066-0.056 0.102-0.128 0.095-0.212-0.005-0.066-0.022-0.131-0.034-0.197-0.009-0.052-0.021-0.106-0.027-0.16-0.009-0.099-0.021-0.201-0.021-0.3 0-0.092 0.005-0.188 0.022-0.28 0.025-0.118 0.054-0.235 0.104-0.348 0.058-0.128 0.128-0.248 0.221-0.35 0.067-0.075 0.147-0.142 0.225-0.205 0.131-0.104 0.28-0.176 0.431-0.244 0.052-0.022 0.108-0.038 0.16-0.057 0.086-0.030 0.17-0.063 0.244-0.115 0.022-0.014 0.038-0.038 0.052-0.061 0.038-0.057 0.066-0.119 0.085-0.183 0.032-0.104 0.077-0.201 0.127-0.294 0.054-0.101 0.109-0.206 0.176-0.3 0.072-0.099 0.154-0.192 0.253-0.268 0.081-0.061 0.162-0.122 0.255-0.164 0.090-0.043 0.185-0.077 0.285-0.104 0.167-0.045 0.334-0.052 0.503-0.047 0.117 0.004 0.232 0.018 0.35 0.031 0.052 0.007 0.101 0.025 0.151 0.034 0.109 0.018 0.207-0.004 0.287-0.086 0.027-0.027 0.052-0.054 0.077-0.081 0.127-0.131 0.277-0.23 0.442-0.307 0.104-0.047 0.205-0.097 0.309-0.142 0.043-0.018 0.093-0.027 0.138-0.039 0.045-0.009 0.093-0.016 0.138-0.025 0.005 0 0.009-0.014 0.013-0.020 0.124 0.009 0.251 0.009 0.377 0.009zM8.079 9.873c0.129 0 0.258 0.002 0.386-0.018 0.085-0.014 0.174-0.018 0.262-0.027 0.039-0.005 0.076-0.014 0.115-0.021 0.040-0.007 0.081-0.014 0.12-0.025 0.045-0.011 0.088-0.025 0.133-0.039 0.092-0.027 0.188-0.050 0.277-0.081 0.092-0.031 0.183-0.068 0.273-0.104 0.059-0.023 0.115-0.047 0.171-0.075 0.095-0.047 0.185-0.101 0.28-0.151 0.181-0.097 0.348-0.216 0.51-0.343 0.104-0.081 0.194-0.174 0.291-0.262 0.207-0.19 0.388-0.402 0.544-0.634 0.076-0.115 0.149-0.234 0.216-0.356 0.050-0.088 0.088-0.181 0.133-0.271 0.056-0.106 0.097-0.219 0.136-0.332 0.018-0.050 0.031-0.101 0.047-0.151 0.014-0.045 0.027-0.090 0.040-0.138 0.009-0.036 0.018-0.072 0.025-0.111 0.014-0.061 0.030-0.122 0.040-0.183s0.023-0.124 0.030-0.188c0.016-0.117 0.031-0.234 0.040-0.354 0.007-0.083 0.005-0.169 0.002-0.255-0.002-0.077-0.005-0.151-0.011-0.226-0.009-0.097-0.025-0.192-0.039-0.289s-0.031-0.194-0.047-0.291c-0.007-0.034-0.016-0.070-0.027-0.104-0.018-0.066-0.039-0.128-0.059-0.192-0.018-0.056-0.030-0.113-0.052-0.167-0.040-0.104-0.084-0.21-0.131-0.311-0.052-0.111-0.104-0.221-0.167-0.327-0.066-0.113-0.14-0.224-0.214-0.332-0.101-0.149-0.219-0.287-0.341-0.42-0.133-0.144-0.28-0.277-0.434-0.401-0.084-0.067-0.169-0.133-0.258-0.194-0.091-0.061-0.183-0.119-0.277-0.171-0.124-0.067-0.252-0.131-0.379-0.194-0.070-0.034-0.14-0.061-0.212-0.091-0.045-0.018-0.091-0.034-0.136-0.048-0.061-0.020-0.122-0.036-0.183-0.054-0.066-0.018-0.129-0.040-0.197-0.054-0.1-0.022-0.201-0.038-0.303-0.056-0.104-0.020-0.21-0.034-0.316-0.040-0.122-0.007-0.243-0.027-0.366-0.020-0.090 0.004-0.181 0.004-0.269 0.012-0.099 0.007-0.197 0.018-0.295 0.032-0.079 0.012-0.16 0.025-0.239 0.040s-0.158 0.034-0.234 0.054c-0.045 0.012-0.090 0.022-0.136 0.036-0.054 0.016-0.109 0.034-0.162 0.052-0.052 0.016-0.106 0.031-0.155 0.052-0.099 0.043-0.199 0.088-0.298 0.131-0.131 0.058-0.258 0.128-0.379 0.205-0.109 0.067-0.215 0.142-0.318 0.216-0.142 0.102-0.276 0.212-0.397 0.334-0.151 0.151-0.303 0.302-0.426 0.476-0.063 0.088-0.128 0.174-0.189 0.267-0.054 0.083-0.104 0.174-0.154 0.26-0.036 0.063-0.072 0.128-0.101 0.194-0.043 0.095-0.079 0.192-0.117 0.291-0.029 0.072-0.059 0.144-0.081 0.219-0.029 0.099-0.054 0.201-0.079 0.303-0.022 0.093-0.045 0.183-0.058 0.277s-0.018 0.194-0.025 0.289c-0.005 0.074-0.007 0.151-0.011 0.226 0 0.007-0.002 0.013-0.002 0.021-0.002 0.059-0.007 0.12-0.005 0.178 0.002 0.067 0.011 0.136 0.018 0.203 0.009 0.097 0.014 0.194 0.025 0.289 0.009 0.066 0.030 0.128 0.041 0.194 0.021 0.115 0.050 0.228 0.083 0.341 0.036 0.115 0.070 0.232 0.12 0.343 0.038 0.088 0.072 0.176 0.115 0.264 0.059 0.122 0.12 0.242 0.197 0.354 0.040 0.061 0.079 0.124 0.12 0.185 0.048 0.068 0.095 0.137 0.146 0.203s0.113 0.124 0.165 0.192c0.077 0.1 0.165 0.185 0.258 0.267 0.109 0.095 0.219 0.185 0.332 0.273 0.079 0.061 0.16 0.122 0.244 0.174 0.113 0.068 0.228 0.133 0.343 0.192 0.101 0.052 0.203 0.101 0.309 0.145 0.099 0.040 0.201 0.072 0.303 0.108 0.059 0.021 0.115 0.039 0.174 0.054 0.074 0.018 0.151 0.031 0.223 0.050 0.077 0.018 0.151 0.039 0.23 0.043 0.005 0 0.011 0 0.016 0.002 0.066 0.014 0.133 0.030 0.199 0.036 0.106 0.011 0.212 0.018 0.318 0.025 0.079 0.002 0.156 0 0.23 0z' }),
	                        _react2['default'].createElement('path', { d: 'M8.032 12.809c-0.014 0.018-0.027 0.030-0.031 0.045-0.025 0.076-0.048 0.155-0.072 0.232-0.059 0.181-0.122 0.361-0.183 0.544-0.029 0.088-0.059 0.178-0.088 0.267-0.040 0.122-0.083 0.242-0.127 0.364-0.027 0.081-0.052 0.165-0.079 0.246-0.027 0.079-0.056 0.155-0.083 0.235-0.040 0.12-0.079 0.242-0.12 0.361-0.027 0.084-0.059 0.162-0.085 0.246-0.018 0.056-0.032 0.117-0.050 0.174-0.032 0.097-0.066 0.192-0.099 0.287-0.003 0.007-0.005 0.016-0.007 0.025-0.009 0.039-0.036 0.086-0.074 0.086l-0.074 0.005c-0.063 0-0.066-0.050-0.101-0.101-0.007-0.011-0.011-0.018-0.018-0.030-0.083-0.133-0.151-0.28-0.21-0.425-0.066-0.162-0.136-0.322-0.203-0.483-0.045-0.106-0.088-0.212-0.136-0.316-0.025-0.052-0.059-0.1-0.095-0.145-0.048-0.056-0.138-0.068-0.207-0.040-0.106 0.040-0.192 0.113-0.289 0.169-0.085 0.050-0.169 0.104-0.255 0.155-0.117 0.070-0.234 0.142-0.354 0.212-0.117 0.068-0.232 0.137-0.354 0.198-0.109 0.054-0.194 0.005-0.244-0.084 0-0.054-0.005-0.108 0.005-0.16 0.011-0.059 0.038-0.113 0.056-0.171 0.018-0.056 0.032-0.113 0.050-0.167 0.029-0.091 0.059-0.181 0.088-0.271 0.029-0.086 0.059-0.171 0.085-0.258 0.018-0.059 0.032-0.12 0.050-0.178 0.022-0.075 0.050-0.149 0.074-0.223 0.022-0.068 0.040-0.137 0.063-0.206 0.018-0.056 0.038-0.111 0.056-0.165s0.034-0.108 0.052-0.16c0.021-0.061 0.040-0.124 0.061-0.185 0.027-0.086 0.052-0.171 0.079-0.258 0.018-0.056 0.038-0.111 0.056-0.167 0.009-0.030 0.018-0.059 0.027-0.086 0.054-0.174 0.109-0.348 0.165-0.519 0.029-0.092 0.059-0.188 0.090-0.28 0.018-0.054 0.045-0.108 0.083-0.153 0.027-0.031 0.063-0.050 0.104-0.059 0.083-0.016 0.167-0.023 0.253-0.023 0.054 0 0.109-0.007 0.162-0.007 0.122 0.002 0.246 0.005 0.368 0.011 0.081 0.005 0.16 0.027 0.239 0.034 0.093 0.007 0.155 0.063 0.228 0.106 0.117 0.070 0.232 0.14 0.352 0.203 0.081 0.040 0.171 0.068 0.255 0.101 0.115 0.047 0.237 0.072 0.359 0.086 0.142 0.016 0.284 0.018 0.425-0.009 0.084-0.016 0.165-0.030 0.246-0.056 0.088-0.030 0.176-0.061 0.262-0.101 0.079-0.036 0.153-0.075 0.228-0.117 0.091-0.054 0.178-0.113 0.264-0.171 0.088-0.061 0.176-0.12 0.282-0.137 0.075-0.011 0.151-0.014 0.226-0.014 0.108-0.002 0.214 0.023 0.321 0.040 0.011 0.002 0.023 0.005 0.034 0.005 0.084 0.009 0.167 0.021 0.253 0.027 0.081 0.007 0.137 0.050 0.171 0.12 0.025 0.050 0.043 0.104 0.052 0.16 0.011 0.072 0.036 0.145 0.056 0.214 0.023 0.075 0.047 0.151 0.070 0.226 0.030 0.088 0.059 0.174 0.088 0.259 0.018 0.052 0.034 0.104 0.052 0.158 0.021 0.061 0.040 0.12 0.061 0.181 0.018 0.052 0.034 0.106 0.050 0.158 0.030 0.091 0.059 0.181 0.086 0.271 0.025 0.081 0.050 0.162 0.076 0.243s0.056 0.16 0.081 0.242c0.025 0.079 0.047 0.158 0.072 0.237 0.021 0.066 0.045 0.129 0.066 0.192 0.018 0.059 0.034 0.12 0.050 0.178 0.007 0.025 0.016 0.050 0.025 0.076 0.021 0.068 0.040 0.136 0.066 0.201 0.034 0.1 0.068 0.197 0.104 0.293 0.011 0.030 0.025 0.061 0.030 0.092 0.007 0.036 0.002 0.075-0.016 0.108-0.052 0.091-0.142 0.14-0.258 0.092-0.075-0.030-0.14-0.079-0.21-0.117-0.12-0.068-0.237-0.136-0.354-0.207-0.113-0.068-0.226-0.137-0.336-0.207-0.092-0.059-0.183-0.122-0.277-0.178-0.034-0.021-0.072-0.034-0.111-0.040-0.079-0.016-0.145 0.018-0.185 0.084-0.039 0.059-0.068 0.124-0.097 0.188-0.045 0.101-0.085 0.203-0.129 0.304-0.045 0.106-0.095 0.21-0.142 0.316-0.050 0.111-0.1 0.221-0.149 0.332-0.027 0.059-0.052 0.122-0.081 0.178-0.030 0.054-0.075 0.086-0.14 0.091-0.127 0.009-0.188-0.079-0.216-0.169-0.030-0.092-0.061-0.183-0.091-0.275-0.025-0.081-0.050-0.165-0.075-0.246-0.018-0.054-0.039-0.106-0.056-0.16-0.018-0.056-0.034-0.115-0.052-0.174-0.018-0.054-0.036-0.108-0.054-0.162-0.030-0.091-0.056-0.181-0.085-0.271-0.027-0.081-0.056-0.16-0.084-0.242-0.040-0.122-0.076-0.246-0.115-0.368-0.030-0.091-0.061-0.178-0.088-0.268-0.018-0.056-0.031-0.113-0.050-0.167-0.031-0.097-0.066-0.192-0.1-0.287-0.018-0.066-0.040-0.124-0.066-0.194z' }),
	                        _react2['default'].createElement('path', { d: 'M8.005 9.243c-0.097 0-0.197 0.009-0.291-0.002-0.083-0.009-0.167-0.009-0.248-0.036-0.038-0.011-0.079-0.011-0.117-0.018-0.061-0.011-0.12-0.023-0.178-0.039-0.067-0.018-0.133-0.039-0.201-0.059-0.054-0.016-0.109-0.031-0.16-0.052-0.040-0.014-0.083-0.031-0.124-0.050-0.106-0.050-0.215-0.097-0.318-0.151-0.151-0.076-0.293-0.167-0.429-0.268-0.144-0.106-0.28-0.223-0.409-0.345-0.070-0.066-0.131-0.142-0.194-0.214-0.151-0.171-0.28-0.361-0.391-0.559-0.074-0.131-0.14-0.269-0.192-0.41-0.027-0.072-0.056-0.144-0.083-0.216-0.011-0.029-0.018-0.059-0.025-0.088-0.016-0.074-0.029-0.151-0.050-0.223-0.038-0.142-0.054-0.289-0.066-0.436-0.011-0.128-0.007-0.26-0.003-0.391 0.005-0.109 0.018-0.219 0.032-0.327 0.009-0.077 0.025-0.151 0.043-0.226 0.016-0.070 0.038-0.136 0.059-0.203 0.016-0.059 0.032-0.117 0.050-0.174 0.022-0.066 0.050-0.128 0.077-0.194 0.056-0.136 0.124-0.264 0.199-0.391 0.099-0.167 0.212-0.325 0.338-0.476 0.117-0.138 0.242-0.268 0.379-0.388 0.154-0.133 0.314-0.252 0.487-0.357 0.117-0.072 0.237-0.14 0.361-0.194 0.124-0.057 0.248-0.115 0.383-0.151 0.061-0.016 0.12-0.041 0.181-0.058 0.043-0.011 0.085-0.018 0.131-0.027 0.050-0.011 0.097-0.022 0.144-0.034 0.005-0.002 0.011-0.005 0.016-0.005 0.077-0.009 0.154-0.018 0.23-0.025 0.027-0.002 0.054-0.007 0.081-0.009 0.146-0.021 0.296-0.014 0.443-0.011 0.1 0.002 0.197 0.011 0.296 0.022 0.066 0.007 0.129 0.025 0.194 0.038 0.050 0.009 0.1 0.016 0.149 0.027 0.039 0.007 0.076 0.016 0.115 0.027 0.036 0.011 0.072 0.027 0.111 0.036 0.122 0.027 0.235 0.076 0.348 0.127 0.101 0.043 0.203 0.095 0.3 0.147 0.085 0.045 0.169 0.095 0.251 0.147 0.146 0.095 0.282 0.201 0.413 0.316 0.095 0.081 0.185 0.169 0.268 0.262 0.124 0.14 0.242 0.284 0.343 0.444 0.081 0.128 0.162 0.258 0.226 0.395 0.054 0.115 0.108 0.232 0.146 0.354 0.023 0.067 0.045 0.136 0.068 0.203 0.011 0.040 0.021 0.083 0.030 0.124 0.014 0.054 0.025 0.106 0.039 0.16 0 0.003 0 0.005 0.002 0.005 0.009 0.059 0.018 0.117 0.025 0.176 0.009 0.085 0.018 0.171 0.021 0.258 0.002 0.117 0.009 0.234-0.002 0.352-0.009 0.090-0.005 0.183-0.034 0.271-0.002 0.005-0.002 0.011-0.002 0.016-0.002 0.095-0.027 0.188-0.050 0.28-0.039 0.154-0.088 0.304-0.149 0.452-0.043 0.101-0.086 0.205-0.14 0.303-0.054 0.099-0.111 0.199-0.174 0.293-0.070 0.106-0.145 0.21-0.226 0.307s-0.171 0.187-0.262 0.278c-0.084 0.086-0.171 0.167-0.268 0.239-0.092 0.068-0.185 0.133-0.28 0.197-0.075 0.050-0.153 0.097-0.232 0.14-0.12 0.066-0.239 0.129-0.368 0.174-0.070 0.025-0.137 0.056-0.207 0.079-0.056 0.021-0.115 0.034-0.174 0.050-0.050 0.014-0.101 0.027-0.151 0.039-0.036 0.009-0.075 0.018-0.111 0.025-0.079 0.014-0.16 0.018-0.239 0.034-0.149 0.027-0.289 0.014-0.429 0.016zM7.222 6.937c-0.021-0.018-0.040-0.032-0.056-0.048-0.167-0.167-0.334-0.334-0.501-0.503-0.122-0.122-0.248-0.244-0.368-0.368-0.048-0.050-0.099-0.067-0.167-0.067-0.090 0-0.171 0.088-0.178 0.176-0.005 0.056 0.016 0.104 0.056 0.144 0.142 0.142 0.282 0.285 0.425 0.426 0.128 0.128 0.26 0.258 0.391 0.386 0.093 0.090 0.183 0.183 0.273 0.273 0.072 0.072 0.183 0.072 0.258-0.003 0.066-0.063 0.131-0.128 0.194-0.194 0.162-0.16 0.322-0.321 0.483-0.483 0.194-0.197 0.39-0.393 0.585-0.587 0.167-0.167 0.334-0.332 0.501-0.497 0.198-0.199 0.397-0.399 0.596-0.598 0.079-0.079 0.158-0.16 0.239-0.242 0.066-0.066 0.075-0.14 0.036-0.221-0.023-0.048-0.061-0.085-0.115-0.097-0.084-0.013-0.158-0.003-0.221 0.066-0.066 0.072-0.137 0.14-0.207 0.21-0.181 0.181-0.364 0.364-0.544 0.544s-0.361 0.359-0.54 0.54c-0.158 0.158-0.316 0.318-0.474 0.476-0.155 0.155-0.314 0.311-0.47 0.467-0.066 0.066-0.128 0.131-0.194 0.199z' })
	                    );
	                case 'genuine-reviews':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M11.8 4.3l-1.5-1.7 0.4-0.4 1.1 0.8 2-1.7 0.4 0.4-2.4 2.6zM15.3 0h-6c-0.4 0-0.7 0.3-0.7 0.7v4.1c0 0.4 0.3 0.7 0.7 0.7h1.2v1.8l2.2-1.8h2.6c0.4 0 0.7-0.3 0.7-0.7v-4.1c0-0.4-0.3-0.7-0.7-0.7v0z' }),
	                        _react2['default'].createElement('path', { d: 'M8.7 8.5h-0.5l-2.7 5.9 1-5.4-1.3-1.4-1.3 1.4 1 5.4-2.7-5.9h-0.5c-1.7 0-1.7 1.3-1.7 2.8v4.7h10.5v-4.7c0-1.5 0-2.8-1.8-2.8v0 0zM2.6 4.8c0-1.5 1.2-2.8 2.6-2.8s2.6 1.2 2.6 2.8c0 1.5-1.2 2.8-2.6 2.8s-2.6-1.3-2.6-2.8v0z' })
	                    );
	                case 'circle-left':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { 'class': 'path1', d: 'M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z' }),
	                        _react2['default'].createElement('path', { 'class': 'path2', d: 'M10.457 4.957l-1.414-1.414-4.457 4.457 4.457 4.457 1.414-1.414-3.043-3.043z' })
	                    );
	                case 'circle-right':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z' }),
	                        _react2['default'].createElement('path', { d: 'M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z' })
	                    );
	                case 'arrow-down':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M16 4.5l-1-1-7 7-7-7-1 1 8 8 8-8z' })
	                    );
	                case 'arrow-up':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M0 11.5l1 1 7-7 7 7 1-1-8-8-8 8z' })
	                    );
	                case 'vf-logo':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { fill: '#0099bc', d: 'M6.969 15.614h-0.106c-0.080 0-0.161-0.007-0.24-0.021l-0.001-0c-0.097-0.017-0.19-0.044-0.274-0.098-0.040-0.026-0.079-0.056-0.109-0.092-0.046-0.056-0.081-0.12-0.099-0.192-0.032-0.127-0.062-0.255-0.092-0.382-0.024-0.103-0.049-0.205-0.070-0.308-0.022-0.105-0.042-0.21-0.061-0.315-0.015-0.085-0.029-0.171-0.042-0.257-0.012-0.088-0.022-0.176-0.032-0.264-0.013-0.112-0.028-0.224-0.039-0.336-0.009-0.085-0.015-0.17-0.021-0.255-0.008-0.117-0.014-0.233-0.020-0.35-0.004-0.080-0.008-0.161-0.010-0.241-0.004-0.163-0.007-0.326-0.009-0.489-0.003-0.39-0.005-0.779-0.008-1.169-0.001-0.118-0.003-0.235-0.003-0.353-0.001-0.202-0.003-0.403 0.010-0.604 0-0.003 0-0.007 0-0.011 0.007-0.076 0.014-0.153 0.019-0.229 0.005-0.075 0.007-0.15 0.011-0.225 0-0.005 0-0.011 0.001-0.016 0.006-0.068 0.014-0.135 0.019-0.203 0.005-0.063 0.007-0.125 0.011-0.188 0.003-0.040 0.006-0.080 0.010-0.12 0.010-0.088 0.020-0.176 0.030-0.264 0.008-0.071 0.011-0.142 0.022-0.213 0.018-0.12 0.040-0.239 0.060-0.358 0.023-0.144 0.059-0.284 0.096-0.424 0.021-0.078 0.047-0.155 0.067-0.234 0.041-0.161 0.078-0.322 0.118-0.483 0.055-0.219 0.112-0.438 0.167-0.657 0.066-0.263 0.13-0.526 0.197-0.789 0.062-0.243 0.128-0.484 0.19-0.726 0.074-0.287 0.147-0.575 0.221-0.863 0.044-0.172 0.092-0.343 0.136-0.516 0.045-0.177 0.089-0.355 0.132-0.533 0.020-0.086 0.037-0.173 0.053-0.26 0.016-0.092 0.030-0.185 0.044-0.277 0.013-0.089 0.027-0.179 0.038-0.268 0.009-0.072 0.013-0.146 0.022-0.218 0.015-0.113 0.033-0.226 0.050-0.339 0.017-0.117 0.031-0.234 0.053-0.349 0.030-0.154 0.062-0.309 0.102-0.46 0.034-0.127 0.070-0.255 0.164-0.353 0.005-0.005 0.011-0.007 0.018-0.007v0c0.025 0 0.064 0.005 0.088 0.011l0 0c0.208 0.051 0.39 0.152 0.544 0.305 0.204 0.203 0.339 0.452 0.423 0.728 0.080 0.262 0.11 0.535 0.116 0.809 0.005 0.271-0.013 0.54-0.038 0.809-0.021 0.222-0.040 0.444-0.066 0.665-0.030 0.245-0.063 0.49-0.102 0.734-0.051 0.316-0.108 0.632-0.164 0.947-0.059 0.331-0.119 0.662-0.179 0.993-0.047 0.258-0.093 0.517-0.14 0.775-0.003 0.015 0.012-0.004 0.010 0.022 0.045-0.031 0.168-0.186 0.242-0.245 0.266-0.273 0.526-0.417 0.771-0.568 0.204-0.118 0.317-0.149 0.493-0.214 0.317-0.118 0.64-0.158 0.971-0.087 0.411 0.088 0.758 0.299 1.054 0.603 0.126 0.129 0.237 0.271 0.336 0.423 0.213 0.33 0.442 0.646 0.688 0.95 0.018 0.022 0.038 0.042 0.060 0.060 0.161 0.132 0.322 0.264 0.483 0.396 0.098 0.081 0.179 0.177 0.226 0.299 0.019 0.048 0.023 0.095 0.007 0.143-0.014 0.041-0.025 0.084-0.038 0.125-0.158 0.517 0.006 1.12-0.204 1.617-0.237 0.663-0.557 1.173-0.831 1.587-0.122 0.213-0.379 0.519-0.422 0.567-0.512 0.61-0.383 0.425-0.647 0.701-0.165 0.153-0.442 0.402-0.609 0.522-0.308 0.241-0.611 0.435-0.847 0.573-0.449 0.272-0.811 0.408-1.222 0.589-0.265 0.117-0.542 0.198-0.819 0.278-0.272 0.079-0.551 0.13-0.83 0.175l-0.021 0.003c-0.051 0.008-0.103 0.013-0.155 0.013zM10.628 10.209c0.113-0.015 0.172-0.025 0.256-0.047 0.135-0.035 0.265-0.084 0.389-0.148 0.143-0.074 0.28-0.155 0.403-0.264 0.101-0.089 0.189-0.189 0.263-0.302 0.063-0.097 0.112-0.202 0.151-0.311 0.012-0.034 0.033-0.070 0.020-0.109-0.389-0.198-0.834-0.68-1.084-1.28-0.001 0-0.001 0-0.001 0-0.088 0.013-0.176 0.032-0.261 0.060-0.048 0.016-0.096 0.033-0.144 0.050-0.121 0.045-0.236 0.103-0.345 0.174-0.069 0.045-0.138 0.090-0.2 0.146-0.059 0.053-0.123 0.102-0.181 0.157-0.042 0.040-0.080 0.085-0.117 0.13-0.062 0.077-0.124 0.155-0.181 0.236-0.114 0.163-0.198 0.343-0.275 0.528-0.060 0.144-0.109 0.293-0.14 0.445-0.006 0.029-0.008 0.059 0 0.092 0.013 0.011 0.031 0.027 0.050 0.040 0.089 0.058 0.177 0.118 0.268 0.171 0.078 0.045 0.158 0.091 0.242 0.122 0.197 0.074 0.4 0.118 0.611 0.118z' }),
	                        _react2['default'].createElement('path', { fill: '#0099bc', d: 'M5.841 15.697c-0.007-0.011-0.015-0.022-0.021-0.034-0.48-0.957-0.912-1.936-1.279-2.946-0.254-0.7-0.494-1.405-0.719-2.116-0.159-0.501-0.316-1.003-0.467-1.507-0.235-0.781-0.452-1.569-0.66-2.358-0.039-0.147-0.077-0.295-0.116-0.442-0.005-0.021-0.007-0.027-0.013-0.056-0.007-0.046-0.008-0.048-0.008-0.070 0.059-0.007 0.119-0.013 0.178-0.021 0.26-0.033 0.488 0.041 0.685 0.218 0.158 0.142 0.274 0.317 0.372 0.506 0.122 0.237 0.203 0.491 0.27 0.75 0.090 0.345 0.149 0.696 0.201 1.048 0.042 0.28 0.085 0.561 0.127 0.841 0.035 0.235 0.070 0.471 0.106 0.707 0.095 0.622 0.193 1.243 0.332 1.856 0.114 0.503 0.24 1.003 0.386 1.497 0.171 0.579 0.349 1.156 0.524 1.734z' }),
	                        _react2['default'].createElement('path', { fill: '#fff', d: 'M5.466 12c0.012 0.116 0.015 0.238 0.027 0.355 0.012 0.108 0.020 0.233 0.034 0.341 0.019 0.148 0.018 0.283 0.043 0.43 0.040 0.237-0.007 0.297 0.038 0.534z' }),
	                        _react2['default'].createElement('path', { fill: '#0099bc', d: 'M5.667 14.135c-0.246-0.627-0.303-1.181-0.47-1.836-0.123-0.484-0.233-0.97-0.323-1.462-0.047-0.259-0.091-0.519-0.13-0.78-0.026-0.172-0.041-0.345-0.061-0.518-0.012-0.105-0.026-0.209-0.036-0.314-0.009-0.084-0.013-0.168-0.020-0.252-0.008-0.089-0.019-0.177-0.027-0.266-0.005-0.048-0.006-0.097-0.010-0.145-0.006-0.076-0.013-0.151-0.019-0.227-0.002-0.019 0.001-0.039-0-0.059-0.006-0.087-0.013-0.174-0.019-0.261-0.001-0.021 0.003-0.043 0-0.063-0.015-0.128-0.002-0.257-0.014-0.384-0.009-0.103-0.005-0.205-0.005-0.307-0.002-0.399-0.001-0.799-0.001-1.198 0-0.101-0.001-0.202 0-0.303 0.001-0.078 0.006-0.155 0.009-0.233 0.004-0.107 0.005-0.214 0.010-0.321 0.004-0.073 0.012-0.145 0.018-0.217 0.009-0.108 0.018-0.216 0.028-0.324 0.007-0.081 0.013-0.162 0.021-0.242 0.006-0.058 0.016-0.115 0.023-0.173 0.009-0.079 0.016-0.158 0.025-0.236s0.020-0.157 0.030-0.235c0.010-0.084 0.018-0.168 0.028-0.251 0.012-0.098 0.025-0.197 0.039-0.295 0.021-0.148 0.041-0.297 0.064-0.444 0.029-0.188 0.061-0.376 0.091-0.564 0.010-0.061 0.019-0.122 0.030-0.183 0.008-0.046 0.012-0.045 0.058-0.055 0.080-0.018 0.157-0 0.231 0.027 0.088 0.032 0.161 0.090 0.234 0.149 0.109 0.088 0.186 0.2 0.248 0.325 0.039 0.080 0.065 0.165 0.080 0.253 0.022 0.127 0.040 0.255 0.057 0.382 0.012 0.093 0.021 0.186 0.031 0.28 0.009 0.085 0.020 0.17 0.026 0.255s0.005 0.172 0.011 0.258c0.019 0.252 0.007 0.505 0.007 0.757-0 0.244-0 0.488-0.011 0.732-0.008 0.176 0.001 0.351-0.008 0.527-0.004 0.079-0.014 0.158-0.016 0.237-0.007 0.262-0.074 0.515-0.118 0.771-0.054 0.309-0.109 0.618-0.16 0.928-0.026 0.16-0.046 0.322-0.066 0.484-0.012 0.090-0.020 0.18-0.029 0.27-0.011 0.116-0.020 0.232-0.029 0.348-0.007 0.095-0.014 0.19-0.019 0.286-0.007 0.12-0.014 0.24-0.019 0.36-0.004 0.101-0.004 0.201-0.011 0.302-0.011 0.174-0.005 0.348-0.008 0.522-0.001 0.052-0.001 0.104-0.003 0.155 0.007 0.138-0 0.269 0.005 0.404 0.003 0.092 0.006 0.185 0.010 0.277 0.003 0.073 0.004 0.146 0.009 0.219z' }),
	                        _react2['default'].createElement('path', { fill: '#137395', d: 'M12.911 8.035c-0.898-0.426-1.884-0.285-1.884-0.285s0.164 0.406 0.403 0.689c0.239 0.283 0.299 0.332 0.483 0.47 0.146 0.109 0.198 0.122 0.198 0.122l1.508-0.277c-0.085-0.335-0.707-0.719-0.707-0.719z' })
	                    );
	                case 'tick':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 15.521c-4.327 0-7.85-3.374-7.85-7.522s3.523-7.52 7.85-7.52 7.85 3.374 7.85 7.522-3.52 7.52-7.85 7.52zM8 1.721c-3.644 0-6.609 2.818-6.609 6.281s2.964 6.281 6.609 6.281 6.609-2.818 6.609-6.281-2.964-6.281-6.609-6.281z' }),
	                        _react2['default'].createElement('path', { d: 'M11.52 4l-4.8 4.8-2.24-2.24-1.6 1.6 3.84 3.84 6.4-6.4z' })
	                    );
	                case 'location':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 15.665c-4.41 0-8-3.438-8-7.666s3.59-7.664 8-7.664 8 3.438 8 7.666-3.587 7.664-8 7.664zM8 1.601c-3.714 0-6.735 2.872-6.735 6.401s3.021 6.401 6.735 6.401 6.735-2.872 6.735-6.401-3.021-6.401-6.735-6.401z' }),
	                        _react2['default'].createElement('path', { d: 'M8 2.875c-2.123 0-3.844 1.721-3.844 3.844 0 3.844 3.844 6.406 3.844 6.406s3.844-2.563 3.844-6.406c0-2.123-1.721-3.844-3.844-3.844zM8 7.359c-0.708 0-1.281-0.573-1.281-1.281s0.573-1.281 1.281-1.281c0.708 0 1.281 0.573 1.281 1.281s-0.573 1.281-1.281 1.281z' })
	                    );
	                case 'bubbles':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 15.665c-4.41 0-8-3.438-8-7.666s3.59-7.664 8-7.664 8 3.438 8 7.666-3.587 7.664-8 7.664zM8 1.601c-3.714 0-6.735 2.872-6.735 6.401s3.021 6.401 6.735 6.401 6.735-2.872 6.735-6.401-3.021-6.401-6.735-6.401z' }),
	                        _react2['default'].createElement('path', { d: 'M12.249 11.231c0 0.378 0.216 0.705 0.531 0.864v0.132c-0.088 0.012-0.178 0.019-0.27 0.019-0.565 0-1.073-0.237-1.433-0.616-0.218 0.058-0.448 0.089-0.687 0.089-1.32 0-2.39-0.951-2.39-2.124s1.070-2.124 2.39-2.124c1.32 0 2.39 0.951 2.39 2.124 0 0.459-0.164 0.884-0.443 1.232-0.057 0.123-0.088 0.26-0.088 0.404zM7.469 3.754c2.311 0 4.19 1.499 4.247 3.365-0.408-0.182-0.86-0.278-1.326-0.278-0.793 0-1.542 0.278-2.109 0.782-0.588 0.523-0.912 1.224-0.912 1.973 0 0.371 0.079 0.729 0.23 1.060-0.044 0.001-0.087 0.002-0.131 0.002-0.225 0-0.447-0.014-0.662-0.042-0.912 0.912-2.002 1.076-3.055 1.1v-0.224c0.569-0.279 1.062-0.786 1.062-1.366 0-0.081-0.006-0.16-0.018-0.238-0.961-0.633-1.575-1.6-1.575-2.683 0-1.907 1.902-3.452 4.249-3.452z' })
	                    );
	                case 'circle-checkmark':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM8 14.4c-3.535 0-6.4-2.865-6.4-6.4s2.865-6.4 6.4-6.4c3.535 0 6.4 2.865 6.4 6.4s-2.865 6.4-6.4 6.4z' }),
	                        _react2['default'].createElement('path', { d: 'M12.219 4.458c-3.173 2.402-6.216 5.614-6.216 5.614l-2.193-1.971-0.916 0.933c0.902 0.847 2.99 3.085 3.696 3.924 1.988-3.322 4.055-5.799 6.018-8.065l-0.389-0.435z' })
	                    );
	                case 'mail':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M14.998 3c0.001 0.001 0.001 0.001 0.002 0.002v9.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-9.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 2h-14c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1v0z' }),
	                        _react2['default'].createElement('path', { d: 'M5.831 9.773l-3 2.182c-0.1 0.073-0.216 0.108-0.33 0.108-0.174 0-0.345-0.080-0.455-0.232-0.183-0.251-0.127-0.603 0.124-0.786l3-2.182c0.251-0.183 0.603-0.127 0.786 0.124s0.127 0.603-0.124 0.786z' }),
	                        _react2['default'].createElement('path', { d: 'M13.955 11.831c-0.11 0.151-0.282 0.232-0.455 0.232-0.115 0-0.23-0.035-0.33-0.108l-3-2.182c-0.251-0.183-0.307-0.534-0.124-0.786s0.534-0.307 0.786-0.124l3 2.182c0.251 0.183 0.307 0.535 0.124 0.786z' }),
	                        _react2['default'].createElement('path', { d: 'M13.831 4.955l-5.5 4c-0.099 0.072-0.215 0.108-0.331 0.108s-0.232-0.036-0.331-0.108l-5.5-4c-0.251-0.183-0.307-0.534-0.124-0.786s0.535-0.307 0.786-0.124l5.169 3.759 5.169-3.759c0.251-0.183 0.603-0.127 0.786 0.124s0.127 0.603-0.124 0.786v0z' })
	                    );
	                case 'question-mark':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M9.525 14.458c0 0.851-0.691 1.542-1.542 1.542s-1.542-0.691-1.542-1.542 0.691-1.542 1.542-1.542 1.542 0.691 1.542 1.542z' }),
	                        _react2['default'].createElement('path', { d: 'M7.982 11.379c-0.639 0-1.157-0.518-1.157-1.157v-0.771c0-0.81 0.313-1.539 0.928-2.165 0.455-0.463 1.007-0.81 1.541-1.144 1.098-0.689 1.579-1.060 1.579-1.707 0-0.705-0.407-1.175-0.748-1.447-0.548-0.435-1.309-0.674-2.144-0.674-1.266 0-2.404 0.845-2.77 2.056-0.185 0.612-0.83 0.958-1.441 0.774s-0.958-0.83-0.774-1.441c0.316-1.049 0.973-1.991 1.851-2.654 0.908-0.686 1.993-1.049 3.132-1.049 1.354 0 2.627 0.418 3.581 1.175 1.047 0.831 1.624 1.988 1.624 3.259 0 1.994-1.539 2.961-2.662 3.666-0.942 0.592-1.387 0.919-1.387 1.351v0.771c0 0.639-0.518 1.157-1.157 1.157z' })
	                    );
	                case 'search':
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M16 13.5l-4.695-4.695c0.444-0.837 0.695-1.792 0.695-2.805 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.013 0 1.968-0.252 2.805-0.695l4.695 4.695 2.5-2.5zM2 6c0-2.209 1.791-4 4-4s4 1.791 4 4-1.791 4-4 4-4-1.791-4-4z' })
	                    );
	                default:
	                    return _react2['default'].createElement(
	                        'g',
	                        null,
	                        _react2['default'].createElement('path', { d: 'M7.41 7.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z' })
	                    );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var styles = {
	                fill: DEFAULT_COLOR,
	                verticalAlign: 'middle',
	                width: this.props.size,
	                height: this.props.size
	            };
	
	            var svg = _react2['default'].createElement(
	                'svg',
	                { viewBox: '0 0 16 16', preserveAspectRatio: 'xMidYMid meet', fit: true,
	                    style: this._mergeStyles(styles, this.props.style) },
	                this.renderGraphic()
	            );
	
	            if (this.props.onClick) {
	                return _react2['default'].createElement(
	                    'div',
	                    { onClick: this.props.onClick },
	                    svg
	                );
	            }
	
	            return svg;
	        }
	    }]);
	
	    return Icon;
	})(_react.Component);
	
	exports['default'] = Icon;
	
	Icon.propTypes = {
	    icon: _react2['default'].PropTypes.string.isRequired,
	    size: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    style: _react2['default'].PropTypes.object,
	    onClick: _react2['default'].PropTypes.func
	};
	Icon.defaultProps = { size: '30px' };
	module.exports = exports['default'];

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(693);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _constantsSteps = __webpack_require__(691);
	
	var ProgressBarHeader = (function (_Component) {
	    _inherits(ProgressBarHeader, _Component);
	
	    function ProgressBarHeader() {
	        _classCallCheck(this, ProgressBarHeader);
	
	        _get(Object.getPrototypeOf(ProgressBarHeader.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ProgressBarHeader, [{
	        key: 'getProgressBarItems',
	        value: function getProgressBarItems() {
	            var barItems = [];
	
	            for (var i = _constantsSteps.StepOrder.CONTACT; i < _constantsSteps.StepOrder.FINISH; i++) {
	                if (i === _constantsSteps.StepOrder.FINISH) {
	                    continue;
	                }
	
	                var checkmarkStyle = { fill: 'white' };
	                var item = _react2['default'].createElement(
	                    'div',
	                    { className: 'app__header__progress-item' },
	                    _react2['default'].createElement('div', { className: 'app__header__progress-circle' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__header__progress-text' },
	                        _constantsSteps.BarLabelMap[i]
	                    )
	                );
	
	                if (i <= this.props.stepIndex) {
	                    item = _react2['default'].createElement(
	                        'div',
	                        { className: 'app__header__progress-item' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__header__progress-circle app__header__progress-circle--selected' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'progress-circle__checkmark' },
	                                _react2['default'].createElement(_iconsIcon2['default'], { icon: 'checkmark', size: '25px', style: checkmarkStyle })
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__header__progress-text' },
	                            _constantsSteps.BarLabelMap[i]
	                        )
	                    );
	                }
	
	                barItems.push(item);
	            }
	            return barItems;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__header__progress' },
	                this.getProgressBarItems()
	            );
	        }
	    }]);
	
	    return ProgressBarHeader;
	})(_react.Component);
	
	exports['default'] = ProgressBarHeader;
	
	ProgressBarHeader.propTypes = {
	    stepIndex: _react2['default'].PropTypes.number
	};
	module.exports = exports['default'];

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var ASSET_URL = 'https://assets.vouchedfor.co.uk/img/';
	var LogoWhite = ASSET_URL + 'vf2023/logo-white.png';
	
	exports.LogoWhite = LogoWhite;
	var dmIcon = ASSET_URL + 'vf2023/home/Daily_Mail_Logo_Navy.png';
	exports.dmIcon = dmIcon;
	var guardianIcon = ASSET_URL + 'vf2023/home/The_Guardian_Logo_Navy.png';
	exports.guardianIcon = guardianIcon;
	var independentIcon = ASSET_URL + 'vf2023/home/Independent_Logo_Navy.png';
	exports.independentIcon = independentIcon;
	var itvIcon = ASSET_URL + 'vf2023/home/ITV_Logo_Navy.png';
	exports.itvIcon = itvIcon;
	var sundaytimesIcon = ASSET_URL + 'vf2023/home/The_Sunday_Times_Navy.png';
	exports.sundaytimesIcon = sundaytimesIcon;
	var timIcon = ASSET_URL + 'home/tim-w.png';
	exports.timIcon = timIcon;

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(545);
	
	var _reactRouter = __webpack_require__(693);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _servicesEventHandler = __webpack_require__(544);
	
	var EventHandler = _interopRequireWildcard(_servicesEventHandler);
	
	var _constantsSteps = __webpack_require__(691);
	
	var NavigationControl = (function (_Component) {
	    _inherits(NavigationControl, _Component);
	
	    function NavigationControl() {
	        _classCallCheck(this, NavigationControl);
	
	        _get(Object.getPrototypeOf(NavigationControl.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(NavigationControl, [{
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit(handler) {
	            if (!this.props.canSubmit) {
	                return;
	            }
	
	            handler();
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            _reactRouter.browserHistory.goBack();
	        }
	    }, {
	        key: 'submitData',
	        value: function submitData() {
	            this.props.actions.submit(this.props.person.getDataAsJSON(), 'finish');
	            EventHandler.track('Clicked Send Message', {
	                category: 'Message page'
	            });
	        }
	
	        /* eslint indent: 0 */
	    }, {
	        key: 'renderForwardButton',
	        value: function renderForwardButton() {
	            var text = undefined;
	            var handleActionFunction = undefined;
	
	            switch (this.props.stepIndex) {
	                case _constantsSteps.StepOrder.SEND_MESSAGE:
	                    text = 'Send';
	                    handleActionFunction = this.submitData;
	                    break;
	                default:
	                    return '';
	            }
	
	            return _react2['default'].createElement(
	                'button',
	                { className: 'big-button vouchedfor-brand', refs: 'next', name: 'next',
	                    onClick: this.handleFormSubmit.bind(this, handleActionFunction.bind(this)) },
	                text
	            );
	        }
	    }, {
	        key: 'renderSecondaryButton',
	        value: function renderSecondaryButton() {
	            if (this.props.stepIndex >= _constantsSteps.StepOrder.SEND_MESSAGE && this.props.stepIndex < _constantsSteps.StepOrder.FINISH) {
	                return _react2['default'].createElement(
	                    'button',
	                    { className: 'big-button back vouchedfor-brand',
	                        onClick: this.goBack.bind(this), type: 'button' },
	                    'Previous'
	                );
	            }
	
	            return null;
	        }
	    }, {
	        key: 'renderRequiredNotification',
	        value: function renderRequiredNotification() {
	            if (!this.props.invalidSubmit) {
	                return null;
	            }
	
	            var requiredMessage = 'Please fill the required fields or delete any you don\'t want to include';
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__page-error small' },
	                requiredMessage
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // Don't render if < 0 or 'null' or 'undefined'
	            /* eslint eqeqeq: 0 */
	            if (this.props.stepIndex < 0 || this.props.stepIndex == null || this.props.stepIndex === _constantsSteps.StepOrder.FINISH) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            return _react2['default'].createElement(
	                'section',
	                { className: 'app__main-section app__main-section__actions--alignment' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__main-section__actions' },
	                    this.renderSecondaryButton(),
	                    this.renderForwardButton(),
	                    this.renderRequiredNotification()
	                ),
	                this.props.stepIndex === _constantsSteps.StepOrder.SEND_MESSAGE && _react2['default'].createElement(
	                    'div',
	                    { className: 'contact-link push-down-50 push-up-30' },
	                    'Not ready to contact anyone yet? Give us a call on ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'tel:02031110583' },
	                        '0203 111 0583'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NavigationControl;
	})(_react.Component);
	
	exports.NavigationControl = NavigationControl;
	
	NavigationControl.propTypes = {
	    person: _react2['default'].PropTypes.object,
	    stepIndex: _react2['default'].PropTypes.number,
	    actions: _react2['default'].PropTypes.object,
	
	    canSubmit: _react2['default'].PropTypes.bool,
	    invalidSubmit: _react2['default'].PropTypes.bool
	};
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	
	        stepIndex: state.navigation.get('stepIndex'),
	        title: state.navigation.get('title'),
	
	        canSubmit: state.navigation.get('canSubmit'),
	        invalidSubmit: state.navigation.get('invalidSubmit')
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavigationControl);

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementsCounter = __webpack_require__(803);
	
	var _elementsCounter2 = _interopRequireDefault(_elementsCounter);
	
	var _contentStepContent = __webpack_require__(690);
	
	var _constantsSteps = __webpack_require__(691);
	
	var _constantsAdviceArea = __webpack_require__(686);
	
	var PageInstruction = (function (_Component) {
	    _inherits(PageInstruction, _Component);
	
	    function PageInstruction() {
	        _classCallCheck(this, PageInstruction);
	
	        _get(Object.getPrototypeOf(PageInstruction.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(PageInstruction, [{
	        key: 'render',
	        value: function render() {
	            /* eslint eqeqeq: 0 */
	            if (this.props.stepIndex == null) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            var title = _contentStepContent.PageInstructions[this.props.stepIndex].title;
	            var subtitle = _contentStepContent.PageInstructions[this.props.stepIndex].subtitle;
	
	            if (this.props.stepIndex === _constantsSteps.StepOrder.CONTACT && this.props.adviceArea) {
	                title = _react2['default'].createElement(
	                    'span',
	                    null,
	                    'Great news! We have ',
	                    _react2['default'].createElement(_elementsCounter2['default'], { from: 0, to: _constantsAdviceArea.AdviceAreaStats[this.props.adviceArea], delay: 51, speed: 900,
	                        className: 'green' }),
	                    ' advisers across the UK who can help with ',
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'line' },
	                        ' ',
	                        _constantsAdviceArea.AdviceArea[this.props.adviceArea],
	                        ' advice.'
	                    )
	                );
	                subtitle = '';
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__page-title__container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__page-title' },
	                    title
	                ),
	                _react2['default'].createElement('div', { className: 'push-down-10', dangerouslySetInnerHTML: { __html: subtitle } })
	            );
	        }
	    }]);
	
	    return PageInstruction;
	})(_react.Component);
	
	exports['default'] = PageInstruction;
	
	PageInstruction.propTypes = {
	    stepIndex: _react2['default'].PropTypes.number,
	
	    adviceArea: _react2['default'].PropTypes.number
	};
	module.exports = exports['default'];

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Counter = (function (_Component) {
	    _inherits(Counter, _Component);
	
	    function Counter(props) {
	        _classCallCheck(this, Counter);
	
	        _get(Object.getPrototypeOf(Counter.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            counter: props.from || 0
	        };
	    }
	
	    _createClass(Counter, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.start(this.props);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clear();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.to !== nextProps.to) {
	                this.start(nextProps);
	            }
	        }
	    }, {
	        key: 'start',
	        value: function start(props) {
	            var _this = this;
	
	            this.clear();
	            this.setState({ counter: this.props.from || 0 }, function () {
	                var delay = _this.props.delay || 100;
	                _this.loopsCounter = 0;
	                _this.loops = Math.ceil(props.speed / delay);
	                _this.increment = (props.to - _this.state.counter) / _this.loops;
	                _this.interval = setInterval(_this.next.bind(_this, props), delay);
	            });
	        }
	    }, {
	        key: 'next',
	        value: function next(props) {
	            if (this.loopsCounter < this.loops) {
	                this.loopsCounter++;
	                this.setState({
	                    counter: this.state.counter + this.increment
	                });
	            } else {
	                this.clear();
	                if (props.onComplete) {
	                    props.onComplete();
	                }
	            }
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'span',
	                { className: this.props.className },
	                this.state.counter.toFixed(this.props.digits)
	            );
	        }
	    }]);
	
	    return Counter;
	})(_react.Component);
	
	exports['default'] = Counter;
	
	Counter.propTypes = {
	    from: _react2['default'].PropTypes.number,
	    to: _react2['default'].PropTypes.number.isRequired,
	    speed: _react2['default'].PropTypes.number.isRequired,
	    delay: _react2['default'].PropTypes.number,
	    onComplete: _react2['default'].PropTypes.func,
	    digits: _react2['default'].PropTypes.number,
	    className: _react2['default'].PropTypes.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(179);
	
	var PageError = (function (_Component) {
	    _inherits(PageError, _Component);
	
	    function PageError() {
	        _classCallCheck(this, PageError);
	
	        _get(Object.getPrototypeOf(PageError.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(PageError, [{
	        key: 'setError',
	        value: function setError() {
	            return { __html: this.props.errorMessage };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.error) {
	                return _react2['default'].createElement('div', null);
	            }
	
	            return _react2['default'].createElement('div', { className: 'app__page-error', dangerouslySetInnerHTML: this.setError() });
	        }
	    }]);
	
	    return PageError;
	})(_react.Component);
	
	exports.PageError = PageError;
	
	PageError.propTypes = {
	    error: _react2['default'].PropTypes.bool,
	    errorMessage: _react2['default'].PropTypes.string
	};
	
	function mapStateToProps(state) {
	    return {
	        error: state.reducer.get('error'),
	        errorMessage: state.reducer.get('errorMessage')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(PageError);

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _servicesWindowEventsHandler = __webpack_require__(795);
	
	var _servicesWindowEventsHandler2 = _interopRequireDefault(_servicesWindowEventsHandler);
	
	var _landingControlSection = __webpack_require__(806);
	
	var _landingControlSection2 = _interopRequireDefault(_landingControlSection);
	
	var _landingHowItWorks = __webpack_require__(839);
	
	var _landingHowItWorks2 = _interopRequireDefault(_landingHowItWorks);
	
	var _landingAdviserInfo = __webpack_require__(841);
	
	var _landingAdviserInfo2 = _interopRequireDefault(_landingAdviserInfo);
	
	var _landingVerifiedDetails = __webpack_require__(847);
	
	var _landingVerifiedDetails2 = _interopRequireDefault(_landingVerifiedDetails);
	
	var _sharedAboutUs = __webpack_require__(849);
	
	var _sharedAboutUs2 = _interopRequireDefault(_sharedAboutUs);
	
	var _sharedAsFeaturedIn = __webpack_require__(850);
	
	var _sharedAsFeaturedIn2 = _interopRequireDefault(_sharedAsFeaturedIn);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	/* Load hero banner images for all sizes */
	__webpack_require__(852);
	__webpack_require__(853);
	
	var LandingPage = (function (_Component) {
	    _inherits(LandingPage, _Component);
	
	    function LandingPage() {
	        _classCallCheck(this, LandingPage);
	
	        _get(Object.getPrototypeOf(LandingPage.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(LandingPage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var query = this.props.location ? this.props.location.query : {};
	            this.props.actions.reset(query);
	            this.props.actions.initialiseUrlQueryData(query);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _servicesWindowEventsHandler2['default'].disableUnloadMessage();
	        }
	
	        /* eslint no-undef: 0 */
	    }, {
	        key: 'scrollToForm',
	        value: function scrollToForm() {
	            if (!this.props.canSubmit) {
	                var formAnchor = document.getElementById('form-anchor');
	
	                $('html, body').animate({
	                    scrollTop: $(formAnchor).offset().top
	                }, 700);
	            } else {
	                _reactRouter.browserHistory.push('contact');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'landing-page push-down-30' },
	                _react2['default'].createElement(_landingControlSection2['default'], { scrollToForm: this.scrollToForm.bind(this) }),
	                _react2['default'].createElement(_landingHowItWorks2['default'], null),
	                _react2['default'].createElement(_landingVerifiedDetails2['default'], null),
	                _react2['default'].createElement(_landingAdviserInfo2['default'], { scrollToForm: this.scrollToForm.bind(this) }),
	                _react2['default'].createElement(_sharedAsFeaturedIn2['default'], null),
	                _react2['default'].createElement(_sharedAboutUs2['default'], null)
	            );
	        }
	    }]);
	
	    return LandingPage;
	})(_react.Component);
	
	exports.LandingPage = LandingPage;
	
	LandingPage.propTypes = {
	    canSubmit: _react2['default'].PropTypes.bool,
	    actions: _react2['default'].PropTypes.object
	};
	
	function mapStateToProps(state) {
	    return {
	        canSubmit: state.navigation.get('canSubmit')
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LandingPage);

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _wrapperVersionWrapper = __webpack_require__(807);
	
	var _Form = __webpack_require__(808);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _elementsFilterSelector = __webpack_require__(838);
	
	var _elementsFilterSelector2 = _interopRequireDefault(_elementsFilterSelector);
	
	var _constantsDefaultServices = __webpack_require__(687);
	
	var _contentHeadlineContent = __webpack_require__(688);
	
	var _servicesEventHandler = __webpack_require__(544);
	
	var EventHandler = _interopRequireWildcard(_servicesEventHandler);
	
	var ControlSection = (function (_Component) {
	    _inherits(ControlSection, _Component);
	
	    function ControlSection() {
	        _classCallCheck(this, ControlSection);
	
	        _get(Object.getPrototypeOf(ControlSection.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ControlSection, [{
	        key: 'getHeadlineContent',
	        value: function getHeadlineContent() {
	            var content = _contentHeadlineContent.DEFAULT_HEADLINE_CONTENT;
	
	            if (this.props.adviserType || this.props.consumerLocation) {
	                content = (0, _contentHeadlineContent.getHeadlineContentFromQuery)(this.props.adviserType, this.props.consumerLocation);
	            }
	
	            return content;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.WrappedForm = (0, _wrapperVersionWrapper.Wrapped)(this.controlForm(), this.experimentForm());
	        }
	    }, {
	        key: 'handleFilterClick',
	        value: function handleFilterClick(adviceArea, needName, key) {
	            EventHandler.track('Clicked Need Button', {
	                category: 'Landing Page',
	                label: needName
	            });
	
	            this.props.actions.updatePersonAttribute('adviceArea', adviceArea);
	            if (key) {
	                this.props.actions.updatePersonAttribute('needKey', key);
	            }
	
	            _reactRouter.browserHistory.push('match');
	        }
	    }, {
	        key: 'renderBanner',
	        value: function renderBanner() {
	            var content = this.getHeadlineContent();
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'banner-info' },
	                _react2['default'].createElement(
	                    'h1',
	                    { className: 'hero-banner__header hidden-mobile' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'line' },
	                        content.headline.firstLine,
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'line' },
	                        content.headline.secondLine
	                    )
	                ),
	                _react2['default'].createElement(
	                    'h1',
	                    { className: 'hero-banner__header mobile-only' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'line' },
	                        content.headline.mobile.firstLine,
	                        ' '
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'line' },
	                        content.headline.mobile.secondLine
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'hero-banner__subtitle' },
	                    'With more than ',
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'semi-bold' },
	                        '5,000'
	                    ),
	                    ' advisers and',
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'semi-bold' },
	                        ' 60,000'
	                    ),
	                    ' reviews, VouchedFor is home to the UK\'s top mortgage advisers. Simply tell us a little bit about you, and we\'ll find the perfect adviser to help with your mortgage.'
	                )
	            );
	        }
	    }, {
	        key: 'controlForm',
	        value: function controlForm() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'hero-banner__down matching' },
	                _react2['default'].createElement('div', { id: 'form-anchor' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'banner-form' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'banner-form__container' },
	                        _react2['default'].createElement(
	                            'h2',
	                            null,
	                            'What are you looking for help with?'
	                        ),
	                        _react2['default'].createElement(_elementsFilterSelector2['default'], { filters: _constantsDefaultServices.DefaultServices,
	                            handleClick: this.handleFilterClick.bind(this) })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'experimentForm',
	        value: function experimentForm() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'hero-banner__down' },
	                _react2['default'].createElement('div', { id: 'form-anchor' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'banner-form' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'banner-form__container' },
	                        _react2['default'].createElement(_Form2['default'], null)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderForm',
	        value: function renderForm() {
	            return _react2['default'].createElement(this.WrappedForm, null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section--full' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__landing-page__full-image hero-banner__image' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'opacity-layer' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__landing-page__hero-banner' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'hero-banner__up' },
	                                this.renderBanner()
	                            ),
	                            this.renderForm()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ControlSection;
	})(_react.Component);
	
	exports.ControlSection = ControlSection;
	
	ControlSection.propTypes = {
	    scrollToForm: _react2['default'].PropTypes.func,
	
	    actions: _react2['default'].PropTypes.object,
	
	    consumerLocation: _react2['default'].PropTypes.string,
	    adviserType: _react2['default'].PropTypes.string,
	    person: _react2['default'].PropTypes.object
	};
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        adviserType: state.reducer.get('adviserType'),
	        consumerLocation: state.reducer.get('consumerLocation'),
	        person: state.reducer.get('person')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ControlSection);

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(179);
	
	var Wrapped = function Wrapped(ControlComponent, ExperimentComponent) {
	    var VersionWrapper = (function (_Component) {
	        _inherits(VersionWrapper, _Component);
	
	        function VersionWrapper(props) {
	            _classCallCheck(this, VersionWrapper);
	
	            _get(Object.getPrototypeOf(VersionWrapper.prototype), 'constructor', this).call(this, props);
	            this.state = { renderExperiment: props.experiment };
	        }
	
	        _createClass(VersionWrapper, [{
	            key: 'render',
	            value: function render() {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    this.state.renderExperiment ? ExperimentComponent : ControlComponent
	                );
	            }
	        }]);
	
	        return VersionWrapper;
	    })(_react.Component);
	
	    function mapStateToProps(state) {
	        return {
	            experiment: state.navigation.get('experiment')
	        };
	    }
	
	    return (0, _reactRedux.connect)(mapStateToProps)(VersionWrapper);
	};
	exports.Wrapped = Wrapped;

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	/* eslint no-unused-vars: 0 */
	
	var _GetQuotesButton = __webpack_require__(809);
	
	var _GetQuotesButton2 = _interopRequireDefault(_GetQuotesButton);
	
	var _elementsEditableInput = __webpack_require__(810);
	
	var _elementsDropdown = __webpack_require__(814);
	
	var _elementsDropdown2 = _interopRequireDefault(_elementsDropdown);
	
	var _elementsMultiSelect = __webpack_require__(816);
	
	var _elementsMultiSelect2 = _interopRequireDefault(_elementsMultiSelect);
	
	var _elementsSelector = __webpack_require__(837);
	
	var _elementsSelector2 = _interopRequireDefault(_elementsSelector);
	
	var _servicesEventHandler = __webpack_require__(544);
	
	var EventHandler = _interopRequireWildcard(_servicesEventHandler);
	
	var _servicesFeatureToggleService = __webpack_require__(546);
	
	var _servicesFeatureToggleService2 = _interopRequireDefault(_servicesFeatureToggleService);
	
	var MORTGAGE_ADVICE_ID = 392;
	var MORTGAGE_PAGE_LINK = 'http://offers.vouchedfor.co.uk/mortgage-adviser/get-free-quote/' + '?utm_source=discover&utm_medium=button&utm_campaign=redirect';
	
	var Form = (function (_Component) {
	    _inherits(Form, _Component);
	
	    function Form() {
	        _classCallCheck(this, Form);
	
	        _get(Object.getPrototypeOf(Form.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Form, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ phone: '' });
	
	            var experiment = JSON.parse(_servicesFeatureToggleService2['default'].instance.getFeatureValue('addMoreServices'));
	            EventHandler.track('Viewed Form', {
	                category: 'Landing Page',
	                label: experiment.name
	            });
	
	            this.addMoreServices = experiment.value;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ phone: nextProps.person.get('phone') });
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
	            this.forceUpdate();
	        }
	
	        // This is necessary due to chrome auto-fill not triggering javascript events
	    }, {
	        key: 'updateAllFieldsBasedOnRefs',
	        value: function updateAllFieldsBasedOnRefs() {
	            this.props.actions.updatePersonAttribute('wealthLevel', this.refs.wealthLevel.getValue());
	        }
	    }, {
	        key: 'submitQuoteRequest',
	        value: function submitQuoteRequest() {
	            if (!this.props.canSubmit) {
	                return;
	            }
	
	            if (this.props.person.get('adviceArea') && this.props.person.get('adviceArea').split(',').length > 1) {
	                var adviceAreas = this.props.person.get('adviceArea').split(',');
	                this.props.actions.updatePersonAttribute('adviceArea', adviceAreas[0]);
	                this.props.actions.updatePersonAttribute('otherAdviceAreas', adviceAreas.slice(1));
	            }
	
	            /* eslint eqeqeq: 0 */
	            if (this.props.person.get('adviceArea') == MORTGAGE_ADVICE_ID) {
	                window.location.href = MORTGAGE_PAGE_LINK;
	                return;
	            }
	
	            this.updateAllFieldsBasedOnRefs();
	
	            _reactRouter.browserHistory.push('contact');
	        }
	    }, {
	        key: 'renderRequiredNotification',
	        value: function renderRequiredNotification() {
	            if (!this.props.invalidSubmit) {
	                return null;
	            }
	
	            var requiredMessage = 'Please fill the required fields';
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__form__page-error' },
	                requiredMessage
	            );
	        }
	    }, {
	        key: 'renderDropdownOrMultiSelect',
	        value: function renderDropdownOrMultiSelect(maxWidthInputs) {
	            if (this.addMoreServices) {
	                var options = [{ value: '391', label: 'Insurance & Protection' }, { value: '396', label: 'Auto Enrolment' }, { value: '397', label: 'Investments & Savings' }, { value: '392', label: 'Mortgages' }, { value: '393', label: 'Pension & Retirement' }, { value: '557', label: 'Pension Transfers - Non Specialist' }, { value: '394', label: 'Equity Release' }, { value: '558', label: 'Inheritance Planning' }, { value: '395', label: 'Annuities' }];
	
	                return _react2['default'].createElement(_elementsMultiSelect2['default'], { name: 'adviceArea',
	                    ref: 'adviceArea',
	                    sublabel: 'You can select more than one service',
	                    value: this.props.person.get('adviceArea'),
	                    options: options,
	                    widthProportion: 'fixed',
	                    invalidSubmit: this.props.invalidSubmit,
	                    handleChange: this.handleChange.bind(this),
	                    fixedWidth: maxWidthInputs,
	                    required: true });
	            }
	
	            return _react2['default'].createElement(_elementsDropdown2['default'], { name: 'adviceArea',
	                ref: 'adviceArea',
	                value: this.props.person.get('adviceArea'),
	                optionsType: 'adviceArea',
	                blankOptionLabel: 'primary advice area',
	                blankOption: true,
	                widthProportion: 'fixed',
	                invalidSubmit: this.props.invalidSubmit,
	                handleChange: this.handleChange.bind(this),
	                fixedWidth: maxWidthInputs,
	                required: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var maxWidthInputs = this.addMoreServices ? '305px' : '280px';
	            var adviceAreaTitle = this.addMoreServices ? 'What are you seeking advice on?' : 'What are you looking for advice on?';
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__form__grid__column' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'hero-banner__form-label__container' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'hero-banner__form-label' },
	                            adviceAreaTitle
	                        )
	                    ),
	                    this.renderDropdownOrMultiSelect(maxWidthInputs)
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__form__grid__column' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'hero-banner__form-label__container' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'hero-banner__form-label' },
	                            'How much are your savings/investments/pensions worth?'
	                        )
	                    ),
	                    _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'wealthLevel',
	                        ref: 'wealthLevel',
	                        placeholder: '£50,000',
	                        value: this.props.person.get('wealthLevel'),
	                        maxLength: 11,
	                        invalidSubmit: this.props.invalidSubmit,
	                        widthProportion: 'fixed',
	                        fixedWidth: maxWidthInputs,
	                        maskType: 'currency',
	                        handleChange: this.handleChange.bind(this),
	                        required: true })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__form__grid__column' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__form__actions' },
	                        _react2['default'].createElement(_GetQuotesButton2['default'], { section: 'Hero Banner',
	                            wording: 'Get Free IFA Quotes',
	                            size: 'big',
	                            handler: this.submitQuoteRequest.bind(this) })
	                    )
	                ),
	                this.renderRequiredNotification()
	            );
	        }
	    }]);
	
	    return Form;
	})(_react.Component);
	
	exports.Form = Form;
	
	Form.propTypes = {
	    canSubmit: _react2['default'].PropTypes.bool,
	    invalidSubmit: _react2['default'].PropTypes.bool,
	
	    actions: _react2['default'].PropTypes.object,
	    person: _react2['default'].PropTypes.object
	};
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        canSubmit: state.navigation.get('canSubmit'),
	        invalidSubmit: state.navigation.get('invalidSubmit'),
	
	        person: state.reducer.get('person')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Form);

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _servicesEventHandler = __webpack_require__(544);
	
	var EventHandler = _interopRequireWildcard(_servicesEventHandler);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var GetQuotesButton = (function (_Component) {
	    _inherits(GetQuotesButton, _Component);
	
	    function GetQuotesButton() {
	        _classCallCheck(this, GetQuotesButton);
	
	        _get(Object.getPrototypeOf(GetQuotesButton.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(GetQuotesButton, [{
	        key: 'onClick',
	        value: function onClick() {
	            if (this.props.handler) {
	                this.props.handler();
	            }
	
	            if (!this.props.canSubmit) {
	                return;
	            }
	
	            EventHandler.track('Clicked Get Your Quotes', {
	                category: 'Landing Page',
	                label: this.props.section
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var className = 'button';
	            if (this.props.size === 'big') {
	                className = 'big-button';
	            }
	
	            return _react2['default'].createElement(
	                'button',
	                { className: className + ' vouchedfor-brand landing-page',
	                    onClick: this.onClick.bind(this) },
	                this.props.wording || 'Find the best adviser for me'
	            );
	        }
	    }]);
	
	    return GetQuotesButton;
	})(_react.Component);
	
	exports.GetQuotesButton = GetQuotesButton;
	
	GetQuotesButton.propTypes = {
	    canSubmit: _react2['default'].PropTypes.bool,
	    handler: _react2['default'].PropTypes.func,
	
	    section: _react2['default'].PropTypes.string,
	    wording: _react2['default'].PropTypes.string,
	
	    actions: _react2['default'].PropTypes.object,
	
	    size: _react2['default'].PropTypes.string
	};
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        canSubmit: state.navigation.get('canSubmit')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GetQuotesButton);

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(780);
	
	var _reactInputMask = __webpack_require__(811);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _FormInput2 = __webpack_require__(812);
	
	var _FormInput3 = _interopRequireDefault(_FormInput2);
	
	var EditableInput = (function (_FormInput) {
	    _inherits(EditableInput, _FormInput);
	
	    function EditableInput() {
	        _classCallCheck(this, EditableInput);
	
	        _get(Object.getPrototypeOf(EditableInput.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(EditableInput, [{
	        key: 'getInputProperties',
	        value: function getInputProperties(className) {
	            return _get(Object.getPrototypeOf(EditableInput.prototype), 'getInputProperties', this).call(this, className);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var className = 'inspectletIgnore ';
	            className += this.props.className ? this.props.className : 'app__editable-input';
	            var inputProperties = this.getInputProperties(className);
	
	            return _react2['default'].createElement(
	                'div',
	                { className: '' + className },
	                this.renderLabel(className),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__editable-input__container-hint' },
	                    _react2['default'].createElement(_reactInputMask2['default'], inputProperties),
	                    this.renderHint()
	                ),
	                this.renderErrorMessage(className)
	            );
	        }
	    }]);
	
	    return EditableInput;
	})(_FormInput3['default']);
	
	exports['default'] = EditableInput;
	
	EditableInput.propTypes = {
	    label: _react2['default'].PropTypes.string,
	    value: _react2['default'].PropTypes.node,
	    type: _react2['default'].PropTypes.string,
	    hintText: _react2['default'].PropTypes.string,
	
	    maskType: _react2['default'].PropTypes.string,
	
	    placeholder: _react2['default'].PropTypes.string,
	    name: _react2['default'].PropTypes.string,
	    handleChange: _react2['default'].PropTypes.func,
	    className: _react2['default'].PropTypes.string,
	    widthProportion: _react2['default'].PropTypes.string,
	    fixedWidth: _react2['default'].PropTypes.string,
	
	    invalidSubmit: _react2['default'].PropTypes.bool
	};
	
	var FormEditableInput = (0, _formsyReact.HOC)(EditableInput);
	exports.FormEditableInput = FormEditableInput;

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/sanniassin/react-input-mask
	
	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(147);
	
	var InputElement = React.createClass({
	    displayName: "InputElement",
	
	    defaultCharsRules: {
	        "9": "[0-9]",
	        "a": "[A-Za-z]",
	        "*": "[A-Za-z0-9]"
	    },
	    defaultMaskChar: "_",
	    lastCaretPos: null,
	    isAndroidBrowser: function () {
	        var windows = new RegExp("windows", "i");
	        var firefox = new RegExp("firefox", "i");
	        var android = new RegExp("android", "i");
	        var ua = navigator.userAgent;
	        return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
	    },
	    isWindowsPhoneBrowser: function () {
	        var windows = new RegExp("windows", "i");
	        var phone = new RegExp("phone", "i");
	        var ua = navigator.userAgent;
	        return windows.test(ua) && phone.test(ua);
	    },
	    isAndroidFirefox: function () {
	        var windows = new RegExp("windows", "i");
	        var firefox = new RegExp("firefox", "i");
	        var android = new RegExp("android", "i");
	        var ua = navigator.userAgent;
	        return !windows.test(ua) && firefox.test(ua) && android.test(ua);
	    },
	    isDOMElement: function (element) {
	        return typeof HTMLElement === "object" ? element instanceof HTMLElement // DOM2
	        : element.nodeType === 1 && typeof element.nodeName === "string";
	    },
	    // getDOMNode is deprecated but we need it to stay compatible with React 0.12
	    getInputDOMNode: function () {
	        var input = this.refs.input;
	
	        if (!input) {
	            return null;
	        }
	
	        // React 0.14
	        if (this.isDOMElement(input)) {
	            return input;
	        }
	
	        return input.getDOMNode();
	    },
	    enableValueAccessors: function () {
	        var _this = this;
	
	        var canUseAccessors = !!(Object.getOwnPropertyDescriptor && Object.getPrototypeOf && Object.defineProperty);
	        if (canUseAccessors) {
	            var input = this.getInputDOMNode();
	            this.valueDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value');
	            Object.defineProperty(input, 'value', {
	                configurable: true,
	                enumerable: true,
	                get: function () {
	                    return _this.value;
	                },
	                set: function (val) {
	                    _this.value = val;
	                    _this.valueDescriptor.set.call(input, val);
	                }
	            });
	        }
	    },
	    disableValueAccessors: function () {
	        var valueDescriptor = this.valueDescriptor;
	
	        if (!valueDescriptor) {
	            return;
	        }
	        this.valueDescriptor = null;
	        var input = this.getInputDOMNode();
	        Object.defineProperty(input, 'value', valueDescriptor);
	    },
	    getInputValue: function () {
	        var input = this.getInputDOMNode();
	        var valueDescriptor = this.valueDescriptor;
	
	        var value;
	        if (valueDescriptor) {
	            value = valueDescriptor.get.call(input);
	        } else {
	            value = input.value;
	        }
	
	        return value;
	    },
	    getPrefix: function () {
	        var prefix = "";
	        var mask = this.mask;
	
	        for (var i = 0; i < mask.length && this.isPermanentChar(i); ++i) {
	            prefix += mask[i];
	        }
	        return prefix;
	    },
	    getFilledLength: function () {
	        var value = arguments.length <= 0 || arguments[0] === undefined ? this.state.value : arguments[0];
	
	        var i;
	        var maskChar = this.maskChar;
	
	        if (!maskChar) {
	            return value.length;
	        }
	
	        for (i = value.length - 1; i >= 0; --i) {
	            var character = value[i];
	            if (!this.isPermanentChar(i) && this.isAllowedChar(character, i)) {
	                break;
	            }
	        }
	
	        return ++i || this.getPrefix().length;
	    },
	    getLeftEditablePos: function (pos) {
	        for (var i = pos; i >= 0; --i) {
	            if (!this.isPermanentChar(i)) {
	                return i;
	            }
	        }
	        return null;
	    },
	    getRightEditablePos: function (pos) {
	        var mask = this.mask;
	
	        for (var i = pos; i < mask.length; ++i) {
	            if (!this.isPermanentChar(i)) {
	                return i;
	            }
	        }
	        return null;
	    },
	    isEmpty: function () {
	        var _this2 = this;
	
	        var value = arguments.length <= 0 || arguments[0] === undefined ? this.state.value : arguments[0];
	
	        return !value.split("").some(function (character, i) {
	            return !_this2.isPermanentChar(i) && _this2.isAllowedChar(character, i);
	        });
	    },
	    isFilled: function () {
	        var value = arguments.length <= 0 || arguments[0] === undefined ? this.state.value : arguments[0];
	
	        return this.getFilledLength(value) === this.mask.length;
	    },
	    createFilledArray: function (length, val) {
	        var array = [];
	        for (var i = 0; i < length; i++) {
	            array[i] = val;
	        }
	        return array;
	    },
	    formatValue: function (value) {
	        var _this3 = this;
	
	        var maskChar = this.maskChar;
	        var mask = this.mask;
	
	        if (!maskChar) {
	            var prefix = this.getPrefix();
	            var prefixLen = prefix.length;
	            value = this.insertRawSubstr("", value, 0);
	            while (value.length > prefixLen && this.isPermanentChar(value.length - 1)) {
	                value = value.slice(0, value.length - 1);
	            }
	
	            if (value.length < prefixLen) {
	                value = prefix;
	            }
	
	            return value;
	        }
	        if (value) {
	            var emptyValue = this.formatValue("");
	            return this.insertRawSubstr(emptyValue, value, 0);
	        }
	        return value.split("").concat(this.createFilledArray(mask.length - value.length, null)).map(function (character, pos) {
	            if (_this3.isAllowedChar(character, pos)) {
	                return character;
	            } else if (_this3.isPermanentChar(pos)) {
	                return mask[pos];
	            }
	            return maskChar;
	        }).join("");
	    },
	    clearRange: function (value, start, len) {
	        var _this4 = this;
	
	        var end = start + len;
	        var maskChar = this.maskChar;
	        var mask = this.mask;
	
	        if (!maskChar) {
	            var prefixLen = this.getPrefix().length;
	            value = value.split("").filter(function (character, i) {
	                return i < prefixLen || i < start || i >= end;
	            }).join("");
	            return this.formatValue(value);
	        }
	        return value.split("").map(function (character, i) {
	            if (i < start || i >= end) {
	                return character;
	            }
	            if (_this4.isPermanentChar(i)) {
	                return mask[i];
	            }
	            return maskChar;
	        }).join("");
	    },
	    replaceSubstr: function (value, newSubstr, pos) {
	        return value.slice(0, pos) + newSubstr + value.slice(pos + newSubstr.length);
	    },
	    insertRawSubstr: function (value, substr, pos) {
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        var isFilled = this.isFilled(value);
	        var prefixLen = this.getPrefix().length;
	        substr = substr.split("");
	
	        if (!maskChar && pos > value.length) {
	            value += mask.slice(value.length, pos);
	        }
	
	        for (var i = pos; i < mask.length && substr.length;) {
	            var isPermanent = this.isPermanentChar(i);
	            if (!isPermanent || mask[i] === substr[0]) {
	                var character = substr.shift();
	                if (this.isAllowedChar(character, i, true)) {
	                    if (i < value.length) {
	                        if (maskChar || isFilled || i < prefixLen) {
	                            value = this.replaceSubstr(value, character, i);
	                        } else {
	                            value = this.formatValue(value.substr(0, i) + character + value.substr(i));
	                        }
	                    } else if (!maskChar) {
	                        value += character;
	                    }
	                    ++i;
	                }
	            } else {
	                if (!maskChar && i >= value.length) {
	                    value += mask[i];
	                } else if (maskChar && isPermanent && substr[0] === maskChar) {
	                    substr.shift();
	                }
	                ++i;
	            }
	        }
	        return value;
	    },
	    getRawSubstrLength: function (value, substr, pos) {
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        substr = substr.split("");
	        for (var i = pos; i < mask.length && substr.length;) {
	            if (!this.isPermanentChar(i) || mask[i] === substr[0]) {
	                var character = substr.shift();
	                if (this.isAllowedChar(character, i, true)) {
	                    ++i;
	                }
	            } else {
	                ++i;
	            }
	        }
	        return i - pos;
	    },
	    isAllowedChar: function (character, pos) {
	        var allowMaskChar = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        if (this.isPermanentChar(pos)) {
	            return mask[pos] === character;
	        }
	        var ruleChar = mask[pos];
	        var charRule = this.charsRules[ruleChar];
	        return new RegExp(charRule).test(character || "") || allowMaskChar && character === maskChar;
	    },
	    isPermanentChar: function (pos) {
	        return this.permanents.indexOf(pos) !== -1;
	    },
	    setCaretToEnd: function () {
	        var filledLen = this.getFilledLength();
	        var pos = this.getRightEditablePos(filledLen);
	        if (pos !== null) {
	            this.setCaretPos(pos);
	        }
	    },
	    setSelection: function (start) {
	        var len = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	        var input = this.getInputDOMNode();
	        if (!input) {
	            return;
	        }
	
	        var end = start + len;
	        if ("selectionStart" in input && "selectionEnd" in input) {
	            input.selectionStart = start;
	            input.selectionEnd = end;
	        } else {
	            var range = input.createTextRange();
	            range.collapse(true);
	            range.moveStart("character", start);
	            range.moveEnd("character", end - start);
	            range.select();
	        }
	    },
	    getSelection: function () {
	        var input = this.getInputDOMNode();
	        var start = 0;
	        var end = 0;
	
	        if ("selectionStart" in input && "selectionEnd" in input) {
	            start = input.selectionStart;
	            end = input.selectionEnd;
	        } else {
	            var range = document.selection.createRange();
	            if (range.parentElement() === input) {
	                start = -range.moveStart("character", -input.value.length);
	                end = -range.moveEnd("character", -input.value.length);
	            }
	        }
	
	        return {
	            start: start,
	            end: end,
	            length: end - start
	        };
	    },
	    getCaretPos: function () {
	        return this.getSelection().start;
	    },
	    setCaretPos: function (pos) {
	        var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (fn) {
	            return setTimeout(fn, 0);
	        };
	
	        var setPos = this.setSelection.bind(this, pos, 0);
	
	        setPos();
	        raf(setPos);
	
	        this.lastCaretPos = pos;
	    },
	    isFocused: function () {
	        return document.activeElement === this.getInputDOMNode();
	    },
	    parseMask: function (mask) {
	        var _this5 = this;
	
	        if (typeof mask !== "string") {
	            return {
	                mask: null,
	                lastEditablePos: null,
	                permanents: []
	            };
	        }
	        var str = "";
	        var permanents = [];
	        var isPermanent = false;
	        var lastEditablePos = null;
	
	        mask.split("").forEach(function (character) {
	            if (!isPermanent && character === "\\") {
	                isPermanent = true;
	            } else {
	                if (isPermanent || !_this5.charsRules[character]) {
	                    permanents.push(str.length);
	                } else {
	                    lastEditablePos = str.length;
	                }
	                str += character;
	                isPermanent = false;
	            }
	        });
	
	        return {
	            mask: str,
	            lastEditablePos: lastEditablePos,
	            permanents: permanents
	        };
	    },
	    getStringValue: function (value) {
	        return !value && value !== 0 ? "" : value + "";
	    },
	    getInitialState: function () {
	        this.hasValue = this.props.value != null;
	        this.charsRules = "formatChars" in this.props ? this.props.formatChars : this.defaultCharsRules;
	
	        var mask = this.parseMask(this.props.mask);
	        var defaultValue = this.props.defaultValue != null ? this.props.defaultValue : '';
	        var value = this.props.value != null ? this.props.value : defaultValue;
	
	        value = this.getStringValue(value);
	
	        this.mask = mask.mask;
	        this.permanents = mask.permanents;
	        this.lastEditablePos = mask.lastEditablePos;
	        this.maskChar = "maskChar" in this.props ? this.props.maskChar : this.defaultMaskChar;
	
	        if (this.mask && (this.props.alwaysShowMask || value)) {
	            value = this.formatValue(value);
	        }
	
	        return { value: value };
	    },
	    componentWillMount: function () {
	        var mask = this.mask;
	        var value = this.state.value;
	
	        if (mask && value) {
	            this.setState({ value: value });
	        }
	    },
	    componentWillReceiveProps: function (nextProps) {
	        this.hasValue = this.props.value != null;
	        this.charsRules = "formatChars" in nextProps ? nextProps.formatChars : this.defaultCharsRules;
	
	        var mask = this.parseMask(nextProps.mask);
	        var isMaskChanged = mask.mask && mask.mask !== this.mask;
	
	        this.mask = mask.mask;
	        this.permanents = mask.permanents;
	        this.lastEditablePos = mask.lastEditablePos;
	        this.maskChar = "maskChar" in nextProps ? nextProps.maskChar : this.defaultMaskChar;
	
	        if (!this.mask) {
	            return;
	        }
	
	        var newValue = nextProps.value != null ? this.getStringValue(nextProps.value) : this.state.value;
	
	        var showEmpty = nextProps.alwaysShowMask || this.isFocused();
	        if (isMaskChanged || mask.mask && (newValue || showEmpty && !this.hasValue)) {
	            newValue = this.formatValue(newValue);
	
	            if (isMaskChanged) {
	                var pos = this.lastCaretPos;
	                var filledLen = this.getFilledLength(newValue);
	                if (filledLen < pos) {
	                    this.setCaretPos(this.getRightEditablePos(filledLen));
	                }
	            }
	        }
	        if (mask.mask && this.isEmpty(newValue) && !showEmpty && !this.hasValue) {
	            newValue = "";
	        }
	        this.value = newValue;
	        if (this.state.value !== newValue) {
	            this.setState({ value: newValue });
	        }
	    },
	    onKeyDown: function (event) {
	        var hasHandler = typeof this.props.onKeyDown === "function";
	        if (event.ctrlKey || event.metaKey) {
	            if (hasHandler) {
	                this.props.onKeyDown(event);
	            }
	            return;
	        }
	
	        var caretPos = this.getCaretPos();
	        var value = this.state.value;
	        var key = event.key;
	        var preventDefault = false;
	        switch (key) {
	            case "Backspace":
	            case "Delete":
	                var prefixLen = this.getPrefix().length;
	                var deleteFromRight = key === "Delete";
	                var selectionRange = this.getSelection();
	                if (selectionRange.length) {
	                    value = this.clearRange(value, selectionRange.start, selectionRange.length);
	                } else if (caretPos < prefixLen || !deleteFromRight && caretPos === prefixLen) {
	                    caretPos = prefixLen;
	                } else {
	                    var editablePos = deleteFromRight ? this.getRightEditablePos(caretPos) : this.getLeftEditablePos(caretPos - 1);
	                    if (editablePos !== null) {
	                        value = this.clearRange(value, editablePos, 1);
	                        caretPos = editablePos;
	                    }
	                }
	                preventDefault = true;
	                break;
	            default:
	                break;
	        }
	
	        if (hasHandler) {
	            this.props.onKeyDown(event);
	        }
	
	        if (value !== this.state.value) {
	            event.target.value = value;
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            });
	            preventDefault = true;
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	        if (preventDefault) {
	            event.preventDefault();
	            this.setCaretPos(caretPos);
	        }
	    },
	    onKeyPress: function (event) {
	        var key = event.key;
	        var hasHandler = typeof this.props.onKeyPress === "function";
	        if (key === "Enter" || event.ctrlKey || event.metaKey) {
	            if (hasHandler) {
	                this.props.onKeyPress(event);
	            }
	            return;
	        }
	
	        if (this.isWindowsPhoneBrowser) {
	            return;
	        }
	
	        var caretPos = this.getCaretPos();
	        var selection = this.getSelection();
	        var value = this.state.value;
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	        var lastEditablePos = this.lastEditablePos;
	
	        var maskLen = mask.length;
	        var prefixLen = this.getPrefix().length;
	
	        if (this.isPermanentChar(caretPos) && mask[caretPos] === key) {
	            value = this.insertRawSubstr(value, key, caretPos);
	            ++caretPos;
	        } else {
	            var editablePos = this.getRightEditablePos(caretPos);
	            if (editablePos !== null && this.isAllowedChar(key, editablePos)) {
	                value = this.clearRange(value, selection.start, selection.length);
	                value = this.insertRawSubstr(value, key, editablePos);
	                caretPos = editablePos + 1;
	            }
	        }
	
	        if (value !== this.state.value) {
	            event.target.value = value;
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            });
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	        event.preventDefault();
	        if (caretPos < lastEditablePos && caretPos > prefixLen) {
	            caretPos = this.getRightEditablePos(caretPos);
	        }
	        this.setCaretPos(caretPos);
	    },
	    onChange: function (event) {
	        var _this6 = this;
	
	        var pasteSelection = this.pasteSelection;
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	        var lastEditablePos = this.lastEditablePos;
	
	        var target = event.target;
	        var value = this.getInputValue();
	        if (!value && this.preventEmptyChange) {
	            this.disableValueAccessors();
	            this.preventEmptyChange = false;
	            target.value = this.state.value;
	            return;
	        }
	        var oldValue = this.state.value;
	        if (pasteSelection) {
	            this.pasteSelection = null;
	            this.pasteText(oldValue, value, pasteSelection, event);
	            return;
	        }
	        var selection = this.getSelection();
	        var caretPos = selection.end;
	        var maskLen = mask.length;
	        var valueLen = value.length;
	        var oldValueLen = oldValue.length;
	        var prefixLen = this.getPrefix().length;
	        var clearedValue;
	
	        if (valueLen > oldValueLen) {
	            var substrLen = valueLen - oldValueLen;
	            var startPos = selection.end - substrLen;
	            var enteredSubstr = value.substr(startPos, substrLen);
	
	            if (startPos < maskLen && (substrLen !== 1 || enteredSubstr !== mask[startPos])) {
	                caretPos = this.getRightEditablePos(startPos);
	            } else {
	                caretPos = startPos;
	            }
	
	            value = value.substr(0, startPos) + value.substr(startPos + substrLen);
	
	            clearedValue = this.clearRange(value, startPos, maskLen - startPos);
	            clearedValue = this.insertRawSubstr(clearedValue, enteredSubstr, caretPos);
	
	            value = this.insertRawSubstr(oldValue, enteredSubstr, caretPos);
	
	            if (substrLen !== 1 || caretPos >= prefixLen && caretPos < lastEditablePos) {
	                caretPos = this.getFilledLength(clearedValue);
	            } else if (caretPos < lastEditablePos) {
	                caretPos++;
	            }
	        } else if (valueLen < oldValueLen) {
	            var removedLen = maskLen - valueLen;
	            clearedValue = this.clearRange(oldValue, selection.end, removedLen);
	            var substr = value.substr(0, selection.end);
	            var clearOnly = substr === oldValue.substr(0, selection.end);
	
	            if (maskChar) {
	                value = this.insertRawSubstr(clearedValue, substr, 0);
	            }
	
	            clearedValue = this.clearRange(clearedValue, selection.end, maskLen - selection.end);
	            clearedValue = this.insertRawSubstr(clearedValue, substr, 0);
	
	            if (!clearOnly) {
	                caretPos = this.getFilledLength(clearedValue);
	            } else if (caretPos < prefixLen) {
	                caretPos = prefixLen;
	            }
	        }
	        value = this.formatValue(value);
	
	        // prevent android autocomplete insertion on backspace
	        // prevent hanging after first entered character on Windows 10 Mobile
	        if (!this.isAndroidBrowser && !this.isWindowsPhoneBrowser) {
	            target.value = value;
	
	            if (value && !this.getInputValue()) {
	                if (this.isAndroidFirefox) {
	                    this.value = value;
	                    this.enableValueAccessors();
	                }
	                this.preventEmptyChange = true;
	                setTimeout(function () {
	                    _this6.preventEmptyChange = false;
	                    _this6.disableValueAccessors();
	                }, 0);
	            }
	        }
	
	        this.setState({
	            value: this.hasValue ? this.state.value : value
	        });
	
	        if (typeof this.props.onChange === "function") {
	            this.props.onChange(event);
	        }
	        this.setCaretPos(caretPos);
	    },
	    onFocus: function (event) {
	        if (!this.state.value) {
	            var prefix = this.getPrefix();
	            var value = this.formatValue(prefix);
	            event.target.value = this.formatValue(value);
	
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            }, this.setCaretToEnd);
	
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        } else if (this.getFilledLength() < this.mask.length) {
	            this.setCaretToEnd();
	        }
	
	        if (typeof this.props.onFocus === "function") {
	            this.props.onFocus(event);
	        }
	    },
	    onBlur: function (event) {
	        if (!this.props.alwaysShowMask && this.isEmpty(this.state.value)) {
	            event.target.value = "";
	            this.setState({
	                value: this.hasValue ? this.state.value : ""
	            });
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	
	        if (typeof this.props.onBlur === "function") {
	            this.props.onBlur(event);
	        }
	    },
	    onPaste: function (event) {
	        if (this.isAndroidBrowser) {
	            this.pasteSelection = this.getSelection();
	            event.target.value = "";
	            return;
	        }
	        var text;
	        if (window.clipboardData && window.clipboardData.getData) {
	            // IE
	            text = window.clipboardData.getData("Text");
	        } else if (event.clipboardData && event.clipboardData.getData) {
	            text = event.clipboardData.getData("text/plain");
	        }
	        if (text) {
	            var value = this.state.value;
	            var selection = this.getSelection();
	            this.pasteText(value, text, selection, event);
	        }
	        event.preventDefault();
	    },
	    pasteText: function (value, text, selection, event) {
	        var caretPos = selection.start;
	        if (selection.length) {
	            value = this.clearRange(value, caretPos, selection.length);
	        }
	        var textLen = this.getRawSubstrLength(value, text, caretPos);
	        value = this.insertRawSubstr(value, text, caretPos);
	        caretPos += textLen;
	        caretPos = this.getRightEditablePos(caretPos) || caretPos;
	        if (value !== this.getInputDOMNode().value) {
	            if (event) {
	                event.target.value = value;
	            }
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            });
	            if (event && typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	        this.setCaretPos(caretPos);
	    },
	    componentDidMount: function () {
	        this.isAndroidBrowser = this.isAndroidBrowser();
	        this.isWindowsPhoneBrowser = this.isWindowsPhoneBrowser();
	        this.isAndroidFirefox = this.isAndroidFirefox();
	    },
	    render: function () {
	        var _this7 = this;
	
	        var ourProps = {};
	        if (this.mask) {
	            var handlersKeys = ["onFocus", "onBlur", "onChange", "onKeyDown", "onKeyPress", "onPaste"];
	            handlersKeys.forEach(function (key) {
	                ourProps[key] = _this7[key];
	            });
	            ourProps.value = this.state.value;
	        }
	        return React.createElement("input", _extends({ ref: "input" }, this.props, ourProps));
	    }
	});
	
	module.exports = InputElement;

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpersStringFormatHelper = __webpack_require__(685);
	
	var _helpersStringFormatHelper2 = _interopRequireDefault(_helpersStringFormatHelper);
	
	var _helpersDateInputMaskHelper = __webpack_require__(813);
	
	var _helpersDateInputMaskHelper2 = _interopRequireDefault(_helpersDateInputMaskHelper);
	
	var FormInput = (function (_Component) {
	    _inherits(FormInput, _Component);
	
	    function FormInput(props) {
	        _classCallCheck(this, FormInput);
	
	        _get(Object.getPrototypeOf(FormInput.prototype), 'constructor', this).call(this, props);
	        var state = {} || this.state;
	        state.value = this.props.value;
	        this.state = state;
	    }
	
	    _createClass(FormInput, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (nextProps.invalidSubmit) {
	                return true;
	            }
	
	            if (this.state.value !== nextState.value) {
	                return true;
	            }
	
	            if (this.state.value !== nextProps.value && this.props.value !== nextProps.value) {
	                this.state.value = nextProps.value;
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(event) {
	            if (this.props.setValue) {
	                this.props.setValue(event.target.value);
	            }
	
	            var state = this.state;
	
	            /* eslint indent: 0 */
	            switch (this.props.maskType) {
	                case 'currency':
	                    if (!isNaN(parseInt(event.target.value))) {
	                        state.value = _helpersStringFormatHelper2['default'].formatToCurrency(parseInt(event.target.value));
	                    } else if (!event.target.value || event.target.value === '£') {
	                        state.value = '';
	                    } else {
	                        var tempValue = _helpersStringFormatHelper2['default'].formatToNumber(event.target.value);
	                        state.value = _helpersStringFormatHelper2['default'].formatToCurrency(tempValue);
	                    }
	                    break;
	                case 'dateOfBirth':
	                    state.value = _helpersDateInputMaskHelper2['default'].applyMaskDate(state.value, event.target.value);
	                    break;
	                default:
	                    state.value = event.target.value;
	            }
	
	            this.setState(state);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(event) {
	            if (!this.lostFocusAtLeastOnce) {
	                this.lostFocusAtLeastOnce = true;
	            }
	
	            if (this.props.setValue) {
	                this.props.setValue(event.target.value);
	            }
	
	            if (this.props.handleChange && event.target.value !== this.oldValue) {
	                this.props.handleChange(event);
	                this.oldValue = event.target.value;
	            }
	
	            this.forceUpdate();
	        }
	    }, {
	        key: 'onKeyPress',
	        value: function onKeyPress(event) {
	            if (event.key === 'Enter') {
	                this.onBlur(event);
	            }
	        }
	    }, {
	        key: 'getInputProperties',
	        value: function getInputProperties(className) {
	            var widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
	            var requiredClass = this.showRequired() ? className + '--required' : '';
	            var readOnlyClass = this.props.readOnly ? className + '--read-only' : '';
	
	            var style = {};
	            if (this.props.fixedWidth) {
	                style = {
	                    width: this.props.fixedWidth
	                };
	            }
	
	            var inputProperties = {
	                className: className + '__input ' + widthProportion + ' ' + requiredClass + ' ' + readOnlyClass,
	                onChange: this.onChange.bind(this),
	                onBlur: this.onBlur.bind(this),
	                onKeyPress: this.onKeyPress.bind(this),
	                placeholder: this.props.placeholder,
	                type: this.props.type,
	                name: this.props.name,
	                value: this.state.value,
	                readOnly: this.props.readOnly,
	                maxLength: this.props.maxLength,
	                style: style
	            };
	
	            if (this.props.maskType === 'phoneNumber') {
	                inputProperties.mask = '99999 999 999';
	                inputProperties.maskChar = '';
	            }
	
	            if (this.props.maskType === 'number') {
	                inputProperties.mask = '99999999999';
	                inputProperties.maskChar = '';
	            }
	
	            return inputProperties;
	        }
	    }, {
	        key: 'renderHint',
	        value: function renderHint() {
	            if (!this.props.hintText) {
	                return null;
	            }
	
	            return _react2['default'].createElement(
	                'span',
	                { className: 'app__hint' },
	                this.props.hintText
	            );
	        }
	    }, {
	        key: 'renderLabel',
	        value: function renderLabel(className) {
	            if (!this.props.label) {
	                return '';
	            }
	
	            if (this.props.labelMobileOnly) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: className + '__label--mobile' },
	                    this.props.label
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: className + '__label' },
	                this.props.label
	            );
	        }
	    }, {
	        key: 'renderErrorMessage',
	        value: function renderErrorMessage(className) {
	            if (!this.props.getErrorMessage || !this.props.getErrorMessage()) {
	                return '';
	            }
	
	            return _react2['default'].createElement(
	                'span',
	                { className: className + '__error-message' },
	                this.props.getErrorMessage()
	            );
	        }
	    }, {
	        key: 'showRequired',
	        value: function showRequired() {
	            if (!this.props.showRequired || !this.props.showRequired()) {
	                return false;
	            }
	
	            if (this.props.showRequired() && this.lostFocusAtLeastOnce) {
	                return true;
	            }
	
	            if (this.props.showRequired() && this.props.invalidSubmit) {
	                return true;
	            }
	
	            return false;
	        }
	    }]);
	
	    return FormInput;
	})(_react.Component);
	
	exports['default'] = FormInput;
	
	FormInput.propTypes = {
	    /* input value and label defaults */
	    name: _react2['default'].PropTypes.string,
	
	    label: _react2['default'].PropTypes.string,
	    labelMobileOnly: _react2['default'].PropTypes.bool,
	    placeholder: _react2['default'].PropTypes.string,
	    hintText: _react2['default'].PropTypes.string,
	
	    value: _react2['default'].PropTypes.node,
	    type: _react2['default'].PropTypes.string,
	    readOnly: _react2['default'].PropTypes.bool,
	
	    /* style and masks */
	    maskType: _react2['default'].PropTypes.string,
	    className: _react2['default'].PropTypes.string,
	    widthProportion: _react2['default'].PropTypes.string,
	    fixedWidth: _react2['default'].PropTypes.string,
	
	    /* callbacks */
	    handleChange: _react2['default'].PropTypes.func,
	
	    invalidSubmit: _react2['default'].PropTypes.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var DateInputMaskHelper = (function () {
	    function DateInputMaskHelper() {
	        _classCallCheck(this, DateInputMaskHelper);
	    }
	
	    _createClass(DateInputMaskHelper, null, [{
	        key: 'applyMaskDate',
	        value: function applyMaskDate(oldDateString, newDateString) {
	            if (!newDateString) {
	                return '';
	            }
	
	            var dateWithoutSlashes = newDateString ? newDateString.replace(/\//g, '') : '';
	            var numberOfSlashes = newDateString && newDateString.match(/\//g) ? newDateString.match(/\//g).length : 0;
	
	            if (!DateInputMaskHelper.isStringValid(dateWithoutSlashes, numberOfSlashes)) {
	                return oldDateString;
	            }
	
	            if (dateWithoutSlashes.length >= 3 && dateWithoutSlashes.length < 5 && numberOfSlashes === 0) {
	                return newDateString.substr(0, 2) + '/' + newDateString.substr(2);
	            }
	
	            if (dateWithoutSlashes.length >= 5 && numberOfSlashes === 0) {
	                return newDateString.substr(0, 2) + '/' + newDateString.substr(2, 2) + '/' + newDateString.substr(4);
	            }
	
	            if (dateWithoutSlashes.length >= 5 && numberOfSlashes === 1 && newDateString.indexOf('/') === 2) {
	                return newDateString.substr(0, 5) + '/' + newDateString.substr(5);
	            }
	
	            if (dateWithoutSlashes.length >= 5 && numberOfSlashes === 1 && newDateString.indexOf('/') === 1) {
	                return newDateString.substr(0, 4) + '/' + newDateString.substr(4);
	            }
	
	            return newDateString;
	        }
	    }, {
	        key: 'isStringValid',
	        value: function isStringValid(dateWithoutSlashes, numberOfSlashes) {
	            // First rule: should not have more than 2 slashes
	            if (numberOfSlashes > 2) {
	                return false;
	            }
	
	            // Second rule: should not have only slashes
	            if (!dateWithoutSlashes) {
	                return false;
	            }
	
	            // Third rule: should not have more than 8 digits (not counting the slashes)
	            if (dateWithoutSlashes.length > 8) {
	                return false;
	            }
	
	            // Fourth rule: without slashes, should be a number
	            return !isNaN(dateWithoutSlashes);
	        }
	    }]);
	
	    return DateInputMaskHelper;
	})();
	
	exports['default'] = DateInputMaskHelper;
	module.exports = exports['default'];

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(780);
	
	var _FormInput2 = __webpack_require__(812);
	
	var _FormInput3 = _interopRequireDefault(_FormInput2);
	
	var _constantsDropdownOptions = __webpack_require__(815);
	
	var Dropdown = (function (_FormInput) {
	    _inherits(Dropdown, _FormInput);
	
	    function Dropdown() {
	        _classCallCheck(this, Dropdown);
	
	        _get(Object.getPrototypeOf(Dropdown.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Dropdown, [{
	        key: 'onChange',
	        value: function onChange(event) {
	            if (this.props.handleChange) {
	                this.props.handleChange(event);
	            }
	
	            _get(Object.getPrototypeOf(Dropdown.prototype), 'onChange', this).call(this, event);
	        }
	    }, {
	        key: 'renderLabel',
	        value: function renderLabel() {
	            if (!this.props.label) {
	                return '';
	            }
	
	            if (this.props.labelMobileOnly) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'app__dropdown__label--mobile' },
	                    this.props.label
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__dropdown__label' },
	                this.props.label
	            );
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            var optionsElements = [];
	            var listOfOptions = this.props.options;
	
	            if (!listOfOptions && !this.props.optionsType) {
	                listOfOptions = _constantsDropdownOptions.DropdownOptions.get(this.props.name);
	            } else if (this.props.optionsType) {
	                listOfOptions = _constantsDropdownOptions.DropdownOptions.get(this.props.optionsType);
	            }
	
	            if (!listOfOptions || !listOfOptions.length) {
	                return '';
	            }
	
	            if (this.props.blankOption) {
	                var defaultBlankOptionLabel = this.props.label ? this.props.label.toLowerCase() : 'an option';
	                var blankOptionLabel = this.props.blankOptionLabel ? this.props.blankOptionLabel : defaultBlankOptionLabel;
	
	                optionsElements.push(_react2['default'].createElement(
	                    'option',
	                    { value: '' },
	                    '-- select ',
	                    blankOptionLabel,
	                    ' --'
	                ));
	            }
	
	            for (var i = 0; i < listOfOptions.length; i++) {
	                var option = listOfOptions[i];
	                optionsElements.push(_react2['default'].createElement(
	                    'option',
	                    { value: option.value },
	                    option.text
	                ));
	            }
	            return optionsElements;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
	            var requiredClass = this.showRequired() ? 'app__dropdown__dropdown--required' : '';
	
	            var style = {};
	            if (this.props.fixedWidth) {
	                style = {
	                    width: this.props.fixedWidth
	                };
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__dropdown' },
	                this.renderLabel(),
	                _react2['default'].createElement(
	                    'select',
	                    { className: 'app__dropdown__dropdown ' + widthProportion + ' ' + requiredClass,
	                        onChange: this.onChange.bind(this),
	                        onBlur: this.onBlur.bind(this),
	                        name: this.props.name,
	                        value: this.props.value,
	                        defaultValue: '',
	                        style: style },
	                    this.renderOptions()
	                )
	            );
	        }
	    }]);
	
	    return Dropdown;
	})(_FormInput3['default']);
	
	exports.Dropdown = Dropdown;
	
	Dropdown.propTypes = {
	    label: _react2['default'].PropTypes.string,
	    labelMobileOnly: _react2['default'].PropTypes.bool,
	    value: _react2['default'].PropTypes.node,
	
	    options: _react2['default'].PropTypes.array,
	    optionsType: _react2['default'].PropTypes.string,
	
	    name: _react2['default'].PropTypes.string,
	    handleChange: _react2['default'].PropTypes.func,
	    widthProportion: _react2['default'].PropTypes.string,
	    fixedWidth: _react2['default'].PropTypes.string,
	
	    blankOption: _react2['default'].PropTypes.bool,
	    blankOptionLabel: _react2['default'].PropTypes.string,
	
	    invalidSubmit: _react2['default'].PropTypes.bool
	};
	
	exports['default'] = (0, _formsyReact.HOC)(Dropdown);

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _immutable = __webpack_require__(545);
	
	var DropdownOptions = (0, _immutable.Map)({
	    'default': [{ value: 'true', text: 'Yes' }, { value: 'false', text: 'No' }],
	    adviceArea: [{ value: 391, text: 'Insurance & Protection' }, { value: 396, text: 'Auto Enrolment' }, { value: 397, text: 'Investments & Savings' }, { value: 392, text: 'Mortgages' }, { value: 393, text: 'Pension & Retirement' }, { value: 557, text: 'Pension Transfers - Non Specialist' }, { value: 394, text: 'Equity Release' }, { value: 558, text: 'Inheritance Planning' }, { value: 395, text: 'Annuities' }],
	    adviceTime: [{ value: 'now', text: 'Now / ASAP' }, { value: '1-3 months', text: 'Between 1-3 months from now' }, { value: 'more than 3 months', text: 'More than 3 months from now' }, { value: 'just interested', text: 'I\'m just interested in whether I can get a mortgage' }]
	});
	exports.DropdownOptions = DropdownOptions;

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(780);
	
	/* eslint no-unused-vars: 0 */
	
	var _reactSelect = __webpack_require__(817);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(833);
	
	var _FormInput2 = __webpack_require__(812);
	
	var _FormInput3 = _interopRequireDefault(_FormInput2);
	
	var MultiSelect = (function (_FormInput) {
	    _inherits(MultiSelect, _FormInput);
	
	    function MultiSelect(props) {
	        _classCallCheck(this, MultiSelect);
	
	        _get(Object.getPrototypeOf(MultiSelect.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            value: props.value
	        };
	    }
	
	    _createClass(MultiSelect, [{
	        key: 'renderLabel',
	        value: function renderLabel() {
	            if (!this.props.label) {
	                return '';
	            }
	
	            if (this.props.labelMobileOnly) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'app__multiselect__label--mobile' },
	                    this.props.label
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__multiselect__label' },
	                this.props.label,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__multiselect__sublabel' },
	                    this.props.sublabel
	                )
	            );
	        }
	    }, {
	        key: 'handleBlur',
	        value: function handleBlur() {
	            var event = {
	                target: {
	                    name: this.props.name,
	                    value: this.state.value
	                }
	            };
	
	            _get(Object.getPrototypeOf(MultiSelect.prototype), 'onBlur', this).call(this, event);
	        }
	    }, {
	        key: 'handleSelectChange',
	        value: function handleSelectChange(value) {
	            var event = {
	                target: {
	                    name: this.props.name,
	                    value: value
	                }
	            };
	
	            if (this.props.handleChange) {
	                this.props.handleChange(event);
	            }
	
	            _get(Object.getPrototypeOf(MultiSelect.prototype), 'onChange', this).call(this, event);
	
	            this.setState({ value: value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
	            var requiredClass = this.showRequired() ? 'app__multiselect__select--required' : '';
	
	            var style = {};
	            if (this.props.fixedWidth) {
	                style = {
	                    width: this.props.fixedWidth
	                };
	            }
	
	            var className = 'app__multiselect__select ' + widthProportion + ' ' + requiredClass;
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__multiselect' },
	                this.renderLabel(),
	                _react2['default'].createElement(_reactSelect2['default'], { multi: true,
	                    simpleValue: true,
	                    className: className,
	                    style: style,
	                    value: this.state.value,
	                    placeholder: '-- Select advice areas --',
	                    options: this.props.options,
	                    onBlur: this.handleBlur.bind(this),
	                    searchable: false,
	                    onChange: this.handleSelectChange.bind(this) })
	            );
	        }
	    }]);
	
	    return MultiSelect;
	})(_FormInput3['default']);
	
	exports.MultiSelect = MultiSelect;
	
	MultiSelect.propTypes = {
	    label: _react2['default'].PropTypes.string,
	    sublabel: _react2['default'].PropTypes.string,
	    labelMobileOnly: _react2['default'].PropTypes.bool,
	    value: _react2['default'].PropTypes.node,
	
	    options: _react2['default'].PropTypes.array,
	    optionsType: _react2['default'].PropTypes.string,
	    multiple: _react2['default'].PropTypes.bool,
	
	    name: _react2['default'].PropTypes.string,
	    handleChange: _react2['default'].PropTypes.func,
	    widthProportion: _react2['default'].PropTypes.string,
	    fixedWidth: _react2['default'].PropTypes.string,
	
	    invalidSubmit: _react2['default'].PropTypes.bool
	};
	
	exports['default'] = (0, _formsyReact.HOC)(MultiSelect);

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(834);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(836)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../sass-loader/index.js!./react-select.css", function() {
				var newContent = require("!!../../css-loader/index.js!../../sass-loader/index.js!./react-select.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(835)();
	// imports
	
	
	// module
	exports.push([module.id, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),

/***/ 835:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Selector = (function (_Component) {
	    _inherits(Selector, _Component);
	
	    function Selector() {
	        _classCallCheck(this, Selector);
	
	        _get(Object.getPrototypeOf(Selector.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Selector, [{
	        key: 'onChange',
	        value: function onChange(event) {
	            if (this.props.handleChange) {
	                this.props.handleChange(event);
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.value !== this.props.value;
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue() {
	            return this.props.value;
	        }
	    }, {
	        key: 'renderLabel',
	        value: function renderLabel() {
	            if (!this.props.label) {
	                return '';
	            }
	
	            if (this.props.labelMobileOnly) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'app__selector__label--mobile' },
	                    this.props.label
	                );
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__selector__label' },
	                this.props.label
	            );
	        }
	    }, {
	        key: 'selectOption',
	        value: function selectOption(event) {
	            var newEvent = {
	                target: {
	                    name: this.props.name,
	                    value: event.target.getAttribute('value')
	                }
	            };
	
	            this.onChange(newEvent);
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            var optionsElements = [];
	
	            for (var i = 0; i < this.props.optionsList.length; i++) {
	                var option = this.props.optionsList[i];
	                var selected = option.value === this.props.value;
	
	                var selectedClass = selected ? 'app__selector__option--selected' : '';
	                optionsElements.push(_react2['default'].createElement(
	                    'div',
	                    { className: 'app__selector__option ' + selectedClass,
	                        name: this.props.name,
	                        onClick: this.selectOption.bind(this),
	                        value: option.value },
	                    option.text
	                ));
	            }
	
	            return optionsElements;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
	
	            var style = {};
	            if (this.props.fixedWidth) {
	                style = {
	                    width: this.props.fixedWidth
	                };
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__selector' },
	                this.renderLabel(),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__selector__set ' + widthProportion,
	                        onChange: this.onChange.bind(this), style: style },
	                    this.renderOptions()
	                )
	            );
	        }
	    }]);
	
	    return Selector;
	})(_react.Component);
	
	exports['default'] = Selector;
	
	Selector.propTypes = {
	    label: _react2['default'].PropTypes.string,
	    labelMobileOnly: _react2['default'].PropTypes.bool,
	    value: _react2['default'].PropTypes.node,
	
	    name: _react2['default'].PropTypes.string,
	    handleChange: _react2['default'].PropTypes.func,
	    widthProportion: _react2['default'].PropTypes.string,
	    fixedWidth: _react2['default'].PropTypes.string,
	
	    optionsList: _react2['default'].PropTypes.array
	};
	module.exports = exports['default'];

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var FilterSelector = (function (_Component) {
	    _inherits(FilterSelector, _Component);
	
	    function FilterSelector() {
	        _classCallCheck(this, FilterSelector);
	
	        _get(Object.getPrototypeOf(FilterSelector.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(FilterSelector, [{
	        key: 'handleClick',
	        value: function handleClick(category, label, key) {
	            if (this.props.handleClick) {
	                this.props.handleClick(category, label, key);
	            }
	        }
	    }, {
	        key: 'renderAllFilters',
	        value: function renderAllFilters(className) {
	            var _this = this;
	
	            if (!this.props.filters || !this.props.filters.count()) {
	                return '';
	            }
	
	            var filters = [];
	
	            this.props.filters.forEach(function (filter, key) {
	                var selectedClass = filter.get('selected') ? 'selected' : '';
	
	                filters.push(_react2['default'].createElement(
	                    'div',
	                    { className: className + '__filter ' + selectedClass + ' app__grid__column__three-one',
	                        onClick: _this.handleClick.bind(_this, filter.get('id'), filter.get('name'), key) },
	                    _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: filter.get('name') } })
	                ));
	            });
	
	            return filters;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var className = this.props.className ? this.props.className : 'app__filter-selector';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: className },
	                this.renderAllFilters(className)
	            );
	        }
	    }]);
	
	    return FilterSelector;
	})(_react.Component);
	
	exports['default'] = FilterSelector;
	
	FilterSelector.propTypes = {
	    filters: _react2['default'].PropTypes.object,
	    handleClick: _react2['default'].PropTypes.func
	};
	module.exports = exports['default'];

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _contentHowItWorksContent = __webpack_require__(840);
	
	var _wrapperVersionWrapper = __webpack_require__(807);
	
	var HowItWorks = (function (_Component) {
	    _inherits(HowItWorks, _Component);
	
	    function HowItWorks() {
	        _classCallCheck(this, HowItWorks);
	
	        _get(Object.getPrototypeOf(HowItWorks.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(HowItWorks, [{
	        key: 'renderItems',
	        value: function renderItems() {
	            var iconDefaultSize = '80px';
	            var style = { backgroundColor: '#DBF3F5' };
	
	            var itemsRendered = [];
	            for (var i = 0; i < _contentHowItWorksContent.HowItWorksLandingContent.length; i++) {
	                itemsRendered.push(_react2['default'].createElement(
	                    'div',
	                    { className: 'app__grid__column__three-one padding-sides-20' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__icon' },
	                        _react2['default'].createElement(_iconsIcon2['default'], { icon: _contentHowItWorksContent.HowItWorksLandingContent[i].icon, size: iconDefaultSize, style: style })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'semi-bold' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'semi-bold' },
	                            i + 1,
	                            '. '
	                        ),
	                        _contentHowItWorksContent.HowItWorksLandingContent[i].header
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__info font-lighter' },
	                        _contentHowItWorksContent.HowItWorksLandingContent[i].step === 1 ? _react2['default'].createElement(
	                            'div',
	                            null,
	                            'It\'s free and takes just 60 seconds! Simply tell us what you\'re looking for and we\'ll do the rest. Or, if you prefer, you can ',
	                            _react2['default'].createElement(
	                                'a',
	                                { href: 'https://www.vouchedfor.co.uk/', target: '_blank' },
	                                'search our directory'
	                            )
	                        ) : _contentHowItWorksContent.HowItWorksLandingContent[i].text
	                    )
	                ));
	            }
	
	            return itemsRendered;
	        }
	    }, {
	        key: 'controlElement',
	        value: function controlElement() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section how-it-works matching' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'how-it-works__container' },
	                    _react2['default'].createElement(
	                        'h5',
	                        { className: 'vouchedfor-brand' },
	                        'How it works'
	                    ),
	                    _react2['default'].createElement('div', { className: 'under-title' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__list' },
	                        this.renderItems()
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'experimentElement',
	        value: function experimentElement() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section how-it-works' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'how-it-works__container' },
	                    _react2['default'].createElement(
	                        'h5',
	                        { className: 'vouchedfor-brand' },
	                        'How it works'
	                    ),
	                    _react2['default'].createElement('div', { className: 'under-title' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__list' },
	                        this.renderItems()
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var WrappedComponent = (0, _wrapperVersionWrapper.Wrapped)(this.controlElement(), this.experimentElement());
	            return _react2['default'].createElement(WrappedComponent, null);
	        }
	    }]);
	
	    return HowItWorks;
	})(_react.Component);
	
	exports['default'] = HowItWorks;
	module.exports = exports['default'];

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var HowItWorksLandingContent = [{
	    step: 1,
	    icon: 'pencil',
	    header: 'Submit your request',
	    text: ''
	}, {
	    step: 2,
	    icon: 'tick',
	    header: 'We\'ll find your top 5 advisers',
	    text: 'We\'ll search our directory to shortlist the top 5 whole of market mortgage advisers for your situation.' + ' Then we\'ll send your enquiry to the best!'
	}, {
	    step: 3,
	    icon: 'phone-outgoing',
	    header: 'Speak to an adviser',
	    text: 'Have a free, no obligation chat with the adviser we send your enquiry to'
	}];
	
	exports.HowItWorksLandingContent = HowItWorksLandingContent;
	var HowItWorksContactContent = [{
	    icon: 'pencil',
	    header: 'Submit your request',
	    text: 'Simply fill in your details below and tell us how many quotes you\'d like '
	}, {
	    icon: 'tick',
	    header: 'We\'ll find your best matches',
	    text: 'We\'ll search our directory to find the top advisers for you'
	}, {
	    icon: 'phone-outgoing',
	    header: 'Speak to an adviser',
	    text: 'Have a free no obligation chat with up to 3 advisers who can give you bespoke quotes'
	}];
	exports.HowItWorksContactContent = HowItWorksContactContent;

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GetQuotesButton = __webpack_require__(809);
	
	var _GetQuotesButton2 = _interopRequireDefault(_GetQuotesButton);
	
	/* Load adviser banner images for all sizes */
	__webpack_require__(842);
	__webpack_require__(843);
	__webpack_require__(844);
	__webpack_require__(845);
	__webpack_require__(846);
	
	var AdviserInfo = (function (_Component) {
	    _inherits(AdviserInfo, _Component);
	
	    function AdviserInfo() {
	        _classCallCheck(this, AdviserInfo);
	
	        _get(Object.getPrototypeOf(AdviserInfo.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(AdviserInfo, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section--full' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__landing-page__full-image adviser-banner__image' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__landing-page__adviser-info--left' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'adviser-banner__header' },
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'line' },
	                                '"The adviser was extremely knowledgeable…we felt reassured that we were in good hands."'
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'adviser-banner__subtitle' },
	                            'The independent mortgage advisers we suggest for you will be local to you, verified experts, and positively reviewed by their clients'
	                        ),
	                        _react2['default'].createElement(_GetQuotesButton2['default'], { section: 'Adviser Section', handler: this.props.scrollToForm })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AdviserInfo;
	})(_react.Component);
	
	exports['default'] = AdviserInfo;
	
	AdviserInfo.propTypes = {
	    scrollToForm: _react2['default'].PropTypes.func
	};
	module.exports = exports['default'];

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvYWR2aXNlcl9iYW5uZXJfeHNtYWxsLmpwZyI7"

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvYWR2aXNlcl9iYW5uZXJfc21hbGwuanBnIjs="

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvYWR2aXNlcl9iYW5uZXJfdGFibGV0LmpwZyI7"

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvYWR2aXNlcl9iYW5uZXJfbWVkaXVtLmpwZyI7"

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvYWR2aXNlcl9iYW5uZXJfbGFyZ2UuanBnIjs="

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _contentVerifiedContent = __webpack_require__(848);
	
	var _contentVerifiedContent2 = _interopRequireDefault(_contentVerifiedContent);
	
	var VerifiedDetails = (function (_Component) {
	    _inherits(VerifiedDetails, _Component);
	
	    function VerifiedDetails() {
	        _classCallCheck(this, VerifiedDetails);
	
	        _get(Object.getPrototypeOf(VerifiedDetails.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(VerifiedDetails, [{
	        key: 'renderItems',
	        value: function renderItems() {
	            var iconDefaultSize = '45px';
	            var style = { backgroundColor: '#DBF3F5', fill: '#4BC1CA' };
	
	            var itemsRendered = [];
	            for (var i = 0; i < _contentVerifiedContent2['default'].length; i++) {
	                itemsRendered.push(_react2['default'].createElement(
	                    'div',
	                    { className: 'app__grid__column__one-one app__verified-details__table-cell' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__verified-details__icon' },
	                        _react2['default'].createElement(_iconsIcon2['default'], { icon: _contentVerifiedContent2['default'][i].icon, size: iconDefaultSize, style: style })
	                    ),
	                    _react2['default'].createElement('div', { className: 'app__verified-details__info font-lighter',
	                        dangerouslySetInnerHTML: { __html: _contentVerifiedContent2['default'][i].text } })
	                ));
	            }
	
	            return itemsRendered;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section verified-details' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'verified-details__container' },
	                    _react2['default'].createElement(
	                        'h5',
	                        { className: 'vouchedfor-brand' },
	                        'Verified independent advisers'
	                    ),
	                    _react2['default'].createElement('div', { className: 'under-title' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'push-up-30 push-down-20 font-lighter' },
	                        'We will only connect you to an independent adviser who is...'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__verified-details' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__verified-details__list' },
	                            this.renderItems()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VerifiedDetails;
	})(_react.Component);
	
	exports['default'] = VerifiedDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var VerifiedContent = [{
	    icon: 'circle-checkmark',
	    text: '<span class="semi-bold">A verified independent adviser</span> - we have checked the FCA register'
	}, {
	    icon: 'circle-checkmark',
	    text: '<span class="semi-bold">Positively reviewed</span> by genuine clients'
	}, {
	    icon: 'circle-checkmark',
	    text: '<span class="semi-bold">Easily accessible</span> - face to face or over the phone'
	}];
	
	exports['default'] = VerifiedContent;
	module.exports = exports['default'];

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var AboutUs = (function (_Component) {
	    _inherits(AboutUs, _Component);
	
	    function AboutUs() {
	        _classCallCheck(this, AboutUs);
	
	        _get(Object.getPrototypeOf(AboutUs.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(AboutUs, [{
	        key: 'render',
	        value: function render() {
	            var iconDefaultSize = '70px';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__contact-page__section about-us' },
	                _react2['default'].createElement(
	                    'h5',
	                    { className: 'vouchedfor-brand' },
	                    'About VouchedFor'
	                ),
	                _react2['default'].createElement('div', { className: 'under-title' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'inline-block push-up-30' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__grid__column__three-one padding-sides-20' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__icon' },
	                            _react2['default'].createElement(_iconsIcon2['default'], { icon: 'genuine-reviews', size: iconDefaultSize })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__info__header' },
	                            'Genuine client reviews'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__info font-lighter' },
	                            'VouchedFor is the leading reviews website for professionals in the UK with thousands of well reviewed professionals on board. Only genuine clients can review their adviser and we verify every review.'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__grid__column__three-one padding-sides-20' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__icon' },
	                            _react2['default'].createElement(_iconsIcon2['default'], { icon: 'star', size: iconDefaultSize })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__info__header' },
	                            'Verified professionals'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__info font-lighter' },
	                            'All Financial Advisers in our network are checked against the Financial Conduct Authority Register, and must confirm they offer independent investment and pension advice, and so are not tied to a particular product or provider'
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__grid__column__three-one padding-sides-20' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__icon' },
	                            _react2['default'].createElement(_iconsIcon2['default'], { icon: 'badge', size: iconDefaultSize })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__info__header' },
	                            'Our guarantee'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__about-us__info font-lighter' },
	                            'All of our advisers on VouchedFor are experts at what they do. However, if you’re not completely satisfied with your adviser we will help you find someone else. There is no obligation to continue with any adviser after receiving your plan.'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AboutUs;
	})(_react.Component);
	
	exports['default'] = AboutUs;
	module.exports = exports['default'];

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imagesPartnersThisIsMoneyPng = __webpack_require__(851);
	
	var _imagesPartnersThisIsMoneyPng2 = _interopRequireDefault(_imagesPartnersThisIsMoneyPng);
	
	var _dataImages = __webpack_require__(800);
	
	var AsFeaturedIn = (function (_Component) {
	    _inherits(AsFeaturedIn, _Component);
	
	    function AsFeaturedIn() {
	        _classCallCheck(this, AsFeaturedIn);
	
	        _get(Object.getPrototypeOf(AsFeaturedIn.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(AsFeaturedIn, [{
	        key: 'render',
	        value: function render() {
	            var featuredImages = [{
	                src: _dataImages.itvIcon,
	                alt: 'ITV',
	                width: '40px'
	            }, {
	                src: _dataImages.guardianIcon,
	                alt: 'The Guardian',
	                width: '100px'
	            }, {
	                src: _dataImages.sundaytimesIcon,
	                alt: 'Sunday Times',
	                width: '100px'
	            }, {
	                src: _dataImages.independentIcon,
	                alt: 'Independent',
	                width: '140px'
	            }, {
	                src: _imagesPartnersThisIsMoneyPng2['default'],
	                alt: 'This is Money',
	                width: '100px'
	            }, {
	                src: _dataImages.dmIcon,
	                alt: 'Daily Mail',
	                width: '80px'
	            }];
	
	            var logos = [];
	            for (var i = 0; i < featuredImages.length; i++) {
	                var logo = featuredImages[i];
	                var hiddenMobile = i > 2 ? 'partner__logo__column__container--hidden-mobile' : '';
	
	                logos.push(_react2['default'].createElement(
	                    'div',
	                    { className: 'app__grid__column__six-one__mobile__three-one ' + hiddenMobile },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'partner__logo__column__container' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'partner__logo__column' },
	                            _react2['default'].createElement('img', { src: logo.src, width: logo.width, alt: logo.alt })
	                        )
	                    )
	                ));
	            }
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__contact-page__section featured-in' },
	                _react2['default'].createElement(
	                    'h5',
	                    { className: 'vouchedfor-brand' },
	                    'As Featured In'
	                ),
	                _react2['default'].createElement('div', { className: 'under-title' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__contact-page__section-inside' },
	                    logos
	                )
	            );
	        }
	    }]);
	
	    return AsFeaturedIn;
	})(_react.Component);
	
	exports['default'] = AsFeaturedIn;
	
	AsFeaturedIn.propTypes = {
	    source: _react2['default'].PropTypes.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/this-is-money.png";

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvaGVyb19iYW5uZXJfbGFyZ2UuanBnIjs="

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvaGVyb19iYW5uZXJfeHNtYWxsLmpwZyI7"

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _elementsEditableInput = __webpack_require__(810);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _servicesFeatureToggle = __webpack_require__(855);
	
	/* eslint max-len: 0 */
	
	var SendMessage = (function (_Component) {
	    _inherits(SendMessage, _Component);
	
	    function SendMessage(props) {
	        _classCallCheck(this, SendMessage);
	
	        _get(Object.getPrototypeOf(SendMessage.prototype), 'constructor', this).call(this, props);
	        this.state = {
	            message: props.person.get('message')
	        };
	    }
	
	    _createClass(SendMessage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.createMessage();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ message: nextProps.person.get('message') });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(event) {
	            this.setState({ message: event.target.value });
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(event) {
	            this.props.actions.updatePersonAttribute('message', event.target.value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var maxWidthInputs = this.props.person.get('adviceArea') === 392 ? '280px' : 'auto';
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__message-page__container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__editable-input' },
	                    _react2['default'].createElement('textarea', { className: 'app__text-area', rows: '5',
	                        onChange: this.onChange.bind(this),
	                        onBlur: this.onBlur.bind(this),
	                        value: this.state.message })
	                ),
	                _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'phone',
	                    ref: 'phone',
	                    label: 'The best number to contact me on is:',
	                    placeholder: '01234 567 890',
	                    value: this.props.person.get('phone'),
	                    maxLength: 11,
	                    invalidSubmit: this.props.invalidSubmit,
	                    widthProportion: 'fixed',
	                    fixedWidth: maxWidthInputs,
	                    handleChange: this.handleChange.bind(this),
	                    hintText: 'Most advisers will call you to discuss your request',
	                    required: true })
	            );
	        }
	    }]);
	
	    return SendMessage;
	})(_react.Component);
	
	exports.SendMessage = SendMessage;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	        invalidSubmit: state.navigation.get('invalidSubmit')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SendMessage);

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getRandomInt = getRandomInt;
	exports.featureToggle = featureToggle;
	
	function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	function featureToggle(name) {
	    var values = arguments.length <= 1 || arguments[1] === undefined ? [true, false] : arguments[1];
	
	    if (!name || !window.sessionStorage) return null;
	    if (window.sessionStorage.getItem(name) === null) {
	        var featureValue = values[getRandomInt(0, values.length - 1)];
	        window.sessionStorage.setItem(name, JSON.stringify(featureValue));
	        return featureValue;
	    }
	
	    return JSON.parse(window.sessionStorage.getItem(name));
	}

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _servicesWindowEventsHandler = __webpack_require__(795);
	
	var _servicesWindowEventsHandler2 = _interopRequireDefault(_servicesWindowEventsHandler);
	
	var _stepsFinishNextSteps = __webpack_require__(857);
	
	var _stepsFinishNextSteps2 = _interopRequireDefault(_stepsFinishNextSteps);
	
	/* eslint max-len: 0 */
	
	var ThankYouPage = (function (_Component) {
	    _inherits(ThankYouPage, _Component);
	
	    function ThankYouPage() {
	        _classCallCheck(this, ThankYouPage);
	
	        _get(Object.getPrototypeOf(ThankYouPage.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ThankYouPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _servicesWindowEventsHandler2['default'].disableUnloadMessage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__message-page__container' },
	                _react2['default'].createElement(
	                    'h1',
	                    { className: 'vouchedfor-brand font-size-20' },
	                    'Thank You!'
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Your request is now being processed by our team.'
	                ),
	                _react2['default'].createElement(_stepsFinishNextSteps2['default'], null),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'push-down-10' },
	                    'If you\'d like to amend or cancel your request please email:'
	                ),
	                _react2['default'].createElement(
	                    'a',
	                    { className: 'link-primary', href: 'mailto:consumer_support@vouchedfor.co.uk' },
	                    'consumer_support@vouchedfor.co.uk'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'push-up-10 push-down-50' },
	                    'Or call us on ',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: 'tel:02031110583' },
	                        '0203 111 0583'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ThankYouPage;
	})(_react.Component);
	
	exports['default'] = ThankYouPage;
	module.exports = exports['default'];

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _contentNextStepsContent = __webpack_require__(858);
	
	var _contentNextStepsContent2 = _interopRequireDefault(_contentNextStepsContent);
	
	var NextSteps = (function (_Component) {
	    _inherits(NextSteps, _Component);
	
	    function NextSteps() {
	        _classCallCheck(this, NextSteps);
	
	        _get(Object.getPrototypeOf(NextSteps.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(NextSteps, [{
	        key: 'renderItems',
	        value: function renderItems() {
	            var iconDefaultSize = '80px';
	            var style = { backgroundColor: '#DBF3F5' };
	
	            var itemsRendered = [];
	            for (var i = 0; i < _contentNextStepsContent2['default'].length; i++) {
	                itemsRendered.push(_react2['default'].createElement(
	                    'div',
	                    { className: 'app__grid__column__three-one padding-sides-20' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__icon' },
	                        _react2['default'].createElement(_iconsIcon2['default'], { icon: _contentNextStepsContent2['default'][i].icon, size: iconDefaultSize, style: style })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__info font-lighter' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'semi-bold' },
	                            i + 1,
	                            '. '
	                        ),
	                        _react2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: _contentNextStepsContent2['default'][i].text } })
	                    )
	                ));
	            }
	
	            return itemsRendered;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section how-it-works' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'how-it-works__container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__next-steps__list' },
	                        this.renderItems()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NextSteps;
	})(_react.Component);
	
	exports['default'] = NextSteps;
	module.exports = exports['default'];

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var HowItWorksContent = [{
	    icon: 'location',
	    text: 'Our team are <span class="semi-bold">searching our database</span>' + ' to find the perfect mortgage adviser for you.'
	
	}, {
	    icon: 'bubbles',
	    text: '<span class="semi-bold">The chosen mortgage advisers will be in touch</span> to discuss your request.'
	}, {
	    icon: 'tick',
	    text: 'If you <span class="semi-bold">find a mortgage adviser that\'s right for you</span>, ' + 'let them do what they do best!'
	}];
	
	exports['default'] = HowItWorksContent;
	module.exports = exports['default'];

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _elementsEditableInput = __webpack_require__(810);
	
	var _elementsCustomCheckbox = __webpack_require__(860);
	
	var _elementsDropdown = __webpack_require__(814);
	
	var _elementsDropdown2 = _interopRequireDefault(_elementsDropdown);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _sharedAboutUs = __webpack_require__(849);
	
	var _sharedAboutUs2 = _interopRequireDefault(_sharedAboutUs);
	
	var _sharedAsFeaturedIn = __webpack_require__(850);
	
	var _sharedAsFeaturedIn2 = _interopRequireDefault(_sharedAsFeaturedIn);
	
	var _contentHowItWorksContent = __webpack_require__(840);
	
	/* eslint max-len: 0 */
	
	var ContactDetailsPage = (function (_Component) {
	    _inherits(ContactDetailsPage, _Component);
	
	    function ContactDetailsPage() {
	        _classCallCheck(this, ContactDetailsPage);
	
	        _get(Object.getPrototypeOf(ContactDetailsPage.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ContactDetailsPage, [{
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'handleFormSubmit',
	        value: function handleFormSubmit() {
	            if (!this.props.canSubmit) {
	                return;
	            }
	
	            _reactRouter.browserHistory.push('message');
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var iconDefaultSize = '60px';
	            var style = { backgroundColor: '#F5F8FC' };
	
	            var itemsRendered = [];
	            for (var i = 0; i < _contentHowItWorksContent.HowItWorksContactContent.length; i++) {
	                itemsRendered.push(_react2['default'].createElement(
	                    'div',
	                    { className: 'app__grid__column__three-one padding-sides-20' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__icon' },
	                        _react2['default'].createElement(_iconsIcon2['default'], { icon: _contentHowItWorksContent.HowItWorksContactContent[i].icon, size: iconDefaultSize, style: style })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'semi-bold' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'semi-bold' },
	                            i + 1,
	                            '. '
	                        ),
	                        _contentHowItWorksContent.HowItWorksContactContent[i].header
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__info font-lighter' },
	                        _contentHowItWorksContent.HowItWorksContactContent[i].text
	                    )
	                ));
	            }
	
	            return itemsRendered;
	        }
	    }, {
	        key: 'renderHowItWorks',
	        value: function renderHowItWorks() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__contact-page__how-it-works' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'how-it-works__container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__how-it-works__list' },
	                        this.renderItems()
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var maxWidthInputs = '290px';
	            var numberOfQuotesOptions = [{ value: '1', text: 'One' }, { value: '2', text: 'Two' }, { value: '3', text: 'Three' }];
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                this.renderHowItWorks(),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__contact-page__container' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__contact-page' },
	                        _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'fullName',
	                            ref: 'fullName',
	                            label: 'Your full name',
	                            placeholder: 'Fred Smith',
	                            widthProportion: 'fixed',
	                            fixedWidth: maxWidthInputs,
	                            value: this.props.person.get('fullName'),
	                            handleChange: this.handleChange.bind(this),
	                            invalidSubmit: this.props.invalidSubmit,
	                            required: true }),
	                        _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'email',
	                            ref: 'email',
	                            label: 'Your email',
	                            placeholder: 'fred@fs.com',
	                            validations: 'isEmail',
	                            validationError: 'This is not a valid email',
	                            value: this.props.person.get('email'),
	                            handleChange: this.handleChange.bind(this),
	                            invalidSubmit: this.props.invalidSubmit,
	                            widthProportion: 'fixed',
	                            fixedWidth: maxWidthInputs,
	                            hintText: 'We\'d like to send you a confirmation email and some tips on getting the most from your adviser',
	                            required: true }),
	                        _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'phone',
	                            ref: 'phone',
	                            label: 'Your phone number',
	                            placeholder: '01234 567 890',
	                            value: this.props.person.get('phone'),
	                            maxLength: 13,
	                            invalidSubmit: this.props.invalidSubmit,
	                            widthProportion: 'fixed',
	                            fixedWidth: maxWidthInputs,
	                            handleChange: this.handleChange.bind(this),
	                            hintText: 'Most advisers will call you to discuss your request',
	                            required: true }),
	                        _react2['default'].createElement(_elementsCustomCheckbox.FormCustomCheckbox, { name: 'telephonyAdvice',
	                            label: 'I\'m happy to speak to an adviser by phone only',
	                            value: this.props.person.get('telephonyAdvice'),
	                            handleChange: this.handleChange.bind(this) }),
	                        _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'postcode',
	                            ref: 'postcode',
	                            label: 'Your postcode',
	                            placeholder: 'SW1A 0AA',
	                            value: this.props.person.get('postcode'),
	                            maxLength: 8,
	                            invalidSubmit: this.props.invalidSubmit,
	                            widthProportion: 'fixed',
	                            fixedWidth: maxWidthInputs,
	                            handleChange: this.handleChange.bind(this),
	                            required: true }),
	                        _react2['default'].createElement(_elementsDropdown2['default'], { name: 'numberOfQuotes',
	                            ref: 'numberOfQuotes',
	                            label: 'How many quotes would you like?',
	                            value: this.props.person.get('numberOfQuotes'),
	                            options: numberOfQuotesOptions,
	                            widthProportion: 'fixed',
	                            fixedWidth: maxWidthInputs,
	                            handleChange: this.handleChange.bind(this) }),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'inline-block text-align-center push-up-5' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'app__form-page__security-message' },
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'app__form-page__security-message__icon' },
	                                    _react2['default'].createElement(_iconsIcon2['default'], { icon: 'lock', size: '22px', style: { fill: 'white' } })
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    null,
	                                    'You are protected by SSL security. We go above and beyond industry standards to ensure your data is safe'
	                                )
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'text-align-center push-up-10' },
	                            _react2['default'].createElement(
	                                'button',
	                                { className: 'big-button vouchedfor-brand mobile-button', refs: 'next', name: 'next',
	                                    onClick: this.handleFormSubmit.bind(this) },
	                                'Get Free IFA Quotes'
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(_sharedAsFeaturedIn2['default'], null),
	                _react2['default'].createElement(_sharedAboutUs2['default'], null)
	            );
	        }
	    }]);
	
	    return ContactDetailsPage;
	})(_react.Component);
	
	exports.ContactDetailsPage = ContactDetailsPage;
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	
	        invalidSubmit: state.navigation.get('invalidSubmit'),
	        canSubmit: state.navigation.get('canSubmit')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContactDetailsPage);

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(780);
	
	// no protect
	
	var CustomCheckbox = (function (_Component) {
	    _inherits(CustomCheckbox, _Component);
	
	    function CustomCheckbox() {
	        _classCallCheck(this, CustomCheckbox);
	
	        _get(Object.getPrototypeOf(CustomCheckbox.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(CustomCheckbox, [{
	        key: 'changeValue',
	        value: function changeValue(event) {
	            if (this.props.setValue) {
	                this.props.setValue(event.target.checked);
	            }
	
	            this.props.handleChange({
	                target: {
	                    name: this.props.name,
	                    value: event.target.checked
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var labelContent = undefined;
	            if (this.props.allowLabelHtml) {
	                labelContent = _react2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: this.props.label } });
	            } else {
	                labelContent = this.props.label;
	            }
	
	            var className = this.props.className ? this.props.className : 'app__custom-checkbox';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: '' + className },
	                _react2['default'].createElement(
	                    'label',
	                    { className: className + '__input' },
	                    _react2['default'].createElement('input', { type: 'checkbox',
	                        name: this.props.name,
	                        onChange: this.changeValue.bind(this),
	                        checked: this.props.value
	                    }),
	                    labelContent
	                )
	            );
	        }
	    }]);
	
	    return CustomCheckbox;
	})(_react.Component);
	
	exports['default'] = CustomCheckbox;
	
	CustomCheckbox.propTypes = {
	    label: _react2['default'].PropTypes.string,
	    name: _react2['default'].PropTypes.string,
	    value: _react2['default'].PropTypes.node,
	    className: _react2['default'].PropTypes.string,
	    allowLabelHtml: _react2['default'].PropTypes.bool,
	    handleChange: _react2['default'].PropTypes.func
	};
	
	var FormCustomCheckbox = (0, _formsyReact.HOC)(CustomCheckbox);
	exports.FormCustomCheckbox = FormCustomCheckbox;

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _StatsWidget = __webpack_require__(862);
	
	var _StatsWidget2 = _interopRequireDefault(_StatsWidget);
	
	var _ContactForm = __webpack_require__(863);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _constantsDefaultServices = __webpack_require__(687);
	
	/* eslint max-len: 0 */
	
	var MatchPage = (function (_Component) {
	    _inherits(MatchPage, _Component);
	
	    function MatchPage() {
	        _classCallCheck(this, MatchPage);
	
	        _get(Object.getPrototypeOf(MatchPage.prototype), 'constructor', this).call(this);
	        this.state = { isModalOpen: false };
	    }
	
	    _createClass(MatchPage, [{
	        key: 'closeModal',
	        value: function closeModal() {
	            this.setState({ isModalOpen: false });
	        }
	    }, {
	        key: 'handleContactSubmit',
	        value: function handleContactSubmit() {
	            if (!this.props.canSubmit) {
	                return;
	            }
	
	            _reactRouter.browserHistory.push('message');
	        }
	    }, {
	        key: 'renderMatchingContent',
	        value: function renderMatchingContent() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__match-page__content' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__match-page__left' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'match-page__widget' },
	                        _react2['default'].createElement(_StatsWidget2['default'], { showButton: false, isVertical: true })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__match-page__right' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'match-page__form' },
	                        _react2['default'].createElement(_ContactForm2['default'], { handler: this.handleContactSubmit.bind(this) })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderBanner',
	        value: function renderBanner() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__match-page__full-image match-page__image' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'opacity-layer' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__match-page__title' },
	                        _react2['default'].createElement(
	                            'h1',
	                            { className: 'vouchedfor-brand' },
	                            'Enter your details and a highly rated mortgage adviser will be in touch'
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__match-page__subtitle' },
	                            'The first call will just be to explain how they can help; there is no commitment!'
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__landing-page__section--full app__match-page__container' },
	                this.renderBanner(),
	                this.renderMatchingContent(),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__match-page__subtitle' },
	                    _react2['default'].createElement(
	                        'p',
	                        null,
	                        'Prefer to speak to us? Freephone 0330 038 8543'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MatchPage;
	})(_react.Component);
	
	exports.MatchPage = MatchPage;
	
	MatchPage.propTypes = {
	    actions: _react2['default'].PropTypes.object,
	
	    person: _react2['default'].PropTypes.object,
	
	    invalidSubmit: _react2['default'].PropTypes.bool,
	    canSubmit: _react2['default'].PropTypes.bool
	};
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	
	        invalidSubmit: state.navigation.get('invalidSubmit'),
	        canSubmit: state.navigation.get('canSubmit')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MatchPage);

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _constantsDefaultServices = __webpack_require__(687);
	
	var _elementsCounter = __webpack_require__(803);
	
	var _elementsCounter2 = _interopRequireDefault(_elementsCounter);
	
	/* eslint max-len: 0 */
	
	var StatsWidget = (function (_Component) {
	    _inherits(StatsWidget, _Component);
	
	    function StatsWidget(props) {
	        _classCallCheck(this, StatsWidget);
	
	        _get(Object.getPrototypeOf(StatsWidget.prototype), 'constructor', this).call(this, props);
	
	        this.oldStats = {
	            total: 0,
	            reviewsCount: 0
	        };
	    }
	
	    _createClass(StatsWidget, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.updateStats(this.props.person.getDataAsSearchParams());
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.person.getDataAsSearchParams() !== nextProps.person.getDataAsSearchParams()) {
	                this.oldStats.total = this.props.total;
	                this.oldStats.reviewsCount = this.props.reviewsCount;
	
	                this.props.actions.updateStats(nextProps.person.getDataAsSearchParams());
	            }
	        }
	    }, {
	        key: 'renderVerticalMode',
	        value: function renderVerticalMode() {
	            var serviceDescription = _constantsDefaultServices.DefaultServices.get(this.props.person.get('needKey')) ? _constantsDefaultServices.DefaultServices.get(this.props.person.get('needKey')).get('description') : 'investments';
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__stats-widget__item margin' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-label' },
	                        'VouchedFor Advisers'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-sub-label push-down-10' },
	                        serviceDescription
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__stats-widget__number spaced' },
	                        _react2['default'].createElement(_elementsCounter2['default'], { from: this.oldStats.total,
	                            to: this.props.total, delay: 30, speed: 1200 })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__stats-widget__item margin' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-label' },
	                        'Average rating'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-sub-label push-down-10' },
	                        'from genuine client reviews'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__stats-widget__number padding-right-45' },
	                        this.props.averageScore,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__stats-widget__icon' },
	                            _react2['default'].createElement(_iconsIcon2['default'], { icon: 'star', style: { fill: 'gold' }, size: '26px' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-sub-label push-down-10' },
	                        'out of 5 stars'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__stats-widget__item' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-label' },
	                        'Clients helped'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-sub-label push-down-10' },
	                        'who have received advice from these IFAs'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-orientation' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__stats-widget__number spaced full' },
	                            _react2['default'].createElement(_elementsCounter2['default'], { from: this.oldStats.averageScore,
	                                to: this.props.reviewsCount, delay: 30, speed: 1200 })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'vertical-label__list--mobile' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-label--mobile' },
	                        'Advisers'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-label--mobile' },
	                        'out of 5'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'vertical-label--mobile' },
	                        'reviews'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderHorizontalMode',
	        value: function renderHorizontalMode() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__stats-widget__container' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'mobile-line' },
	                    'VouchedFor has'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__stats-widget__number spaced' },
	                    _react2['default'].createElement(_elementsCounter2['default'], { from: this.oldStats.total,
	                        to: this.props.total, delay: 30, speed: 1200 })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'mobile-line' },
	                    'advisers who can help with this, with an average review rating of'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'app__stats-widget__number padding-right-45' },
	                    this.props.averageScore,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__stats-widget__icon' },
	                        _react2['default'].createElement(_iconsIcon2['default'], { icon: 'star', style: { fill: 'gold' }, size: '26px' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'line' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'mobile-line' },
	                        'They\'ve helped'
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__stats-widget__number spaced' },
	                        _react2['default'].createElement(_elementsCounter2['default'], { from: this.oldStats.averageScore,
	                            to: this.props.reviewsCount, delay: 30, speed: 1200 })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'mobile-line' },
	                        'others like you'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var container = this.props.isVertical ? this.renderVerticalMode() : this.renderHorizontalMode();
	            var verticalMode = this.props.isVertical ? 'vertical-mode' : '';
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__stats-widget__container ' + verticalMode },
	                container
	            );
	        }
	    }]);
	
	    return StatsWidget;
	})(_react.Component);
	
	exports.StatsWidget = StatsWidget;
	
	StatsWidget.propTypes = {
	    person: _react2['default'].PropTypes.object,
	    actions: _react2['default'].PropTypes.object,
	
	    total: _react2['default'].PropTypes.number,
	    reviewsCount: _react2['default'].PropTypes.number,
	    averageScore: _react2['default'].PropTypes.number,
	
	    isVertical: _react2['default'].PropTypes.bool
	};
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	
	        total: state.stats.get('total'),
	        reviewsCount: state.stats.get('reviewsCount'),
	        averageScore: state.stats.get('averageScore')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StatsWidget);

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _elementsEditableInput = __webpack_require__(810);
	
	var _elementsCustomCheckbox = __webpack_require__(860);
	
	var _elementsDropdown = __webpack_require__(814);
	
	var _elementsDropdown2 = _interopRequireDefault(_elementsDropdown);
	
	var _elementsRadioGroup = __webpack_require__(864);
	
	var _elementsRadioGroup2 = _interopRequireDefault(_elementsRadioGroup);
	
	var _iconsIcon = __webpack_require__(798);
	
	var _iconsIcon2 = _interopRequireDefault(_iconsIcon);
	
	var _constantsMatchSteps = __webpack_require__(865);
	
	var ContactForm = (function (_Component) {
	    _inherits(ContactForm, _Component);
	
	    function ContactForm() {
	        _classCallCheck(this, ContactForm);
	
	        _get(Object.getPrototypeOf(ContactForm.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ContactForm, [{
	        key: 'handleChange',
	        value: function handleChange(event) {
	            if (event.target.name === 'dbPension') {
	                this.props.actions.updatePersonAttribute('adviceArea', event.target.value ? 557 : 393);
	            }
	
	            this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'renderMortgageQuestions',
	        value: function renderMortgageQuestions() {
	            if (this.props.person.get('adviceArea') === 392) {
	                var maxWidthInputs = '280px';
	
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'mortgageValue',
	                        ref: 'mortgageValue',
	                        label: 'What is the value of the property you want to purchase or remortgage?',
	                        placeholder: '£50,000',
	                        value: this.props.person.get('mortgageValue'),
	                        widthProportion: 'fixed',
	                        fixedWidth: maxWidthInputs,
	                        maskType: 'currency',
	                        handleChange: this.handleChange.bind(this),
	                        invalidSubmit: this.props.invalidSubmit,
	                        required: true }),
	                    _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'deposit',
	                        ref: 'deposit',
	                        label: 'What is your potential deposit (or remortgage amount)?',
	                        placeholder: '£10,000',
	                        value: this.props.person.get('deposit'),
	                        widthProportion: 'fixed',
	                        fixedWidth: maxWidthInputs,
	                        maskType: 'currency',
	                        handleChange: this.handleChange.bind(this),
	                        invalidSubmit: this.props.invalidSubmit,
	                        required: true }),
	                    _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'annualIncome',
	                        ref: 'annualIncome',
	                        label: 'What is your annual income? (If it\'s a joint mortgage, enter your combined income)',
	                        placeholder: '£35,000',
	                        value: this.props.person.get('annualIncome'),
	                        widthProportion: 'fixed',
	                        fixedWidth: maxWidthInputs,
	                        maskType: 'currency',
	                        handleChange: this.handleChange.bind(this),
	                        invalidSubmit: this.props.invalidSubmit,
	                        required: true }),
	                    _react2['default'].createElement(
	                        'p',
	                        { className: 'info-message' },
	                        'Please ensure your property value minus your deposit doesn\'t exceed 5 times your income as it\'s unlikely you\'ll be able to get a mortgage.'
	                    ),
	                    _react2['default'].createElement(
	                        'label',
	                        { className: 'semi-bold inline-block push-down-10' },
	                        'When are you looking to purchase the property or remortgage?'
	                    ),
	                    _react2['default'].createElement(_elementsDropdown2['default'], { name: 'adviceTime',
	                        ref: 'adviceTime',
	                        value: this.props.person.get('adviceTime'),
	                        optionsType: 'adviceTime',
	                        widthProportion: 'fixed',
	                        invalidSubmit: this.props.invalidSubmit,
	                        handleChange: this.handleChange.bind(this),
	                        fixedWidth: maxWidthInputs,
	                        required: true })
	                );
	            }
	
	            return _react2['default'].createElement('div', null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var maxWidthInputs = '280px';
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'postcode',
	                    ref: 'postcode',
	                    label: 'What is your postcode?',
	                    placeholder: 'SW1A 0AA',
	                    value: this.props.person.get('postcode'),
	                    maxLength: 8,
	                    invalidSubmit: this.props.invalidSubmit,
	                    widthProportion: 'fixed',
	                    fixedWidth: maxWidthInputs,
	                    handleChange: this.handleChange.bind(this),
	                    required: true }),
	                this.props.person.get('adviceArea') !== 392 && _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'wealthLevel',
	                    ref: 'wealthLevel',
	                    label: 'What is the total value of your savings? (excluding property)',
	                    placeholder: '£50,000',
	                    value: this.props.person.get('wealthLevel'),
	                    widthProportion: 'fixed',
	                    fixedWidth: maxWidthInputs,
	                    maskType: 'currency',
	                    handleChange: this.handleChange.bind(this),
	                    invalidSubmit: this.props.invalidSubmit,
	                    required: true }),
	                this.props.person.get('adviceArea') === 392 && this.renderMortgageQuestions(),
	                _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'fullName',
	                    ref: 'fullName',
	                    label: 'Your full name',
	                    placeholder: 'Fred Smith',
	                    widthProportion: 'fixed',
	                    fixedWidth: maxWidthInputs,
	                    value: this.props.person.get('fullName'),
	                    handleChange: this.handleChange.bind(this),
	                    invalidSubmit: this.props.invalidSubmit,
	                    required: true }),
	                _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'email',
	                    ref: 'email',
	                    label: 'Your email',
	                    placeholder: 'fred@fs.com',
	                    validations: 'isEmail',
	                    validationError: 'This is not a valid email',
	                    value: this.props.person.get('email'),
	                    handleChange: this.handleChange.bind(this),
	                    invalidSubmit: this.props.invalidSubmit,
	                    widthProportion: 'fixed',
	                    fixedWidth: maxWidthInputs,
	                    hintText: 'This is where we will send your confirmation email',
	                    required: true }),
	                _react2['default'].createElement(_elementsEditableInput.FormEditableInput, { name: 'phone',
	                    ref: 'phone',
	                    label: 'Your phone number',
	                    placeholder: '01234 567 890',
	                    value: this.props.person.get('phone'),
	                    maxLength: 13,
	                    invalidSubmit: this.props.invalidSubmit,
	                    widthProportion: 'fixed',
	                    fixedWidth: maxWidthInputs,
	                    handleChange: this.handleChange.bind(this),
	                    hintText: 'Your chosen adviser will give you a quick call to offer you ideas. Please enter a valid UK telephone number, e.g. 01234 567 890',
	                    maskType: 'phoneNumber',
	                    required: true }),
	                (this.props.person.get('adviceArea') === 393 || this.props.person.get('adviceArea') === 557) && _react2['default'].createElement(_elementsCustomCheckbox.FormCustomCheckbox, { name: 'dbPension',
	                    label: 'I have a final salary / defined benefit pension',
	                    value: this.props.person.get('dbPension'),
	                    handleChange: this.handleChange.bind(this) }),
	                _react2['default'].createElement(_elementsRadioGroup2['default'], {
	                    name: 'isLocationImportant',
	                    label: 'Do you mind where your adviser is based?',
	                    options: [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }],
	                    required: true,
	                    onChange: this.handleChange.bind(this)
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'push-up-20' },
	                    _react2['default'].createElement(
	                        'button',
	                        { className: 'bigger-button vouchedfor-brand', name: 'next',
	                            onClick: this.props.handler.bind(this, _constantsMatchSteps.MatchSteps.CONTACT_FORM) },
	                        'Get help with my mortgage'
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'inline-block text-align-center push-up-20' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'app__form-page__security-message' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'app__form-page__security-message__icon' },
	                            _react2['default'].createElement(_iconsIcon2['default'], { icon: 'lock', size: '22px' })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            null,
	                            'You are protected by SSL security. We go above and beyond industry standards to ensure your data is safe'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactForm;
	})(_react.Component);
	
	exports.ContactForm = ContactForm;
	
	ContactForm.propTypes = {
	    person: _react2['default'].PropTypes.object,
	    actions: _react2['default'].PropTypes.object,
	
	    handler: _react2['default'].PropTypes.func,
	
	    invalidSubmit: _react2['default'].PropTypes.bool,
	    canSubmit: _react2['default'].PropTypes.bool
	};
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Actions, dispatch)
	    };
	}
	
	function mapStateToProps(state) {
	    return {
	        person: state.reducer.get('person'),
	
	        invalidSubmit: state.navigation.get('invalidSubmit'),
	        canSubmit: state.navigation.get('canSubmit')
	    };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContactForm);

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

	
	/* eslint no-unused-vars: 0 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var RadioGroup = function RadioGroup(props) {
	    var name = props.name;
	    var label = props.label;
	    var onChange = props.onChange;
	    var options = props.options;
	
	    var rest = _objectWithoutProperties(props, ["name", "label", "onChange", "options"]);
	
	    return _react2["default"].createElement(
	        "div",
	        { className: "app__custom-radiogroup" },
	        _react2["default"].createElement(
	            "div",
	            { className: "app__editable-input__label" },
	            label
	        ),
	        options.map(function (option) {
	            return _react2["default"].createElement(
	                "label",
	                { className: "app__custom-radiogroup__input" },
	                _react2["default"].createElement("input", _extends({
	                    type: "radio",
	                    name: name,
	                    onChange: onChange
	                }, rest, {
	                    value: option.value
	                })),
	                option.label
	            );
	        })
	    );
	};
	
	exports["default"] = RadioGroup;
	module.exports = exports["default"];

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MatchSteps = {
	    WEALTH_LEVEL_QUESTION: 1,
	    LOCATION_QUESTION: 2,
	    CONTACT_FORM: 3
	};
	exports.MatchSteps = MatchSteps;

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var StaticFooter = (function (_Component) {
	    _inherits(StaticFooter, _Component);
	
	    function StaticFooter() {
	        _classCallCheck(this, StaticFooter);
	
	        _get(Object.getPrototypeOf(StaticFooter.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(StaticFooter, [{
	        key: "render",
	        value: function render() {
	            return _react2["default"].createElement(
	                "div",
	                { className: "app__static__footer__container" },
	                _react2["default"].createElement(
	                    "div",
	                    { className: "app__grid__row" },
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "app__grid__column__four-one footer__column" },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: "footer__columns__center-wrapper" },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "semi-bold" },
	                                "Find an adviser"
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.vouchedfor.co.uk/financial-advisor-ifa/" },
	                                    "IFAs"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.vouchedfor.co.uk/mortgage-advisor/" },
	                                    "Mortgage Advisers"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.vouchedfor.co.uk/solicitor/" },
	                                    "Legal Advisers"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.vouchedfor.co.uk/accountant/" },
	                                    "Accountants"
	                                )
	                            )
	                        )
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "app__grid__column__four-one footer__column" },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: "footer__columns__center-wrapper" },
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "semi-bold" },
	                                "Company"
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "http://about.vouchedfor.co.uk/about", target: "_blank" },
	                                    "About Us"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.vouchedfor.co.uk/blog", target: "_blank" },
	                                    "Tips & Guides"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.vouchedfor.co.uk/privacy-policy" },
	                                    "Legal & Cookies"
	                                )
	                            )
	                        )
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "app__grid__column__four-one app__grid__column__two-one--mobile footer__column" },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: "footer__columns__center-wrapper" },
	                            _react2["default"].createElement(
	                                "span",
	                                { className: "semi-bold" },
	                                "VouchedFor professional?"
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://accounts.vouchedfor.co.uk/register" },
	                                    "Sign up"
	                                ),
	                                " |",
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://accounts.vouchedfor.co.uk/" },
	                                    "Log in"
	                                )
	                            )
	                        )
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        { className: "app__grid__column__four-one footer__column" },
	                        _react2["default"].createElement(
	                            "div",
	                            { className: "footer__columns__center-wrapper" },
	                            _react2["default"].createElement(
	                                "span",
	                                { className: "semi-bold" },
	                                "Social"
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.facebook.com/pages/VouchedFor/158173767573318", target: "_blank" },
	                                    "Facebook"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://twitter.com/VouchedFor", target: "_blank" },
	                                    "Twitter"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://www.linkedin.com/company/vouchedfor", target: "_blank" },
	                                    "LinkedIn"
	                                )
	                            ),
	                            _react2["default"].createElement(
	                                "div",
	                                { className: "footer__link" },
	                                _react2["default"].createElement(
	                                    "a",
	                                    { href: "https://plus.google.com/105770956844370682123/posts", target: "_blank" },
	                                    "Google+"
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2["default"].createElement(
	                    "div",
	                    { className: "footer__row" },
	                    _react2["default"].createElement(
	                        "div",
	                        null,
	                        "VouchedFor LTD is a limited company registered in England and Wales with registered number 07485300."
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        null,
	                        "Our registered office and place of business is at 8 Waldegrave Road, Teddington, Middlesex, TW11 8HT."
	                    ),
	                    _react2["default"].createElement(
	                        "div",
	                        null,
	                        _react2["default"].createElement(
	                            "span",
	                            null,
	                            "© VouchedFor 2021 • "
	                        ),
	                        _react2["default"].createElement(
	                            "span",
	                            null,
	                            "0203 111 0580"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StaticFooter;
	})(_react.Component);
	
	exports["default"] = StaticFooter;
	module.exports = exports["default"];

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(693);
	
	/* eslint max-len: 0 */
	
	var LinkErrorPage = (function (_Component) {
	    _inherits(LinkErrorPage, _Component);
	
	    function LinkErrorPage() {
	        _classCallCheck(this, LinkErrorPage);
	
	        _get(Object.getPrototypeOf(LinkErrorPage.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(LinkErrorPage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.location !== '404') {
	                _reactRouter.browserHistory.push('404');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'app__message-page__container' },
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'semi-bold push-down-30' },
	                    'Page not found'
	                ),
	                _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: '/' },
	                    'Go to home page'
	                )
	            );
	        }
	    }]);
	
	    return LinkErrorPage;
	})(_react.Component);
	
	exports['default'] = LinkErrorPage;
	module.exports = exports['default'];

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint no-unused-vars: 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports.loadComponent = loadComponent;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(147);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(159);
	
	var _reactRedux = __webpack_require__(179);
	
	var _reactRouter = __webpack_require__(693);
	
	var _actionsActions = __webpack_require__(787);
	
	var Actions = _interopRequireWildcard(_actionsActions);
	
	var _servicesWindowEventsHandler = __webpack_require__(795);
	
	var _servicesWindowEventsHandler2 = _interopRequireDefault(_servicesWindowEventsHandler);
	
	/*
	- Checks when client presses back button if the form submitted and returns to home page.
	 */
	
	function loadComponent(ComponentWrapped) {
	    var LoadingWrapper = (function (_Component) {
	        _inherits(LoadingWrapper, _Component);
	
	        function LoadingWrapper() {
	            _classCallCheck(this, LoadingWrapper);
	
	            _get(Object.getPrototypeOf(LoadingWrapper.prototype), 'constructor', this).call(this);
	            this.state = { renderComponent: false };
	        }
	
	        _createClass(LoadingWrapper, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                this.checkAttributes(this.props);
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                this.checkAttributes(nextProps);
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                _servicesWindowEventsHandler2['default'].enableUnloadMessage();
	            }
	        }, {
	            key: 'checkAttributes',
	            value: function checkAttributes(props) {
	                if (!props.loading && !props.submitted) {
	                    this.setState({ renderComponent: true });
	                } else if (!props.loading) {
	                    _reactRouter.browserHistory.push('/');
	                    this.setState({ renderComponent: false });
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2['default'].createElement(
	                    'div',
	                    null,
	                    this.state.renderComponent ? _react2['default'].createElement(ComponentWrapped, this.props) : null
	                );
	            }
	        }]);
	
	        return LoadingWrapper;
	    })(_react.Component);
	
	    LoadingWrapper.propTypes = {
	        loading: _react2['default'].PropTypes.bool,
	        submitted: _react2['default'].PropTypes.bool,
	        started: _react2['default'].PropTypes.bool
	    };
	
	    function mapStateToProps(state) {
	        return {
	            loading: state.reducer.get('loading'),
	            submitted: state.reducer.get('submitted'),
	            started: state.reducer.get('started')
	        };
	    }
	
	    return (0, _reactRedux.connect)(mapStateToProps)(LoadingWrapper);
	}

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWFnZXMvYXJyb3dfZG93bi5wbmciOw=="

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(871);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(836)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(835)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700);", ""]);
	
	// module
	exports.push([module.id, ".h1.vouchedfor-brand,h1.vouchedfor-brand{font-size:26px;font-weight:400;color:#022d4f}.h2.vouchedfor-brand,h2.vouchedfor-brand{font-size:22px;margin-bottom:8px;color:#4bc1ca}.h3.vouchedfor-brand,h3.vouchedfor-brand{font-size:18px;margin-bottom:10px;font-weight:700;color:#e43b58}.h4.vouchedfor-brand,h4.vouchedfor-brand{font-size:16px;font-weight:600;color:#022d4f}.h5.vouchedfor-brand,h5.vouchedfor-brand{font-size:24px;font-weight:600;color:#022d4f}h1.vouchedfor-brand+.sub-heading,h2.vouchedfor-brand+.sub-heading,h3.vouchedfor-brand+.sub-heading,h4.vouchedfor-brand+.sub-heading,h5.vouchedfor-brand+.sub-heading{font-size:16px}.app__icon__add_item{display:inline-block;width:30px;height:30px;border-radius:50%;box-shadow:2px 2px 2px #022d4f!important;font-size:18px;font-weight:700;background-color:#4bc1ca;color:#eeebe9;padding:3px;text-align:center;margin-right:10px}.big-button.vouchedfor-brand,.bigger-button.vouchedfor-brand,.button-common,.button.vouchedfor-brand{box-shadow:2px 2px 0 rgba(0,0,0,.5);color:#eeebe9;background-color:#4282f3;min-width:180px;cursor:pointer;border:none}.big-button.vouchedfor-brand:disabled,.bigger-button.vouchedfor-brand:disabled,.button-common.disabled,.button-common:disabled,.button.vouchedfor-brand:disabled,.disabled.big-button.vouchedfor-brand,.disabled.bigger-button.vouchedfor-brand,.disabled.button.vouchedfor-brand{background-color:grey}.big-button.vouchedfor-brand:hover:not(.disabled):not(.secondary),.bigger-button.vouchedfor-brand:hover:not(.disabled):not(.secondary),.button-common:hover:not(.disabled):not(.secondary),.button.vouchedfor-brand:hover:not(.disabled):not(.secondary){background-color:rgba(66,130,243,.75)}.button-common.primary,.primary.big-button.vouchedfor-brand,.primary.bigger-button.vouchedfor-brand,.primary.button.vouchedfor-brand{background-color:#4282f3}.button-common.primary:hover:not(.disabled),.primary.big-button.vouchedfor-brand:hover:not(.disabled),.primary.bigger-button.vouchedfor-brand:hover:not(.disabled),.primary.button.vouchedfor-brand:hover:not(.disabled){background-color:rgba(66,130,243,.75)}.button-common.secondary,.secondary.big-button.vouchedfor-brand,.secondary.bigger-button.vouchedfor-brand,.secondary.button.vouchedfor-brand{background-color:#4bc1ca}.button-common.secondary:hover:not(.disabled),.secondary.big-button.vouchedfor-brand:hover:not(.disabled),.secondary.bigger-button.vouchedfor-brand:hover:not(.disabled),.secondary.button.vouchedfor-brand:hover:not(.disabled){background-color:rgba(75,193,202,.75)}.button-common.tertiary,.tertiary.big-button.vouchedfor-brand,.tertiary.bigger-button.vouchedfor-brand,.tertiary.button.vouchedfor-brand{background-color:#e43b58}.button-common.tertiary:hover,.tertiary.big-button.vouchedfor-brand:hover,.tertiary.bigger-button.vouchedfor-brand:hover,.tertiary.button.vouchedfor-brand:hover{background-color:rgba(228,59,88,.75)}.back.big-button.vouchedfor-brand,.back.bigger-button.vouchedfor-brand,.back.button.vouchedfor-brand,.button-common.back{background-color:#f3d3c7;color:#fff}.back.big-button.vouchedfor-brand:hover:not(.disabled),.back.bigger-button.vouchedfor-brand:hover:not(.disabled),.back.button.vouchedfor-brand:hover:not(.disabled),.button-common.back:hover:not(.disabled){background-color:hsla(16,65%,87%,.75)}.button-common.mobile-button,.mobile-button.big-button.vouchedfor-brand,.mobile-button.bigger-button.vouchedfor-brand,.mobile-button.button.vouchedfor-brand{min-width:inherit;width:50%}@media (min-width:768px){.button-common.mobile-button,.mobile-button.big-button.vouchedfor-brand,.mobile-button.bigger-button.vouchedfor-brand,.mobile-button.button.vouchedfor-brand{margin:0 10px;min-width:180px}}.big-button.vouchedfor-brand{padding:10px}@media (min-width:768px){.big-button.vouchedfor-brand{font-size:20px;padding:15px;width:260px}}.big-button.vouchedfor-brand.big-mobile{width:100%;font-size:18px;padding:15px}.bigger-button.vouchedfor-brand{padding:10px}@media (min-width:768px){.bigger-button.vouchedfor-brand{font-size:20px;padding:15px;width:290px!important}}.bigger-button.vouchedfor-brand.big-mobile{font-size:16px;padding:15px;width:260px}.button.vouchedfor-brand{padding:10px}@media (min-width:768px){.button.vouchedfor-brand{width:auto!important}}.app__link__delete{font-size:14px;float:right;text-align:right;text-decoration:underline;cursor:pointer}.app__box{float:left;width:100%}.link-primary,.link-primary:active,.link-primary:focus{color:#4bc1ca;text-decoration:underline}.link-primary-inverted,.link-primary-inverted:active,.link-primary-inverted:focus{color:#eeebe9;text-decoration:underline}.app__grid__row{margin-bottom:20px;position:relative}.app__grid__column__two-one,.app__grid__row{float:left;width:100%}@media (min-width:768px){.app__grid__column__two-one{width:50%}}.app__grid__column__three-one{float:left;width:100%}@media (min-width:768px){.app__grid__column__three-one{width:33.33333%}}.app__grid__column__three-two-one{float:left;width:100%}@media (min-width:768px){.app__grid__column__three-two-one{width:50%}}@media (min-width:1200px){.app__grid__column__three-two-one{width:33.33333%}}.app__grid__column__three-two{float:left;width:100%}@media (min-width:768px){.app__grid__column__three-two{width:66.66667%}}.app__grid__column__four-one,.app__grid__column__one-one{float:left;width:100%}@media (min-width:768px){.app__grid__column__four-one{width:25%}}.app__grid__column__four-three{float:left;width:100%}@media (min-width:768px){.app__grid__column__four-three{width:75%}}.app__grid__column__six-one{float:left;width:100%}@media (min-width:768px){.app__grid__column__six-one{width:33.33333%}}@media (min-width:1200px){.app__grid__column__six-one{width:16.66667%}}.app__grid__column__six-one__mobile__three-one{float:left;width:33.33333%}@media (min-width:768px){.app__grid__column__six-one__mobile__three-one{width:16.66667%}}.app__dropdown .full.app__editable-input__input,.app__dropdown .full.app__goal-item__amount__input,.app__editable-input .full.app__editable-input__input,.app__editable-input .full.app__goal-item__amount__input,.app__goal-item__amount .full.app__editable-input__input,.app__goal-item__amount .full.app__goal-item__amount__input,.app__multiselect .full.app__editable-input__input,.app__multiselect .full.app__goal-item__amount__input,.app__proportions.full,.app__selector .full.app__editable-input__input,.app__selector .full.app__goal-item__amount__input,.full.app__dropdown__dropdown,.full.app__editable-input-main__input,.full.app__multiselect__select,.full.app__selector__set{width:100%}@media only screen and (max-device-width:768px){.app__dropdown .fixed.app__editable-input__input,.app__dropdown .fixed.app__goal-item__amount__input,.app__editable-input .fixed.app__editable-input__input,.app__editable-input .fixed.app__goal-item__amount__input,.app__goal-item__amount .fixed.app__editable-input__input,.app__goal-item__amount .fixed.app__goal-item__amount__input,.app__multiselect .fixed.app__editable-input__input,.app__multiselect .fixed.app__goal-item__amount__input,.app__proportions.fixed,.app__selector .fixed.app__editable-input__input,.app__selector .fixed.app__goal-item__amount__input,.fixed.app__dropdown__dropdown,.fixed.app__editable-input-main__input,.fixed.app__multiselect__select,.fixed.app__selector__set{width:100%!important}}.app__dropdown .two-thirds.app__editable-input__input,.app__dropdown .two-thirds.app__goal-item__amount__input,.app__editable-input .two-thirds.app__editable-input__input,.app__editable-input .two-thirds.app__goal-item__amount__input,.app__goal-item__amount .two-thirds.app__editable-input__input,.app__goal-item__amount .two-thirds.app__goal-item__amount__input,.app__multiselect .two-thirds.app__editable-input__input,.app__multiselect .two-thirds.app__goal-item__amount__input,.app__proportions.two-thirds,.app__selector .two-thirds.app__editable-input__input,.app__selector .two-thirds.app__goal-item__amount__input,.two-thirds.app__dropdown__dropdown,.two-thirds.app__editable-input-main__input,.two-thirds.app__multiselect__select,.two-thirds.app__selector__set{width:66.66667%}.app__dropdown .half.app__editable-input__input,.app__dropdown .half.app__goal-item__amount__input,.app__editable-input .half.app__editable-input__input,.app__editable-input .half.app__goal-item__amount__input,.app__goal-item__amount .half.app__editable-input__input,.app__goal-item__amount .half.app__goal-item__amount__input,.app__multiselect .half.app__editable-input__input,.app__multiselect .half.app__goal-item__amount__input,.app__proportions.half,.app__selector .half.app__editable-input__input,.app__selector .half.app__goal-item__amount__input,.half.app__dropdown__dropdown,.half.app__editable-input-main__input,.half.app__multiselect__select,.half.app__selector__set{width:50%}.app__dropdown .third.app__editable-input__input,.app__dropdown .third.app__goal-item__amount__input,.app__editable-input .third.app__editable-input__input,.app__editable-input .third.app__goal-item__amount__input,.app__goal-item__amount .third.app__editable-input__input,.app__goal-item__amount .third.app__goal-item__amount__input,.app__multiselect .third.app__editable-input__input,.app__multiselect .third.app__goal-item__amount__input,.app__proportions.third,.app__selector .third.app__editable-input__input,.app__selector .third.app__goal-item__amount__input,.third.app__dropdown__dropdown,.third.app__editable-input-main__input,.third.app__multiselect__select,.third.app__selector__set{width:33.33333%}.app__dropdown .quarter.app__editable-input__input,.app__dropdown .quarter.app__goal-item__amount__input,.app__editable-input .quarter.app__editable-input__input,.app__editable-input .quarter.app__goal-item__amount__input,.app__goal-item__amount .quarter.app__editable-input__input,.app__goal-item__amount .quarter.app__goal-item__amount__input,.app__multiselect .quarter.app__editable-input__input,.app__multiselect .quarter.app__goal-item__amount__input,.app__proportions.quarter,.app__selector .quarter.app__editable-input__input,.app__selector .quarter.app__goal-item__amount__input,.quarter.app__dropdown__dropdown,.quarter.app__editable-input-main__input,.quarter.app__multiselect__select,.quarter.app__selector__set{width:25%}.app__hint{position:relative;display:none;font-size:14px;color:#4bc1ca;background-color:#fff;border:1px solid #4bc1ca;padding:8px 15px 10px;z-index:10;white-space:pre-line;width:100%;margin:10px 0}@media (min-width:1024px){.app__hint{width:320px;min-height:45px;position:absolute;text-align:left;right:-330px;top:-20px}}.app__hint:before{position:absolute;display:inline-block;content:\"\";width:1px;top:-10px;left:12px;border-left:15px solid transparent;border-right:15px solid transparent;border-bottom:10px solid #fff}@media (min-width:1024px){.app__hint:before{top:0;left:-16px;margin-left:-8px;width:0;height:0;border-top:16px solid transparent;border-bottom:16px solid transparent;border-right:16px solid #fff}}.app__dropdown .app__editable-input__input:focus+.app__hint,.app__dropdown .app__goal-item__amount__input:focus+.app__hint,.app__editable-input .app__editable-input__input:focus+.app__hint,.app__editable-input .app__goal-item__amount__input:focus+.app__hint,.app__goal-item__amount .app__editable-input__input:focus+.app__hint,.app__goal-item__amount .app__goal-item__amount__input:focus+.app__hint,.app__hint--focus:focus+.app__hint,.app__multiselect .app__editable-input__input:focus+.app__hint,.app__multiselect .app__goal-item__amount__input:focus+.app__hint,.app__selector .app__editable-input__input:focus+.app__hint,.app__selector .app__goal-item__amount__input:focus+.app__hint{display:inline-block}.app__dropdown,.app__editable-input,.app__goal-item__amount,.app__multiselect,.app__selector{position:relative;clear:both}.app__dropdown .app__editable-input__input,.app__dropdown .app__goal-item__amount__input,.app__editable-input .app__editable-input__input,.app__editable-input .app__goal-item__amount__input,.app__goal-item__amount .app__editable-input__input,.app__goal-item__amount .app__goal-item__amount__input,.app__multiselect .app__editable-input__input,.app__multiselect .app__goal-item__amount__input,.app__selector .app__editable-input__input,.app__selector .app__goal-item__amount__input{display:inline-block;font-size:inherit;color:inherit;text-align:inherit;border:1px solid #4bc1ca;border-radius:5px;padding:6px;margin-bottom:15px}.app__dropdown .app__editable-input__input:focus,.app__dropdown .app__goal-item__amount__input:focus,.app__editable-input .app__editable-input__input:focus,.app__editable-input .app__goal-item__amount__input:focus,.app__goal-item__amount .app__editable-input__input:focus,.app__goal-item__amount .app__goal-item__amount__input:focus,.app__multiselect .app__editable-input__input:focus,.app__multiselect .app__goal-item__amount__input:focus,.app__selector .app__editable-input__input:focus,.app__selector .app__goal-item__amount__input:focus{text-decoration:none}.app__dropdown .app__editable-input__input:read-only,.app__dropdown .app__goal-item__amount__input:read-only,.app__editable-input .app__editable-input__input:read-only,.app__editable-input .app__goal-item__amount__input:read-only,.app__goal-item__amount .app__editable-input__input:read-only,.app__goal-item__amount .app__goal-item__amount__input:read-only,.app__multiselect .app__editable-input__input:read-only,.app__multiselect .app__goal-item__amount__input:read-only,.app__selector .app__editable-input__input:read-only,.app__selector .app__goal-item__amount__input:read-only{background-color:#4bc1ca}.app__dropdown__label,.app__dropdown__label--mobile,.app__editable-input__label,.app__editable-input__label--mobile,.app__goal-item__amount__label,.app__goal-item__amount__label--mobile,.app__multiselect__label,.app__multiselect__label--mobile,.app__selector__label,.app__selector__label--mobile{float:left;font-weight:600;width:100%;margin-bottom:10px}.app__dropdown__label--mobile,.app__editable-input__label--mobile,.app__goal-item__amount__label--mobile,.app__multiselect__label--mobile,.app__selector__label--mobile{text-align:left}@media (min-width:1024px){.app__dropdown__label--mobile,.app__editable-input__label--mobile,.app__goal-item__amount__label--mobile,.app__multiselect__label--mobile,.app__selector__label--mobile{display:none}}.app__editable-input-main__error-message,.app__editable-input__error-message{width:100%;float:left;margin:10px 0;font-weight:700;color:#e43b58}.app__editable-input__required-message{margin-left:10px;font-weight:700;color:#e43b58}.app__editable-input--required,.app__editable-input-main--required,.app__goal-item__amount--required{border-color:red!important}.app__editable-input__container-hint{display:inline;position:relative}.app__goal-item__amount--read-only{display:none!important}.app__editable-input-main{width:100%;padding:5px 0;margin-bottom:15px;font-size:14px;font-weight:600}@media (min-width:768px){.app__editable-input-main{font-size:16px}}.app__editable-input-main__input{display:inline-block;font-size:inherit;color:inherit;text-align:inherit;background-color:transparent;border:none;border-bottom:1px solid #4bc1ca;padding:8px}.app__editable-input-main__input:focus{text-decoration:none;text-shadow:none;outline:none}.app__editable-input-main__label{margin-bottom:10px;width:100%}.app__table__table-row{display:table-row}.app__table__table-cell{display:table-cell}.app__dropdown__dropdown{display:inline-block;font-size:16px;padding:8px;color:inherit;border-color:#4bc1ca;margin-bottom:15px}.app__dropdown__dropdown--required{border-color:red}select{background:#fff;background:#fff url(\"/images/arrow_down.png\") no-repeat 95% 50%;-webkit-appearance:none;-moz-appearance:none}select:focus{outline:none}@media screen and (min-width:0\\0){select{padding:5px}}.app__selector__option{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;cursor:pointer;display:inline-block;font-weight:lighter;color:#022d4f;text-align:center;padding:5px 0;margin-right:20px;width:65px;border:1px solid #4bc1ca;border-radius:5px;background-color:#fff}.app__selector__option--selected{box-shadow:3px 3px 5px 0 #8c8380;color:#eeebe9;background-color:#4bc1ca}.app__selector__set{margin:0 auto 15px}.app__multiselect__select{display:inline-block;font-size:16px;color:inherit;margin-bottom:10px}.app__multiselect__sublabel{font-size:12px;font-weight:lighter}@media (min-width:768px){.app__multiselect__sublabel{font-size:14px}}.app__multiselect__select--required,.app__multiselect__select--required .Select-control{border-color:#e43b58}.Select-control{border-color:#4bc1ca;min-height:54px;padding-bottom:5px}.Select-placeholder{padding-top:7px}.Select--multi .Select-value{width:100%;background-color:#4bc1ca;border-radius:5px;border:1px solid #eeebe9;color:#eeebe9;font-size:14px}.Select--multi .Select-value .Select-value-label{padding:4px 10px 4px 5px}.Select--multi .Select-value-icon:hover{color:#022d4f}.Select-option{color:#022d4f;font-size:14px}.Select-multi-value-wrapper{padding-right:10px;width:100%}.Select-value-label{width:90%}.Select-input{display:block!important;height:auto}.Select-option.is-focused{background-color:#fff;color:#022d4f}@media (min-width:1200px){.Select-option.is-focused{background-color:rgba(75,193,202,.25)}}@media screen and (min-width:0\\0){select{background:none;padding:5px}}.app__custom-checkbox{margin-bottom:10px;font-size:14px}.app__custom-checkbox__input span{margin-left:5px}.app__custom-checkbox-group{display:inline-block;width:100%;margin:10px 0}.app__custom-checkbox-group__row{display:inline-block;margin:10px 30px 0}@media (min-width:768px){.app__custom-checkbox-group__row{display:block;margin:10px 5px 0}}.app__custom-checkbox-group__checkbox--required{box-shadow:0 0 0 1px red}.app__filter-selector__filter{cursor:pointer;display:table;color:#022d4f;float:left;border-radius:5px;border-spacing:7px;height:75px}@media (min-width:768px){.app__filter-selector__filter{height:85px}}.app__filter-selector__filter div{vertical-align:middle;display:table-cell;background-color:#fff;border-radius:5px;padding:0 20px}.app__filter-selector__filter div:hover{background-color:#4282f3;color:#eeebe9}.app__main-section__container{width:100%}.app__main-section{max-width:1280px;margin:5px auto;text-align:center}.app__main-section__actions--alignment{text-align:center}.app__main-section__actions{padding:10px;clear:both;margin-bottom:30px}.app__main-section__form{max-width:920px;padding:10px;margin:auto}@media (min-width:768px){.app__main-section__form{padding:0}}.app__page-title__container{padding:0 20px}@media (min-width:768px){.app__page-title__container{width:70%;margin:auto}}.app__page-title{margin:30px 20px 15px;font-size:20px;font-weight:600;color:#4bc1ca}.app__page-error{display:inline-block;width:100%;font-size:18px;font-weight:600;padding:10px;color:#ff2c45}.app__page-error.small{font-size:16px;margin:15px 0}.app__page-error.initial{font-size:16px;margin:10px 0 0;padding:5px 5px 0}.app__page-error a{color:#4bc1ca}@media (min-width:768px){.app__page-error{padding:0;margin:10px 20px 15px;width:80%}}.app__message-page__container{position:relative;text-align:center;font-size:18px}.app__message-page__container h1{font-size:32px}.app__message-page__container a,.contact-link a{color:#4bc1ca}.app__text-area{display:inline-block;font-size:inherit;color:inherit;border:1px solid #4bc1ca;border-radius:5px;text-align:left;padding:20px;margin-bottom:15px;width:95%;height:320px}.app__text-area:focus{text-decoration:none}@media (min-width:768px){.app__text-area{width:630px}}.app__header__container,.app__header__wrapper{width:100%;text-align:center}.app__header__container{background-color:#022d4f;position:relative}.app__header{position:relative;max-width:1280px;min-height:80px;margin:auto;padding:22px 0 25px}.app__header h1.vouchedfor-brand{color:#eeebe9}.app__header__logo{position:absolute;z-index:100;padding-left:15px}.app__header__logo img{width:200px;cursor:pointer}.app__header__progress{display:inline-block;position:relative;max-width:1280px;width:100%;margin-top:-20px}@media (min-width:768px){.app__header__progress{margin-top:-17px}}.app__header__progress-item{display:inline-block;margin:0 10px}@media (min-width:768px){.app__header__progress-item{margin:0 5%}}@media (min-width:1200px){.app__header__progress-item{margin:0 6%}}.app__header__progress-circle{display:inline-block;height:40px;width:40px;border-radius:50%;border:4px solid #022d4f;background-color:#fff}@media (min-width:768px){.app__header__progress-circle{height:50px;width:50px}}.app__header__progress-circle .progress-circle__checkmark{margin-top:4px}@media (min-width:768px){.app__header__progress-circle .progress-circle__checkmark{margin-top:8px}}.app__header__progress-circle--selected{background-color:#022d4f;border:4px solid #fff}.app__header__actions{position:absolute;display:inline-block;color:#eeebe9;max-width:1280px;width:100%;text-align:left;padding:25px 20px;left:0;top:0}.app__header__actions .underline{text-decoration:underline}@media (min-width:768px){.app__header__actions span{display:inline-block}}@media (min-width:768px){.app__header__actions{text-align:right;padding:0;left:auto;top:20px;right:20px}}.app__header__actions .header__actions__icon{display:inline-block;cursor:pointer}.app__header__actions__phone-number{float:right;display:none}@media (min-width:768px){.app__header__actions__phone-number{float:none;display:inherit}}.app__header__actions__phone-number .app__header__actions__phone-number__number{font-size:24px;vertical-align:bottom}.app__header__actions__phone-number .app__header__actions__phone-number__icon{margin:5px 10px}.app__header__actions__phone-number--mobile{display:inherit}@media (min-width:768px){.app__header__actions__phone-number--mobile{display:none}}.app__header__actions__mobile-left{float:left}@media (min-width:768px){.app__header__actions__mobile-left{float:none}}.app__header__actions__mobile-right{float:right}@media (min-width:768px){.app__header__actions__mobile-right{float:none}}.app__static__footer{position:relative;clear:both;width:100%;bottom:0;left:0;background-color:#022d4f;color:#eeebe9;font-size:12px;height:600px;margin-top:-600px}@media (min-width:768px){.app__static__footer{font-size:14px;height:240px;margin-top:-240px}}.app__static__footer__container{position:relative;max-width:1280px;margin:auto}@media (min-width:768px){.app__static__footer__container{text-align:center}}.footer__column{padding:25px 40px 0}.footer__columns__center-wrapper{display:inline-block;text-align:left}.footer__row{width:100%;padding:10px 50px 10px 25px}.footer__link{margin:5px 0}.footer__link.left{float:left}.footer__link.right{float:right}.app__main-section--full{margin:0 auto;text-align:center}.app__main-section__form--full{padding:0;margin:auto}.app__how-it-works__icon{margin-bottom:15px}.app__how-it-works__info{width:70%;margin:auto;padding-bottom:20px}.app__how-it-works__info a{color:#4bc1ca}@media (min-width:460px){.app__how-it-works__info{padding-bottom:0;width:50%}}@media (min-width:768px){.app__how-it-works__info{width:100%}}.app__how-it-works__icon-order{font-weight:700;font-size:28px;color:#4bc1ca;margin-bottom:5px}.app__how-it-works__list,.app__next-steps__list{margin-top:30px;display:inline-block;position:relative}@media (min-width:768px){.app__how-it-works__list:after,.app__next-steps__list:after{display:inline-block;content:\"\";position:absolute;border-top:2px dashed #4282f3;bottom:auto;height:0;left:auto;right:15%;top:2.6em;width:70%;z-index:-1}}.app__about-us__icon{margin-bottom:15px}.app__about-us__info__header{font-size:18px;font-weight:600;color:#4bc1ca;margin:10px 0}.app__about-us__info{width:70%;margin:auto;padding-bottom:20px}@media (min-width:460px){.app__about-us__info{padding-bottom:0;width:50%}}@media (min-width:768px){.app__about-us__info{width:100%}}.adviser-banner__image{height:450px;background-image:url(\"/images/adviser_banner_xsmall.jpg\");background-repeat:no-repeat;background-size:cover;background-position:0 20%}@media (min-width:768px){.adviser-banner__image{height:500px;background-image:url(\"/images/adviser_banner_small.jpg\")}}@media (min-width:1024px){.adviser-banner__image{height:560px;background-image:url(\"/images/adviser_banner_tablet.jpg\");background-position:50% 0}}@media (min-width:1200px){.adviser-banner__image{background-image:url(\"/images/adviser_banner_medium.jpg\");background-position:50% 25%}}@media (min-width:1600px){.adviser-banner__image{background-image:url(\"/images/adviser_banner_large.jpg\");background-position:50% 10%}}.app__landing-page__adviser-info--left{width:100%;height:450px;background-color:hsla(0,0%,100%,.6);float:left}@media (min-width:768px){.app__landing-page__adviser-info--left{width:50%;height:500px}}@media (min-width:1024px){.app__landing-page__adviser-info--left{height:560px}}.adviser-banner__header{font-size:18px;font-weight:600;display:inline-block;max-width:350px;margin:60px 40px 0}@media (min-width:460px){.adviser-banner__header{margin:60px auto 0}}@media (min-width:768px){.adviser-banner__header{margin:100px auto 0;font-size:24px}}@media (min-width:1024px){.adviser-banner__header{font-size:27px}}@media (min-width:1200px){.adviser-banner__header{max-width:500px}}@media (min-width:1600px){.adviser-banner__header{max-width:650px}}.adviser-banner__subtitle{font-size:14px;max-width:340px;margin:15px auto 20px}@media (min-width:460px){.adviser-banner__subtitle{margin:20px auto}}@media (min-width:768px){.adviser-banner__subtitle{font-size:16px}}@media (min-width:1024px){.adviser-banner__subtitle{font-size:18px}}@media (min-width:1600px){.adviser-banner__subtitle{max-width:380px}}.app__advisers-preview__image{margin-bottom:15px}.app__advisers-preview__image img{border-radius:50%}.app__advisers-preview__info{width:70%;margin:0 auto}@media (min-width:460px){.app__advisers-preview__info{width:50%}}@media (min-width:768px){.app__advisers-preview__info{width:100%}}.app__advisers-preview__adviser-name{font-size:20px}.app__advisers-preview__icon-order{font-weight:700;font-size:28px;color:#4bc1ca;margin-bottom:5px}.app__advisers-preview__list{margin-top:30px;display:inline-block;position:relative;width:100%}.app__advisers-preview__adviser{margin-bottom:40px}@media (min-width:768px){.app__advisers-preview__adviser{margin-bottom:0}}.partner__logo__column__container{display:inline-block;margin:0 5px}.partner__logo__column__container--hidden-mobile{display:none}@media (min-width:768px){.partner__logo__column__container--hidden-mobile{display:inline-block}}.partner__logo__column{float:none;width:100%;display:table-cell;vertical-align:bottom;height:46px}.app__landing-page__featured-in__title__container{position:relative;width:100%}.app__landing-page__featured-in__title{position:absolute;display:inline-block;margin:-35px 0 0 -75px;padding:5px 25px 25px;border-radius:10px 10px 0 0;background-color:#dbf3f5}.app__landing-page__full-image{position:relative;display:inline-block;text-align:center;width:100%}.app__landing-page__hero-banner{max-width:1280px;margin:auto;display:inline-block;width:100%;height:100%}.app__landing-page__hero-banner .hero-banner__up{text-align:center;width:100%;padding-bottom:35px}@media (min-width:460px){.app__landing-page__hero-banner .hero-banner__up{padding-bottom:0;background-color:transparent}}.app__landing-page__hero-banner .hero-banner__up .banner-info{text-align:center;width:100%;margin:20px 0 0}@media (min-width:768px){.app__landing-page__hero-banner .hero-banner__up .banner-info{margin:40px 0}}.app__landing-page__hero-banner .hero-banner__down{z-index:2;width:100%;position:relative}.app__landing-page__hero-banner .hero-banner__down .banner-form{box-shadow:3px 3px 5px 0 #8c8380;background-color:#4bc1ca;margin:0 auto;display:inline-block;width:95%;text-align:center;padding-bottom:20px}.app__landing-page__hero-banner .hero-banner__down .banner-form .app__editable-input__input,.app__landing-page__hero-banner .hero-banner__down .banner-form .app__goal-item__amount__input{padding:15px}.app__landing-page__hero-banner .hero-banner__down .banner-form .app__dropdown__dropdown{padding:17px 8px}.app__landing-page__hero-banner .hero-banner__down .banner-form .banner-form__container{padding:20px 15px}@media (min-width:1200px){.app__landing-page__hero-banner .hero-banner__down .banner-form .banner-form__container{padding:20px 65px 0}}@media (min-width:768px){.app__landing-page__hero-banner .hero-banner__down .banner-form{width:600px;margin:30px auto 0}}@media (min-width:1200px){.app__landing-page__hero-banner .hero-banner__down .banner-form{width:90%;margin:25px auto 0;padding-bottom:15px}}.app__landing-page__hero-banner .hero-banner__down .hero-banner__form-label__container{display:inline-block;margin-bottom:5px}.app__landing-page__hero-banner .hero-banner__down .hero-banner__form-label{display:table-cell;width:305px;vertical-align:bottom;font-weight:600;color:#eeebe9}@media (min-width:1200px){.app__landing-page__hero-banner .hero-banner__down .hero-banner__form-label{height:50px}}.app__landing-page__hero-banner__bullets{position:relative;display:inline-block;text-align:left;width:50%}@media (min-width:768px){.app__landing-page__hero-banner__bullets{width:50%}}.hero-banner__bullets__list{font-weight:600;font-size:16px;margin:0 20px;padding:20px 20px 20px 40px}@media (min-width:768px){.hero-banner__bullets__list{padding:40px 20px 20px 40px;font-size:22px}}@media (min-width:1024px){.hero-banner__bullets__list{font-size:26px;padding:40px 0 0 40px;margin:0 10px}}.hero-banner__bullets__item{width:100%;margin-bottom:10px}@media (min-width:1024px){.hero-banner__bullets__item{margin-bottom:20px}}.hero-banner__bullets__item span.usp-highlight{color:#4bc1ca}.app__landing-page__hero-banner__button-container{display:block;text-align:center;margin:30px 0 0}.hero-banner__image{height:210px;background:#fff url(\"/images/hero_banner_xsmall.jpg\") no-repeat 40% 0;background-size:100%}@media (min-width:768px){.hero-banner__image{background:#fff url(\"/images/hero_banner_large.jpg\") no-repeat 15% 38%;background-size:115%}}@media (min-width:1024px){.hero-banner__image{background:#fff url(\"/images/hero_banner_large.jpg\") no-repeat 15% 38%;background-size:115%}}@media (min-width:1200px){.hero-banner__image{height:400px;background:#fff url(\"/images/hero_banner_large.jpg\") no-repeat 15% 38%;background-size:115%}}h1.hero-banner__header{font-size:28px;font-weight:600;width:98%;margin:0 auto}@media (min-width:768px){h1.hero-banner__header{font-size:28px}}@media (min-width:1024px){h1.hero-banner__header{font-size:40px;width:80%}}.hero-banner__subtitle{font-size:14px;display:inline-block;width:90%;margin:10px auto 20px}@media (min-width:460px){.hero-banner__subtitle{margin:10px 0 20px}}@media (min-width:768px){.hero-banner__subtitle{font-size:16px}}@media (min-width:1024px){.hero-banner__subtitle{margin:30px 0 20px;font-size:18px;width:60%}}.app__verified-details__table-cell{display:table-cell;vertical-align:middle;margin-bottom:15px}.app__verified-details__icon{padding-left:20px;display:table-cell;vertical-align:middle}.app__verified-details__info{display:table-cell;vertical-align:middle;padding:0 15px}.app__verified-details__list{display:table;position:relative;text-align:left;margin:auto;width:100%}@media (min-width:460px){.app__verified-details__list{width:480px}}.app__verified-details{margin:5px 0 20px;font-size:14px}@media (min-width:768px){.app__verified-details{font-size:16px}}.app__landing-page{width:100%}.app__landing-page__section--full{display:inline-block;width:100%;margin:0}.app__landing-page__section{max-width:920px;margin:0 auto}.app__landing-page__section.how-it-works{max-width:1280px;margin:50px auto}@media (min-width:1200px){.app__landing-page__section.how-it-works .how-it-works__container{max-width:900px;margin:0 auto}}.app__landing-page__section.verified-details{max-width:1280px;margin:50px auto}.app__landing-page__section.verified-details .verified-details__container{padding:0 20px}@media (min-width:1200px){.app__landing-page__section.verified-details .verified-details__container{max-width:900px;margin:0 auto}}.app__landing-page__section.advisers-preview{max-width:1280px;margin:50px auto}@media (min-width:1200px){.app__landing-page__section.advisers-preview .advisers-preview__container{max-width:900px;margin:0 auto}}.app__landing-page__section.available-features{margin:50px auto 30px}.app__landing-page__section-inside{position:relative;display:flex}.landing-page__block{margin:40px 0 30px}.landing-page__actions,.landing-page__block{display:inline-block;width:100%}.app__form-page{position:relative;text-align:center}.app__form-page__container{text-align:left;width:100%;padding:10px}@media (min-width:768px){.app__form-page__container{width:80%;margin:auto;padding:10px 20px 20px}}.app__form-page__container .app__start-page__clear-separator{position:relative;margin-bottom:15px}.app__form-page__personal{text-align:left;margin:auto}@media (min-width:768px){.app__form-page__personal{max-width:70%}}.app__form-page__contact{text-align:left;margin:0 auto}.app__form-page__contact h2{text-align:left}@media (min-width:768px){.app__form-page__contact{max-width:70%}}.app__form__actions{float:left;position:relative;width:100%;text-align:center;margin-top:15px}@media (min-width:1200px){.app__form__actions{margin:60px 0 10px}}.app__form-page__security-message{display:table;font-size:12px;max-width:400px;text-align:left}.app__form-page__security-message__icon{padding:5px 10px 10px;display:table-cell;vertical-align:middle}.app__form-page__fake-column{min-height:0}@media (min-width:768px){.app__form-page__fake-column{min-height:32px}}.app__form__page-error{display:inline-block;text-align:center;width:100%;font-size:16px;font-weight:600;padding-top:10px;color:#eeebe9}@media (min-width:1200px){.app__form__page-error{margin-top:-10px}}.app__form__grid__column{float:left;width:100%}@media (min-width:1200px){.app__form__grid__column{width:33.33333%}}.app__contact-page__container{box-shadow:3px 3px 5px 0 #8c8380;position:relative;text-align:center;background-color:#4bc1ca;margin:auto;padding:20px 15px}@media (min-width:768px){.app__contact-page__container{padding:30px;width:70%}}.app__contact-page__container .app__contact-page{text-align:left;display:inline-block;max-width:315px;color:#eeebe9}.app__contact-page__container .app__contact-page input,.app__contact-page__container .app__contact-page select{color:#022d4f}.app__contact-page__how-it-works{margin:0 auto 30px;width:95%}.app__contact-page__how-it-works .app__how-it-works__list,.app__contact-page__how-it-works .app__next-steps__list{margin-top:0}@media (min-width:768px){.app__contact-page__how-it-works .app__how-it-works__list:after,.app__contact-page__how-it-works .app__next-steps__list:after{top:2em}}.app__contact-page__section{max-width:920px;margin:0 auto}.app__contact-page__section.about-us,.app__contact-page__section.featured-in{margin:50px auto}.app__contact-page__section-inside{position:relative;display:flex}.app__next-steps__list{margin-top:10px}.app__match-page__full-image{position:relative;display:inline-block;text-align:center;width:100%}.match-page__image{height:210px;background:#fff url(\"/images/hero_banner_xsmall.jpg\") no-repeat 40% 30%;background-size:100%}@media (min-width:768px){.match-page__image{height:240px;background:#fff url(\"/images/hero_banner_large.jpg\") no-repeat 15% 30%;background-size:115%}}@media (min-width:768px){.app__match-page__container{display:inline-block}}.app__match-page__title{display:inline-block;margin:25px 0;padding:10px 20px 20px}@media (min-width:768px){.app__match-page__title{padding:20px;width:920px}.app__match-page__title h1{font-size:40px!important;font-weight:600!important}}.app__match-page__subtitle{font-size:14px;display:inline-block;margin:10px 0 0}@media (min-width:768px){.app__match-page__subtitle{font-size:16px;width:920px}}@media (min-width:1024px){.app__match-page__subtitle{font-size:20px}}.app__match-page__content{background-color:#4bc1ca;margin:20px auto 40px}@media (min-width:768px){.app__match-page__content{box-shadow:3px 3px 5px 0 #8c8380;margin:20px auto;display:table;width:920px}}.app__match-page__left{position:fixed;left:0;top:0;z-index:105;text-align:center;width:100%}@media (min-width:768px){.app__match-page__left{z-index:0;position:relative;bottom:auto;left:auto;top:auto;display:table-cell;vertical-align:top;width:40%}}@media (min-width:768px){.app__match-page__left .match-page__widget{height:100%}}.app__match-page__right{width:100%}@media (min-width:768px){.app__match-page__right{display:table-cell;width:60%}}.app__match-page__right .match-page__form{background-color:#dbf3f5;padding:0 10px 40px}@media (min-width:768px){.app__match-page__right .match-page__form{text-align:left;background-color:#fff;padding:20px 40px 40px}}.info-message{font-weight:700;font-size:12px;color:red;margin-top:0}.app__match-page__other-actions{background-color:#dde9ff;padding:50px 20px}@media (min-width:768px){.app__match-page__other-actions{padding:50px 30px;margin:60px auto 0}}.app__match-page__other-actions__item{margin:10px auto}@media (min-width:768px){.app__match-page__other-actions__item{width:400px;margin:10px auto}}.app__match-page__other-actions__item:hover .app__match-page__other-actions__icon:before{border-top-color:#4bc1ca;border-right-color:#4bc1ca;border-bottom-color:#4bc1ca;transition:border-top-color .15s linear,border-right-color .15s linear .1s,border-bottom-color .15s linear .2s}.app__match-page__other-actions__item:hover .app__match-page__other-actions__icon:after{border-top:3px solid #4bc1ca;border-left-width:3px;border-right-width:3px;transform:rotate(270deg);transition:transform .4s linear 0s,border-left-width 0s linear .35s}.app__match-page__other-actions__icon{display:inline-block;position:relative;margin-right:10px;border-radius:100%;background-color:#dbf3f5;padding:15px;box-sizing:border-box}.app__match-page__other-actions__icon:after,.app__match-page__other-actions__icon:before{border-radius:100%;box-sizing:border-box;content:\"\";position:absolute;left:0;top:0;width:60px;height:60px}.app__match-page__other-actions__icon:before{border:3px solid transparent}.app__match-page__other-actions__icon:after{border:0 solid transparent}.app__match-page__step-details__container{display:inline-block;width:100%;margin:0;background-color:#dde9ff}.app__match-page__step-details__container .app__match-page__step-details{display:inline-block;margin:0 auto;padding:20px}@media (min-width:768px){.app__match-page__step-details__container .app__match-page__step-details{padding:30px 20px;width:920px}}.app__steps-details__item{padding:15px}@media (min-width:768px){.app__steps-details__item{padding:0 20px}}.app__steps-details__title{font-size:18px;font-weight:600;margin:10px 0}.app__steps-details__circle{display:inline-flex;position:relative;padding:10px;margin-bottom:10px;width:50px;height:50px;border-radius:100%;border:3px solid #4bc1ca;background-color:#fff;z-index:2}.app__steps-details__circle.filled{background-color:#4bc1ca}.app__steps-details__circle .app__steps-details__index{color:#4bc1ca;font-size:20px;font-weight:700;display:inline-block;margin:auto}.app__steps-details__list{display:inline-block;position:relative;width:80%}@media (min-width:768px){.app__steps-details__list:after{display:inline-block;content:\"\";position:absolute;border-top:3px solid #4bc1ca;top:1.7em;bottom:auto;left:auto;right:15%;height:0;width:70%}}.app__steps-details__list.animate:after{transform:scaleX(1)}.app__stats-widget__container{display:inline-block;width:100%;background-color:#4bc1ca;color:#eeebe9;padding:20px}.app__stats-widget__container.vertical-mode{padding:15px 10px 10px}.app__stats-widget__container.vertical-mode .app__stats-widget__number{float:left;margin:0;font-size:20px;width:33.33333%}.app__stats-widget__container.vertical-mode .app__stats-widget__number.spaced{letter-spacing:1px}.app__stats-widget__container.vertical-mode .app__stats-widget__number.full{width:100%}@media (min-width:768px){.app__stats-widget__container.vertical-mode{padding:90px 20px 20px;height:630px}.app__stats-widget__container.vertical-mode .app__stats-widget__number{float:none;margin:0 10px 10px;width:auto}.app__stats-widget__container.vertical-mode .app__stats-widget__number.spaced{letter-spacing:4px}.app__stats-widget__container.vertical-mode .app__stats-widget__number.full{width:auto}}.app__stats-widget__number{display:inline-block;text-align:center;background-color:#fff;color:#022d4f;border:4px solid #e2f5ef;padding:10px;margin:10px;min-width:100px;line-height:1;font-size:22px;font-weight:600}.app__stats-widget__number.spaced{letter-spacing:4px}.app__stats-widget__icon{display:inline-block;position:absolute;margin:-3px 0 0 7px}@media (min-width:768px){.app__stats-widget__item.margin{margin-bottom:50px}}.vertical-label{display:none;font-size:18px}@media (min-width:768px){.vertical-label{display:block;font-size:24px}}.vertical-sub-label{display:none;font-size:14px;font-weight:lighter}@media (min-width:768px){.vertical-sub-label{display:block}}.vertical-orientation{float:left;width:33.33333%}@media (min-width:768px){.vertical-orientation{float:none;width:auto}}.vertical-label__list--mobile{display:block}@media (min-width:768px){.vertical-label__list--mobile{display:none}}.vertical-label--mobile{float:left;font-size:14px;width:33.33333%;line-height:normal;margin-top:5px}.app__landing-page__section.matching.how-it-works{margin:300px auto 50px}@media (min-width:768px){.app__landing-page__section.matching.how-it-works{margin:150px auto 50px}}@media (min-width:1200px){.app__landing-page__section.matching.how-it-works{margin:100px auto 50px}}.hero-banner__down.matching h2{color:#eeebe9;margin-bottom:10px}.hero-banner__down.matching .banner-form{margin:0 auto;width:100%}@media (min-width:768px){.hero-banner__down.matching .banner-form{width:80%}}.hero-banner__down.matching .banner-form__container{padding:20px}.app__email-modal__content{position:absolute;bottom:0;left:0;right:0;height:200px;border:1px solid #4bc1ca;background:#fff;overflow:auto;-webkit-overflow-scrolling:touch;border-radius:4px;outline:none;padding:20px;text-align:center;box-shadow:3px 3px 5px 0 #4bc1ca}.app__email-modal__content h2{margin-bottom:10px}.app__email-modal__content .email-modal__email{margin:20px auto}.app__email-modal__content .email-modal__email input{display:inline-block;font-size:inherit;color:inherit;text-align:inherit;border:1px solid #022d4f;border-radius:5px;padding:6px;margin-bottom:15px;height:40px;width:300px}@media (min-width:460px){.app__email-modal__content .email-modal__email input{height:60px}}.ReactModal__Overlay--after-open{z-index:300!important}.padding-right-15{padding-right:15px}.padding-right-45{padding-right:45px}.push-sides-2{margin-right:2px;margin-left:2px}.push-right-10{margin-right:10px}.push-left-5{margin-left:5px}.push-left-10{margin-left:10px}.push-right-20{padding-right:20px}.push-left-12{padding-left:12px}.push-left-20{margin-left:20px}.push-up-10{margin-top:10px}.push-up-15{margin-top:15px}.push-up-20{margin-top:20px}.push-up-30{margin-top:30px}.push-up-50{margin-top:50px}.push-up-100{margin-top:100px}.push-down-5{margin-bottom:5px}.push-down-10{margin-bottom:10px}.push-down-20{margin-bottom:20px}.push-down-25{margin-bottom:25px}.push-down-30{margin-bottom:30px}.push-down-40{margin-bottom:40px}.push-down-50{margin-bottom:50px}.padding-20{padding:20px}.padding-sides-10{padding:0 10px}.padding-sides-20{padding:0 20px}body,html{height:100%}#app{position:relative;min-height:100%;padding-bottom:600px}@media (min-width:768px){#app{padding-bottom:240px}}body{margin:0;font-size:14px;font-family:Open Sans,sans-serif;font-weight:400;color:#022d4f;background-color:#dbf3f5}@media (min-width:768px){body{font-size:16px}}a,a:focus{color:inherit;text-decoration:none}input,textarea{font-family:Open Sans,sans-serif;color:#022d4f}textarea{resize:none}*{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}ul{margin:0}ul.dashed{list-style-type:none;-webkit-padding-start:10px}ul.dashed>li{margin-bottom:5px}ul.dashed>li:before{content:\"-\";margin-right:5px;font-weight:700}h1,h2,h3,h4,h5,h6{margin:0;font-family:Open Sans,sans-serif;font-weight:400}button{font-size:16px}.text-align-left{text-align:left}.no-margin-bottom{margin-bottom:0!important}.semi-bold{font-weight:600}.bold{font-weight:700}.bordered{border:1px solid #4bc1ca}.pointer{cursor:pointer}.app__dropdown__label,.app__dropdown__label--mobile,.app__editable-input__label,.app__editable-input__label--mobile,.app__goal-item__amount__label,.app__goal-item__amount__label--mobile,.app__multiselect__label,.app__multiselect__label--mobile,.app__selector__label,.app__selector__label--mobile,.label-adjustment{padding-top:3px}.hidden-all{display:none}.italic-bold{font-style:italic;font-weight:600}.hidden-mobile{display:none}@media (min-width:768px){.hidden-mobile{display:inherit}}.hidden-tablet-large{display:none}@media (min-width:1024px){.hidden-tablet-large{display:inherit}}.hidden-medium{display:none}@media (min-width:1200px){.hidden-medium{display:inherit}}.mobile-only{display:inherit}@media (min-width:768px){.mobile-only{display:none}}.separator{display:inline-block;margin:0 auto;border-top:1px solid #4bc1ca;width:90%}@media (min-width:768px){.separator{width:70%}}.under-title{display:inline-block;margin:0 auto;border-top:5px solid #4bc1ca;width:80px}.font-lighter{font-weight:lighter}.inline{display:inline}.inline-block,span.line{display:inline-block}.mobile-line{display:block}@media (min-width:768px){.mobile-line{display:inline}}.position-relative{position:relative}.float-left{float:left}.font-size-20{font-size:20px}.font-size-28{font-size:28px}.green{color:#4282f3}.small-font{font-size:12px}@media (min-width:768px){.small-font{font-size:14px}}.text-align-center{text-align:center}.opacity-layer{width:100%;height:100%;background-color:hsla(0,0%,100%,.8)}@media (min-width:1024px){.opacity-layer{background-color:hsla(0,0%,100%,.75)}}", ""]);
	
	// exports


/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.svg";

/***/ })

});


// WEBPACK FOOTER //
// bundle.js